// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
    ##########################################################################################################################################################
    EzClocker Button UX CSS Classes
    Requires:
        /src/main/webapp/public/styles/common/ez-body.css (for css variables used in this file)
    ##########################################################################################################################################################
*/
:root {
  /* General Button Variables */
  /*
  --ezButtons-font-family: 'Font-Family-ezClocker', 'Roboto', 'Verdana', 'Arial', sans-serif;
  */
  --ezButtons-font-family: 'Roboto', 'Verdana', 'Arial', sans-serif;
  --ezButtons-cursor: pointer;
  /* Link Button Common Variables */
  --ezSmallLinkButton-text-decoration: none;
  --ezSmallLinkButton-font-weight: normal;
  --ezSmallLinkButton-font-style: normal;
  --ezSmallLinkButton-cursor: pointer;
  /* Small Link Button Variables */
  --ezLinkButton-small-font-size: 10pt;
  /* Large Button Variables */
  --ezLargeButtonMaxHeight: 32px;
  --ezLargeButtonMaxWidth: 175px;
  --ezLargeButtonMinWidth: 32px;
  --ezLargeButtonTextTransform: capitalize;
  --ezLargeButtonFontWeight: bold;
  --ezLargeButton-border-radius: 4px;
  /* Navigation Button Variables */
  --ezNavButtonColor: var(--ezOrange);
  --ezNavButtonColorHover: var(--ezClockerOrange);
  --ezNavButtonTextColor: var(--ezBlack);
  --ezNavButtonFontSize: var(--ezFontSize);
  --ezNavButtonFontWeight: var(--ezLargeButtonFontWeight);
  --ezNavButtonMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezNavButtonTextTransform: var(--ezLargeButtonTextTransform);
  --ezNavButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezNavButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezNavButtonRippleEffect: var(--ezWhite);
  --ezNavButton-border-radius: 4px;
  /* Sign-out Button Variables */
  --ezSignOutButtonColor: var(--ezClockerAqua);
  --ezSignOutButtonTextColor: var(--ezWhite);
  --ezSignOutButtonFontSize: var(--ezFontSize);
  --ezSignOutButtonHoverColor: var(--ezDarkAqua);
  --ezSignOutButtonFontWeight: var(--ezLargeButtonFontWeight);
  --ezSignOutButtonTextTransform: var(--ezLargeButtonTextTransform);
  --ezSignOutButtonMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezSignOutButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezSignOutButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezSignOutButtonMinWidth-border-radius: 4px;
  /* Subscription Plan Select Button Variables */
  --ezSelectPlanBtnColor: var(--ezActionGreen);
  --ezSelectPlanBtnTextColor: var(--ezBlack);
  --ezSelectPlanBtnFontSize: var(--ezFontSize);
  --ezSelectPlanBtnHoverColor: var(--ezHoverGreen);
  --ezSelectPlanBtnFontWeight: var(--ezLargeButtonFontWeight);
  --ezSelectPlanTextTransform: var(--ezLargeButtonTextTransform);
  --ezSelectPlanBtnMaxHeight: var(--ezLargeButtonMaxHeight);
  --ezSelectPlanButtonMaxWidth: var(--ezLargeButtonMaxWidth);
  --ezSelectPlanButtonMinWidth: var(--ezLargeButtonMinWidth);
  --ezSelectPlanButton-border-radius: 4px;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Link Buttons
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <a/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Large Link Buttons
    Classes:
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ===================================================================================================================
*/
/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Default Anchor Tag Style
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
a {
  color: var(--ezClockerNavy);
  text-decoration: none;
  font-family: var(--ezButtons-font-family);
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

a:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a:hover:active {
  color: var(--ezDarkNavy);
  font-weight: bold;
  text-decoration: underline;
}

a:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

a:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 * Button acting as a link or anchor
 * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
 */
button.ezLink {
  background-color: transparent;
  color: var(--ezClockerNavy);
  text-decoration: none;
  font-family: var(--ezButtons-font-family);
  font-weight: normal;
  font-style: normal;
  border-color: transparent;
  border-style: none;
  border-width: 0;
  cursor: pointer;
}

button.ezLink:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

button.ezLink:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

button.ezLink:hover:active {
  color: var(--ezDarkNavy);
  font-weight: bold;
  text-decoration: underline;
}

button.ezLink:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

button.ezLink:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink-hidden
        a.ezButtonLink-visible
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink-hidden {
  display: none;
}

a.ezButtonLink-visible {
  display: unset;
}

/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy,
a.ezButtonLink_default-large-navy:enabled,
a.ezButtonLink_default-large-navy:enabled:visited,
a.ez-button-link-large-navy,
a.ez-button-link-large-navy:enabled,
a.ez-button-link-large-navy:enabled:visited,
a.ezLargeNavyLink,
a.ezLargeNavyLink:enabled,
a.ezLargeNavyLink:enabled:visited {
  color: var(--ezClockerNavy);
  font-family: var(--ezButtons-font-family);
  font-weight: normal;
  font-style: normal;
  font-size: 14pt;
  cursor: var(--ezButtons-cursor);
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) a.ezButtonLink_default-large-navy
        (DEPRECATED) a.ez-button-link-large-navy
        (DEPRECATED) a.ezLargeNavyLink
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
        :enabled:visited:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:enabled:hover,
a.ezButtonLink_default-large-navy:enabled:focus:hover,
a.ezButtonLink_default-large-navy:enabled:visited:hover,
a.ez-button-link-large-navy:enabled:hover,
a.ez-button-link-large-navy:enabled:focus:hover,
a.ez-button-link-large-navy:enabled:visited:hover,
a.ezLargeNavyLink:enabled:hover,
a.ezLargeNavyLink:enabled:focus:hover,
a.ezLargeNavyLink:enabled:visited:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:enabled:active,
a.ezButtonLink_default-large-navy:enabled:active:hover,
a.ezButtonLink_default-large-navy:enabled:visited:active,
a.ezButtonLink_default-large-navy:enabled:visited:active:hover,
a.ez-button-link-large-navy:enabled:active,
a.ez-button-link-large-navy:enabled:active:hover,
a.ez-button-link-large-navy:enabled:visited:active,
a.ez-button-link-large-navy:enabled:visited:active:hover,
a.ezLargeNavyLink:enabled:active,
a.ezLargeNavyLink:enabled:active:hover,
a.ezLargeNavyLink:enabled:visited:active,
a.ezLargeNavyLink:enabled:visited:active:hover {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

/* DEPRECATED: ezButtonLink_default-large-navy */
a.ezButtonLink_default-large-navy:disabled,
a.ezButtonLink_default-large-navy:disabled:hover,
a.ez-button-link-large-navy:disabled,
a.ez-button-link-large-navy:disabled:hover,
a.ezLargeNavyLink:disabled,
a.ezLargeNavyLink:disabled:hover {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED a.ezLargeNavyLinkDisabled */
a.ezLargeNavyLinkDisabled,
a.ezLargeNavyLinkDisabled:disabled a.ezLargeNavyLinkDisabled:disabled:hover {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Link Buttons
    Classes:
        a.ezLink-ezClockerNavy
        (DEPRECATED) a.ezNavyLink
    ===================================================================================================================
*/
a.ezLink-ezClockerNavy,
a.ezNavyLink {
  color: var(--ezClockerNavy);
  text-decoration: none;
  font-family: var(--ezButtons-font-family);
  font-size: 12pt;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

a.ezLink-ezClockerNavy:hover,
a.ezNavyLink:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:hover:enabled,
a.ezNavyLink:hover:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:hover:active,
a.ezNavyLink:hover:active {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

a.ezLink-ezClockerNavy:visited,
a.ezNavyLink:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

a.ezLink-ezClockerNavy:disabled,
a.ezNavyLink:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED:  */
a.ezNavyLinkDisabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Link 'Button' Classes
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <a/>
    Name Templates:
        ezButtons-link-{name}-{color}
        ezButtons-link-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Link Buttons
    Classes:
        a.ezButton-link-ezClockerOrange
        a.ezButton-link-ezClockerWhite
        a.ezButton-link-ezClockerHotGreen
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange,
a.ezButton-link-ezClockerOrange:link,
a.ezButton-link-ezClockerOrange:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerOrange);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezBorderOrange);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezclockerOrange:active,
a.ezButton-link-ezclockerOrange:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezClockerOrange-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :active:hover
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange:hover,
a.ezButton-link-ezClockerOrange:visited:hover,
a.ezButton-link-ezClockerOrange:link:hover {
  background-color: var(--ezHoverOrange);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerOrange:disabled,
a.ezButton-link-ezClockerOrange:disabled:active,
a.ezButton-link-ezClockerOrange:disabled:hover,
a.ezButton-link-ezClockerOrange:disabled:visited,
a.ezButton-link-ezClockerOrange:disabled:link {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezOrange);
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite,
a.ezButton-link-ezClockerWhite:link,
a.ezButton-link-ezClockerWhite:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerWhite);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:active,
a.ezButton-link-ezClockerWhite:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezClockerGray-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :active:hover
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:hover,
a.ezButton-link-ezClockerWhite:visited:hover,
a.ezButton-link-ezClockerWhite:link:hover {
  background-color: var(--ezClockerSilver);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerWhite
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerWhite:disabled,
a.ezButton-link-ezClockerWhite:disabled:hover,
a.ezButton-link-ezClockerWhite:disabled:visited,
a.ezButton-link-ezClockerWhite:disabled:link,
a.ezButton-link-ezClockerWhite:disabled:active {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerGray);
  border-color: var(--ezClockerSilver);
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :link
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen,
a.ezButton-link-ezClockerHotGreen:link,
a.ezButton-link-ezClockerHotGreen:visited {
  margin: 0;
  padding: 4px;
  /* Variable --ezClockerOrange defined in ez-body.css */
  background-color: var(--ezClockerHotGreen);
  text-decoration: none;
  /* Variable --ezContentFontColor defined in ez-body.css */
  color: var(--ezContentFontColor);
  /* Variable ezFontFamily defined in ez-body.css */
  font-family: var(--ezFontFamily);
  /* Variable --ezContentFontSize defined in ez-body.css */
  font-size: var(--ezContentFontSize);
  /* Variable --ezContentFontWeigth defined in ez-body.css */
  font-weight: var(--ezContentFontWeigth);
  /* Variable --ezContentFontStyle defined in ez-body.css */
  font-style: var(--ezContentFontStyle);
  /* Variable --ezBorderOrange defined in ez-body.css */
  border-color: var(--ezBorderHotGreen);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :active
        :active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:active,
a.ezButton-link-ezClockerHotGreen:active:hover {
  box-shadow: var(--ezBoxShadow-inset-ezBorderHotGreen-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
        :visited:hove
        :link:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:hover,
a.ezButton-link-ezClockerHotGreen:visited:hover,
a.ezButton-link-ezClockerHotGreen:link:hover {
  background-color: var(--ezHoverHotGreen);
  box-shadow: unset;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-link-ezClockerHotGreen
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
        :disabled:visited
        :disabled:link
        :disabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-link-ezClockerHotGreen:disabled,
a.ezButton-link-ezClockerHotGreen:disabled:hover,
a.ezButton-link-ezClockerHotGreen:disabled:visited,
a.ezButton-link-ezClockerHotGreen:disabled:link,
a.ezButton-link-ezClockerHotGreen:disabled:active {
  background-color: var(--ezHoverHotGreen);
  color: var(--ezBorderHotGreen);
  border-color: var(--ezClockerHotGreen);
  box-shadow: unset;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Small Link Buttons
        a.ezButtonLink_default-small-navy
        (DEPRECATED) a.ezSmallNavyLink
        (DEPRECATED) a.ez-button-link-small-navy
        (DEPRECATED) a.ezSmallNavyLinkDisabled
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Link Button]
|   ezButtonLink_default-small-navy
|   (DEPRECATED) ez-button-link-small-navy
|   (DEPRECATED) ezSmallNavyLink
------------------------------------------------- */
a.ezButtonLink_default-small-navy,
a.ezSmallNavyLink,
a.ez-button-link-small-navy {
  color: var(--ezClockerNavy);
  font-family: var(--ezFontFamily);
  text-decoration: none;
  font-size: 10pt;
  font-weight: normal;
  font-style: normal;
  cursor: pointer;
}

a.ezButtonLink_default-small-navy:hover,
a.ezSmallNavyLink:hover,
a.ez-button-link-small-navy:hover {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:hover:enabled,
a.ezSmallNavyLink:hover:enabled,
a.ez-button-link-small-navy:hover:enabled {
  color: var(--ezHoverNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:hover:active,
a.ezSmallNavyLink:hover:active,
a.ez-button-link-small-navy:hover:active {
  color: var(--ezDarkNavy);
  text-decoration: underline;
}

a.ezButtonLink_default-small-navy:visited,
a.ezSmallNavyLink:visited,
a.ez-button-link-small-navy:visited {
  color: var(--ezClockerNavy);
  text-decoration: none;
}

a.ezButtonLink_default-small-navy:disabled,
a.ezSmallNavyLink:disabled,
a.ez-button-link-small-navy:disabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/* DEPRECATED:  */
a.ezSmallNavyLinkDisabled {
  color: var(--ezClockerGray);
  text-decoration: none;
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Action Link Buttons
    Classes:
        a.ezButtonLink_action-normal-green
        (DEPRECATED) a.ezActionLink
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Link Button]
|   ezButtonLink_action-normal-green
|   (DEPRECATED) ezActionLink
------------------------------------------------- */
a.ezButtonLink_action-normal-green:link,
a.ezActionLink:link {
  margin: 0;
  padding: 8px;
  background-color: var(--ezActionGreen);
  text-decoration: none;
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
  border-radius: 3px;
}

a.ezButtonLink_action-normal-green:hover:enabled,
a.ezActionLink:hover:enabled {
  background-color: var(--ezHoverHotGreen);
}

a.ezButtonLink_action-normal-green:hover:active,
a.ezActionLink:hover:active {
  background-color: var(--ezDarkHotGreen);
}

a.ezButtonLink_action-normal-green:visited,
a.ezActionLink:visited {
  margin: 0;
  padding: 8px;
  text-decoration: none;
  background-color: var(--ezActionGreen);
  font-style: normal;
  color: var(--ezClockerBlack);
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Download Link Buttons
    Classes:
        a.ezButtonLink_download-normal-navy
        (DEPRECATED) a.ezDownloadLink
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:link,
a.ezDownloadLink:link {
  margin: 0;
  padding: 8px;
  background-color: var(--ezClockerNavy);
  text-decoration: none;
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover:enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:hover:enabled,
a.ezDownloadLink:hover:enabled {
  background-color: var(--ezHoverNavy);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:hover:active,
a.ezDownloadLink:hover:active {
  background-color: var(--ezDarkNavy);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButtonLink_download-normal-navy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :visited
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButtonLink_download-normal-navy:visited,
a.ezDownloadLink:visited {
  margin: 0;
  padding: 8px;
  text-decoration: none;
  background-color: var(--ezClockerNavy);
  font-style: normal;
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  cursor: pointer;
}

a.ezButtonLink_download-normal-navy:disabled,
a.ezDownloadLink:disabled {
  background-color: var(--ezLightNavy);
  color: var(--ezClockerSilver);
  border-color: var(--ezLightNavy);
  cursor: default;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Help/More Info Link Buttons
    Classes:
        a.ezButton-what-is-this-link
        a.ezButton-what-is-this-link-margin-top4px
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link {
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: small;
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link:hover {
  text-decoration: underline;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link-margin-top4px
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link-margin-top4px {
  margin-top: 4px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: small;
  text-decoration: none;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link-margin-top4px
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-what-is-this-link-margin-top4px:hover {
  text-decoration: underline;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-show-more-details-link {
  /* top right bottom left */
  padding: 4px 4px 4px 18px;
  background-color: transparent;
  background-size: 10px 10px;
  background-position: 4px center;
  background-repeat: no-repeat;
  background-image: url("/public/images/icons/expand-ezClockerNavy.svg");
  /* --ezClockerNavy from ez-body.css */
  color: var(--ezClockerNavy);
  font-weight: normal;
  /* --ezSmallFontSize from ez-text.css */
  font-size: var(--ezSmallFontSize);
  text-decoration: none;
  border-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        a.ezButton-what-is-this-link
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
a.ezButton-show-more-details-link:hover {
  text-decoration: underline;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Input Buttons
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <input type="button"/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Major Input Buttons
    ===================================================================================================================
*/
/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Input Buttons
| HTML Tags: <input type="button"/>
|-------------------------------------------------
| Template: ezInputButton_{name}-{size}-{color}
|
| Official Classes:
|   ezInputButton_major-normal-orange
|   ezInputButton_action-normal-ezActionGreen
|
| Deprecated Classes:
|   ez-major-button
|   ez-action-button
/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
/*-------------------------------------------------
| [Input Button]
|   ezInputButton_major-normal-orange
|   (DEPRECATED) ez-major-button
------------------------------------------------- */
/* DEPRECATED:  */
input[type=button].ez-major-button,
input[type=button].ezInputButton_major-normal-orange {
  /* ez-major-button style */
  display: inline-block;
  background-color: var(--ezClockerOrange);
  padding: 6px 24px;
  font-family: var(--ezButtons-font-family);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  text-decoration: none;
  border: 1px solid var(--ezClockerBlack);
  cursor: pointer;
  border-radius: 3px;
}

/* DEPRECATED:  */
input[type=button].ez-major-button:hover:enabled,
input[type=button].ezInputButton_major-normal-orange:hover:enabled {
  background-color: #ffcc66;
}

/* DEPRECATED:  */
input[type=button].ez-major-button:hover:active,
input[type=button].ezInputButton_major-normal-orange:hover:active {
  background-color: #ff9933;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Action Input Buttons
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Input Button]
|   ezInputButton_action-normal-ezActionGreen
|   (DEPRECATED) ez-action-button
------------------------------------------------- */
input[type=button].ez-action-button,
input[type=button].ezInputButton_action-normal-ezActionGreen {
  background-color: var(--ezActionGreen);
  border: 1px solid var(--ezActionGreenBorderColor);
  display: inline-block;
  cursor: pointer;
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12px;
  font-weight: bold;
  padding: 6px 24px;
  text-decoration: none;
  border-radius: 3px;
}

input[type=button].ez-action-button:hover:enabled,
input[type=button].ezInputButton_action-normal-ezActionGreen:hover:enabled {
  background-color: var(--ezActionGreenHoverColor);
}

input[type=button].ez-action-button:hover:active,
input[type=button].ezInputButton_action-normal-ezActionGreen:hover:active {
  color: var(--ezActionGreenHoverColor);
  background-color: var(--ezActionGreenBorderColor);
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Edit Input Buttons
    ===================================================================================================================
*/
/* -------------------------------------------------
| [Input Button]
|   ezInputButton_edit-normal-ezClockerOffWhite
|   (DEPRECATED) ez-edit-button
------------------------------------------------- */
input[type=button].ezInputButton_edit-normal-ezClockerOffWhite,
input[type=button].ez-edit-button {
  display: inline-block;
  padding: 4px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12px;
  font-weight: normal;
  text-decoration: none;
  border: 1px solid var(--ezBorderOffWhite);
  cursor: pointer;
  border-radius: 3px;
}

input[type=button].ezInputButton_edit-normal-ezClockerOffWhite:hover:enabled,
input[type=button].ez-edit-button:hover:enabled {
  background-color: var(--ezHoverOffWhite);
}

input[type=button].ezInputButton_edit-normal-ezClockerOffWhite:hover:active,
input[type=button].ez-edit-button:hover:active {
  background-color: var(--ezDarkOffWhite);
}

/*
    ##########################################################################################################################################################
    [Class Section]
    HTML Button Classes
    ##########################################################################################################################################################
    Applies to HTML Tags:
        <button/>
    Name Templates:
        ezButtons-{name}-{color}
        ezButtons-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button,
button:enabled,
button.ezButton-default-ezClockerOrange,
button.ezButton-default-ezClockerOrange:enabled,
button.ezButton,
button.ezButton:enabled,
button.ezButton_default-normal-ezClockerOrange,
button.ezButton_default-normal-ezClockerOrange:enabled {
  padding: 6px 24px;
  margin: 2px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:focus,
button.ezButton-default-ezClockerOrange:enabled:focus,
button.ezButton:enabled:focus,
button.ezButton_default-normal-ezClockerOrange:enabled:focus {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  /* box-shadow: 0 0 1px 1px transparent; */
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:hover,
button:enabled:focus:hover,
button.ezButton-default-ezClockerOrange:enabled:hover,
button.ezButton-default-ezClockerOrange:enabled:focus:hover,
button.ezButton:enabled:hover,
button.ezButton:enabled:focus:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:enabled:active,
button:enabled:active:hover,
button:enabled:focus:active,
button:enabled:focus:active:hover,
button.ezButton-default-normal-ezClockerOrange:enabled:active,
button.ezButton-default-normal-ezClockerOrange:enabled:active:hover,
button.ezButton-default-normal-ezClockerOrange:enabled:focus:active,
button.ezButton-default-normal-ezClockerOrange:enabled:focus:active:hover,
button.ezButton:enabled:active,
button.ezButton:enabled:active:hover,
button.ezButton:enabled:focus:active,
button.ezButton:enabled:focus:active:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:active,
button.ezButton_default-normal-ezClockerOrange:enabled:active:hover,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:active,
button.ezButton_default-normal-ezClockerOrange:enabled:focus:active:hover {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezButton
        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button:disabled,
button:disabled:hover,
button.ezButton-default-normal-ezClockerOrange:disabled,
button.ezButton-default-normal-ezClockerOrange:disabled:hover,
button.ezButton:disabled,
button.ezButton:disabled:hover,
button.ezButton_default-normal-ezClockerOrange:disabled,
button.ezButton_default-normal-ezClockerOrange:disabled:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezClockerOrange);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.disabledButton
        (DEPRECATED) button.ezDisabledButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.disabledButton  */
button.disabledButton,
button.disabledButton:disabled,
button.disabledButton:disabled:hover,
button.ezDisabledButton,
button.ezDisabledButton:disabled,
button.ezDisabledButton:disabled:hover {
  padding: 6px 24px;
  margin: 2px;
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerOrange);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Header Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange,
button.ezButtons-header-ezClockerOrange:enabled,
button.ezHeaderButton,
button.ezHeaderButton:enabled,
button.headerButton,
button.headerButton:enabled {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:focus,
button.ezHeaderButton:enabled:focus,
button.headerButton:enabled:focus {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:hover,
button.ezButtons-header-ezClockerOrange:enabled:focus:hover,
button.headerButton:enabled:hover,
button.headerButton:enabled:focus:hover,
button.ezHeaderButton:enabled:hover,
button.ezHeaderButton:enabled:focus:hover {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:enabled:active,
button.ezButtons-header-ezClockerOrange:enabled:active:hover,
button.ezButtons-header-ezClockerOrange:enabled:focus:active,
button.ezButtons-header-ezClockerOrange:enabled:focus:active:hover,
button.ezHeaderButton:enabled:active,
button.ezHeaderButton:enabled:active:hover,
button.ezHeaderButton:enabled:focus:active,
button.ezHeaderButton:enabled:focus:active:hover,
button.headerButton:enabled:active,
button.headerButton:enabled:active:hover,
button.headerButton:enabled:focus:active,
button.headerButton:enabled:focus:active:hover {
  font-size: 12pt;
  font-weight: bold;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-ezClockerOrange
        (DEPRECATED) button.ezHeaderButton
        (DEPRECATED) button.headerButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-ezClockerOrange:disabled,
button.ezButtons-header-ezClockerOrange:disabled:hover,
button.ezHeaderButton:disabled,
button.ezHeaderButton:disabled:hover,
button.headerButton:disabled,
button.headerButton:disabled:hover {
  font-size: 12pt;
  font-weight: normal;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledHeaderButton
        (DEPRECATED) button.disabledHeaderButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledHeaderButton */
button.ezDisabledHeaderButton,
button.ezDisabledHeaderButton:disabled,
button.ezDisabledHeaderButton:disabled:hover,
button.disabledHeaderButton,
button.disabledHeaderButton:disabled,
button.disabledHeaderButton:disabled:hover {
  font-size: 12pt;
  font-weight: normal;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-header-down-ezClockerOrange
        (DEPRECATED) button.ezHeaderButtonDown
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
        :enabled:hover,
        :enabled:active,
        :enabled:focus,
        :disabled,
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-header-down-ezClockerOrange,
button.ezButtons-header-down-ezClockerOrange:enabled,
button.ezButtons-header-down-ezClockerOrange:enabled:hover,
button.ezButtons-header-down-ezClockerOrange:enabled:active,
button.ezButtons-header-down-ezClockerOrange:enabled:focus,
button.ezHeaderButtonDown,
button.ezHeaderButtonDown:enabled,
button.ezHeaderButtonDown:enabled:hover,
button.ezHeaderButtonDown:enabled:active,
button.ezHeaderButtonDown:enabled:focus,
button.ezHeaderButtonDown:disabled,
button.ezHeaderButtonDown:disabled:hover {
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  color: var(--ezClockerBlack);
  background-color: var(--ezDimOrange);
  border-left-color: var(--ezBorderOrange);
  border-top-color: var(--ezBorderOrange);
  border-right-color: var(--ezOrange);
  border-bottom-color: var(--ezOrange);
}

/*

/*
====================================================================================================================
| [Class Group]
| EzClocker Toggle Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezLargeToggleButton-2col-container
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        all
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-toggle-button-large-2col-container {
  display: grid;
  grid-template-columns: auto auto;
  grid-row-gap: 4px;
  grid-column-gap: 4px;
  justify-content: center;
  align-content: center;
  margin: 10px 10px 0;
  padding: 10px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  border-color: var(--ezClockerGray);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected,
button.ezButtons-toggle-button-large-unselected:enabled {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-toggle-button-large-unselected:enabled:hover,
.ezButtons-toggle-button-large-unselected:enabled:focus:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected:enabled:active,
button.ezButtons-toggle-button-large-unselected:enabled:active:hover,
button.ezButtons-toggle-button-large-unselected:enabled:focus:active,
button.ezButtons-toggle-button-large-unselected:enabled:focus:active:hover {
  background-color: var(--ezHoverNavy);
  color: var(--ezClockerWhite);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  outline-color: var(--ezNavy-alpha-50);
  outline-width: 1px;
  outline-style: auto;
  outline-offset: 2px;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-unselected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-unselected:disabled,
button.ezButtons-toggle-button-large-unselected:disabled:hover {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerGray);
  font-size: 14pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerSilver);
  border-radius: 3px;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-selected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
        :enabled:hover
        :enabled:active,
        :enabled:active:hover
        :enabled:focus
        :enabled:focus:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-selected,
button.ezButtons-toggle-button-large-selected:enabled,
button.ezButtons-toggle-button-large-selected:enabled:hover,
button.ezButtons-toggle-button-large-selected:enabled:active,
button.ezButtons-toggle-button-large-selected:enabled:active:hover,
button.ezButtons-toggle-button-large-selected:enabled:focus,
button.ezButtons-toggle-button-large-selected:enabled:focus:hover,
button.ezButtons-toggle-button-large-selected:enabled:focus:active,
button.ezButtons-toggle-button-large-selected:enabled:focus:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-width: 2px;
  box-shadow: none;
  outline-style: none;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-toggle-button-large-selected
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-toggle-button-large-selected:disabled,
button.ezButtons-toggle-button-large-selected:disabled:hover {
  background-color: var(--ezHoverNavy);
  color: var(--ezBorderNavy);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezClockerNavy);
  box-shadow: none;
  outline-style: none;
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Major Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-major-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow,
.ezButtons-major-mini-ezClockerYellow:enabled,
button.ezMiniMajorButton,
button.ezMiniMajorButton:enabled,
button.miniMajorButton,
button.miniMajorButton:enabled {
  font-size: 8pt;
  font-weight: bold;
  background-color: var(--ezClockerYellow);
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-major-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:enabled:hover,
button.ezButtons-major-mini-ezClockerYellow:enabled:active:hover,
button.ezMiniMajorButton:enabled:hover,
button.ezMiniMajorButton:enabled:active:hover,
button.miniMajorButton:enabled:hover,
button.miniMajorButton:enabled:active:hover {
  background-color: var(--ezLightYellow);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:focus:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:enabled:active,
button.ezButtons-major-mini-ezClockerYellow:enabled:focus:active,
button.ezMiniMajorButton:enabled:active,
button.miniMajorButton:enabled:focus:active {
  background-color: var(--ezLightYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButton-default-normal-ezClockerOrange
        (DEPRECATED) button.ezMiniMajorButton
        (DEPRECATED) button.miniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-major-mini-ezClockerYellow:disabled,
button.ezButtons-major-mini-ezClockerYellow:disabled:hover,
button.ezMiniMajorButton:disabled,
button.ezMiniMajorButton:disabled:hover,
button.miniMajorButton:disabled,
button.miniMajorButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledMiniMajorButton
        (DEPRECATED) button.disabledMiniMajorButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledMiniMajorButton */
button.ezDisabledMiniMajorButton,
button.ezDisabledMiniMajorButton:disabled,
button.ezDisabledMiniMajorButton:disabled:hover,
button.disabledMiniMajorButton:disabled,
button.disabledMiniMajorButton:disabled:hover,
button.disabledMiniMajorButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Mini Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow,
button.ezButtons-default-mini-ezClockerYellow:enabled,
button.ezMiniNormalButton,
button.ezMiniNormalButton:enabled,
button.miniNormalButton,
button.miniNormalButton:enabled {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 8pt;
  font-weight: normal;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:enabled:hover,
button.ezButtons-default-mini-ezClockerYellow:enabled:focus:hover,
button.ezMiniNormalButton:enabled:hover,
button.ezMiniNormalButton:enabled:focus:hover,
button.miniNormalButton:enabled:hover,
button.miniNormalButton:enabled:focus:hover {
  background-color: var(--ezLightYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:enabled:active,
button.ezMiniNormalButton:enabled:active,
button.miniNormalButton:enabled:active {
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-default-mini-ezClockerYellow
        (DEPRECATED) button.ezMiniNormalButton
        (DEPRECATED) button.miniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-default-mini-ezClockerYellow:disabled,
button.ezButtons-default-mini-ezClockerYellow:disabled:hover,
button.ezMiniNormalButton:disabled,
button.ezMiniNormalButton:disabled:hover,
button.miniNormalButton:disabled,
button.miniNormalButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledMiniNormalButton
        (DEPRECATED) button.disabledMiniNormalButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.disabledMiniNormalButton */
button.ezDisabledMiniNormalButton,
button.ezDisabledMiniNormalButton:disabled,
button.ezDisabledMiniNormalButton:disabled:hover,
button.disabledMiniNormalButton,
button.disabledMiniNormalButton:disabled,
button.disabledMiniNormalButton:disabled:hover {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDialogButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDialogButton {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  border-radius: 3px;
}

button.ezDialogButton:hover {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezDialogButton:active {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezDialogButton:disabled {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
}

button.ezDisabledDialogButton {
  padding: 18px;
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
  border-radius: 3px;
}

button.ezWhiteDialogButton {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  border-radius: 3px;
}

button.ezWhiteDialogButton:hover {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
}

button.ezWhiteDialogButton:hover:active,
button.ezWhiteDialogButton:active {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: bold;
  box-shadow: var(--ezBoxShadow-inset-ezclocker-black-50);
}

button.ezWhiteDialogButton:disabled {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
}

button.ezDisabledWhiteDialogButton {
  padding: 18px 24px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerStone);
  vertical-align: middle;
  font-size: 12pt;
  font-weight: normal;
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMajorButton,
button.ezMajorButton:enabled,
button.majorButton,
button.majorButton:enabled {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezMajorButton:enabled:focus,
button.majorButton:enabled:focus {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
}

button.ezMajorButton:enabled:hover,
button.ezMajorButton:enabled:focus:hover,
button.majorButton:enabled:hover,
button.majorButton:enabled:focus:hover {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezMajorButton:enabled:active,
button.ezMajorButton:enabled:active:hover,
button.ezMajorButton:enabled:focus:active,
button.ezMajorButton:enabled:focus:active:hover,
button.majorButton:enabled:active,
button.majorButton:enabled:active:hover,
button.majorButton:enabled:focus:active,
button.majorButton:enabled:focus:active:hover {
  font-weight: bold;
  border-color: var(--ezClockerGray);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  background-color: var(--ezLightYellow);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezMajorButton:disabled,
button.ezMajorButton:disabled:hover,
button.ezMajorButton:disabled:active,
button.majorButton:disabled,
button.majorButton:disabled:hover,
button.majorButton:disabled:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 10pt;
  font-family: var(--ezButtons-font-family);
  border-color: var(--ezDarkYellow);
  cursor: default;
  box-shadow: none;
}

/* DEPRECATED: button.ezDisabledMajorButton */
button.ezDisabledMajorButton,
button.disabledMajorButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 10pt;
  font-family: var(--ezButtons-font-family);
  border-color: var(--ezDarkYellow);
  cursor: default;
  box-shadow: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezNormalButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezNormalButton {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezNormalButton:hover:enabled {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezNormalButton:focus {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
}

button.ezNormalButton:hover,
button.ezNormalButton:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezNormalButton:disabled,
button.ezNormalButton:disabled:hover,
button.ezNormalButton:disabled:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  box-shadow: none;
  cursor: default;
}

button.ezDisabledNormalButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  border-color: var(--ezDarkYellow);
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezNormalButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDefaultNormalButton {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
}

button.ezDefaultNormalButton:hover:enabled {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezDefaultNormalButton:focus {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 12pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
}

button.ezDefaultNormalButton:hover,
button.ezDefaultNormalButton:hover:active {
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 12pt;
  border-color: var(--ezClockerGray);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezDefaultNormalButton:disabled,
button.ezDefaultNormalButton:disabled:hover,
button.ezDefaultNormalButton:disabled:active {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  box-shadow: none;
  cursor: default;
}

button.ezDisabledDefaultNormalButton {
  background-color: var(--ezLightYellow);
  color: var(--ezDarkYellow);
  font-size: 12pt;
  font-weight: normal;
  border-color: var(--ezDarkYellow);
  border-radius: 3px;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezTealMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezTealMajorButton {
  background-color: var(--ezClockerTeal);
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  border-radius: 3px;
}

button.ezTealMajorButton:hover:enabled {
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
  box-shadow: var(--ezTealBoxShadow);
}

button.ezTealMajorButton:focus {
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
}

button.ezTealMajorButton:hover,
button.ezTealMajorButton:hover:active {
  color: var(--ezTealContainerTextColor);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezTealBorder);
  background-color: var(--ezTealHover);
  box-shadow: var(--ezTealInsetBoxShadow);
}

button.ezTealMajorButton:disabled,
button.ezTealMajorButton:disabled:hover,
button.ezTealMajorButton:disabled:active {
  background-color: var(--ezDarkteal);
  color: var(--ezTealContainerDisabledTextColor);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezTealBorder);
  box-shadow: none;
  cursor: default;
}

button.ezTealMajorButtonDisabled {
  background-color: var(--ezDarkteal);
  color: var(--ezTealContainerDisabledTextColor);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezTealBorder);
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWarningMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWarningMajorButton,
button.warningMajorButton {
  font-weight: bold;
  background-color: #CE0F0C;
  border-color: #A60400;
  color: var(--ezClockerWhite);
  border-radius: 3px;
}

button.ezWarningMajorButton:hover:enabled,
button.warningMajorButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
}

button.ezWarningMajorButton:hover:active,
button.warningMajorButton:hover:active {
  color: var(--ezClockerWhite);
  background-color: #BF3330;
}

button.ezWarningMajorButton:disabled,
button.ezWarningMajorButton:disabled:hover,
button.ezWarningMajorButton:disabled:active button.warningMajorButton:disabled button.warningMajorButton:disabled:hover,
button.warningMajorButton:disabled:active {
  color: var(--ezClockerStone);
  background-color: #FFf0f0;
  border-color: var(--ezClockerStone);
  font-weight: normal;
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteMajorButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDeleteMajorButton,
button.ezDeleteMajorButton:enabled,
button.deleteMajorButton,
button.deleteMajorButton:enabled {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteMajorButton:enabled:focus,
button.deleteMajorButton:enabled:focus {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
}

button.ezDeleteMajorButton:enabled:hover,
button.ezDeleteMajorButton:enabled:focus:hover,
button.deleteMajorButton:enabled:hover,
button.deleteMajorButton:enabled:focus:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezDeleteMajorButton:enabled:active,
button.ezDeleteMajorButton:enabled:active:hover,
button.ezDeleteMajorButton:enabled:focus:active,
button.ezDeleteMajorButton:enabled:focus:active:hover,
button.deleteMajorButton:enabled:active,
button.deleteMajorButton:enabled:active:hover,
button.deleteMajorButton:enabled:focus:active,
button.deleteMajorButton:enabled:focus:active:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);
}

button.ezDeleteMajorButton:disabled,
button.ezDeleteMajorButton:disabled:hover,
button.deleteMajorButton:disabled,
button.deleteMajorButton:disabled:hover {
  margin: 0;
  padding: 6px 24px;
  background-color: var(--ezHoverAlertRed);
  color: var(--ezBorderAlertRed);
  font-size: 10pt;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  box-shadow: none;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWarningHeaderButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWarningHeaderButton,
button.warningHeaderButton {
  vertical-align: middle;
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
  background-color: #CE0F0C;
  border-color: #BF3330;
  border-radius: 3px;
}

button.ezWarningHeaderButton:hover:enabled,
button.warningHeaderButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezWarningHeaderButton:focus,
button.warningHeaderButton:focus {
  background-color: var(--ezClockerAlertRed);
}

button.ezWarningHeaderButton:hover:active,
button.warningHeaderButton:hover:active {
  box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);
}

button.ezWarningHeaderButton:disabled,
button.warningHeaderButton:disabled {
  color: #BF3330;
  background-color: var(--ezClockerAlertRed);
  border-color: #BF3330;
  font-weight: normal;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezLargeToolButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezLargeToolButton:hover,
button.ezLargeToolButton:hover:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezHoverNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

button.ezLargeToolButton:active,
button.ezLargeToolButton:hover:active {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: inset 0 0 4px 2px rgba(6, 56, 97, 0.5);
}

button.ezLargeToolButton:disabled {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerSilver);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezLightNavy);
  cursor: default;
}

button.disabledEzLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: #063565;
  color: #0d58a6;
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #0d58a6;
  cursor: default;
  border-radius: 3px;
}

button.ezRedLargeToolButton {
  padding: 2px;
  margin: 1px;
  min-width: 32px;
  min-height: 32px;
  max-height: 32px;
  background-color: #ff7673;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #a60400;
  border-radius: 3px;
}

button.ezRedLargeToolButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
}

button.ezRedLargeToolButton:hover:active {
  background-color: #BF3330;
}

button.ezRedLargeToolButton:disabled {
  background-color: var(--ezClockerOffWhite);
  color: #808080;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/*
====================================================================================================================
| [Class Group]
| EzClocker Tool Buttons
====================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy,
.ezButtons-tool-navy:enabled,
.ezToolButton,
.ezToolButton:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:focus,
.ezToolButton:enabled:focus {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: var(--ezFocusBoxShadowBlack);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:hover,
.ezButtons-tool-navy:enabled:focus:hover,
.ezToolButton:enabled:hover,
.ezToolButton:enabled:focus:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:enabled:active,
.ezButtons-tool-navy:enabled:active:hover,
.ezButtons-tool-navy:enabled:focus:active,
.ezButtons-tool-navy:enabled:focus:active:hover,
.ezToolButton:enabled:active,
.ezToolButton:enabled:active:hover,
.ezToolButton:enabled:focus:active,
.ezToolButton:enabled:focus:active:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy:disabled,
.ezButtons-tool-navy:disabled:hover,
.ezToolButton:disabled,
.ezToolButton:disabled:hover {
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverNavy);
  opacity: 0.5;
  color: var(--ezBorderNavy);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy-large
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large,
.ezButtons-tool-navy-large:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:focus {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:hover,
.ezButtons-tool-navy-large:enabled:focus:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezHoverNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:enabled:active,
.ezButtons-tool-navy-large:enabled:active:hover,
.ezButtons-tool-navy-large:enabled:focus:active,
.ezButtons-tool-navy-large:enabled:focus:active:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerNavy);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-navy
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-navy-large:disabled,
.ezButtons-tool-navy-large:disabled:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezHoverNavy);
  opacity: 0.5;
  color: var(--ezBorderNavy);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: default;
}

.ezButtons-tool-stone-large,
.ezButtons-tool-stone-large:enabled {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerStone);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerStone);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-stone
        (DEPRECATED) .ezToolButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-stone-large:enabled:focus {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerStone);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerStone);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-stone
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-stone-large:enabled:hover,
.ezButtons-tool-stone-large:enabled:focus:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezHoverStone);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderStone);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: unset;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezButtons-tool-stone
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezButtons-tool-stone-large:enabled:active,
.ezButtons-tool-stone-large:enabled:active:hover,
.ezButtons-tool-stone-large:enabled:focus:active,
.ezButtons-tool-stone-large:enabled:focus:active:hover {
  padding: 2px;
  margin: 1px;
  min-width: 38px;
  min-height: 38px;
  max-height: 38px;
  background-color: var(--ezClockerStone);
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 12pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderStone);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: auto;
  outline-width: 1px;
  outline-color: var(--ezNavy-alpha-50);
  box-shadow: var(--ezBoxShadow-inset-ezNavy-50);
  cursor: pointer;
}

button.ezRedToolButton,
button.ezRedToolButton:enabled {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
}

button.ezRedToolButton:enabled:focus {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezRedToolButton:enabled:hover,
button.ezRedToolButton:enabled:focus:hover {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezRedToolButton:enabled:active,
button.ezRedToolButton:enabled:active:hover,
button.ezRedToolButton:enabled:focus:active,
button.ezRedToolButton:enabled:focus:active:hover {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px var(--ezBorderAlertRed-alpha-50);
  outline-width: 0;
}

button.ezRedToolButton:disabled,
button.ezRedToolButton:disabled:hover {
  opacity: 0.5;
  padding: 0;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: var(--ezHoverAlertRed);
  color: var(--ezClockerGray);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerGray);
  cursor: default;
}

button.ezTransparentToolButton {
  opacity: 1;
  padding: 0;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: rgba(255, 255, 255, 0.2);
}

button.ezTransparentToolButton:hover:enabled {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
}

button.ezTransparentToolButton:focus button.ezTransparentToolButton:active {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
  box-shadow: none;
}

button.ezTransparentToolButton:hover:active {
  background-color: transparent;
  color: var(--ezClockerWhite);
  border-color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px rgba(255, 255, 255, 0.5);
}

button.ezTransparentToolButton:hover:disabled,
button.ezTransparentToolButton:active:disabled,
button.ezTransparentToolButton:disabled {
  opacity: 0.5;
  padding: 0;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  background-color: transparent;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: transparent;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButton-hidden-egg
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezButton-hidden-egg {
  padding: 4px;
  margin: 0;
  background-color: transparent;
  min-width: 18px;
  min-height: 18px;
  color: transparent;
  font-size: xx-small;
  vertical-align: middle;
  text-align: center;
  border-style: none;
  cursor: url("/secure/account/hack.cur"), auto;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezEditButton,
button.ezEditButton:enabled,
button.editButton,
button.editButton:enabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerYellow);
  min-width: 75px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerBlack);
  border-radius: 3px;
}

button.ezEditButton:enabled:focus,
button.editButton:enabled:focus {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightYellow);
  min-width: 75px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerBlack);
  border-radius: 3px;
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezEditButton:enabled:hover,
button.ezEditButton:enabled:focus:hover,
button.editButton:enabled:hover,
button.editButton:enabled:focus:hover {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  text-align: center;
  font-size: 10pt;
  vertical-align: middle;
  box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);
}

button.ezEditButton:enabled:active,
button.ezEditButton:enabled:active:hover,
button.ezEditButton:enabled:focus:active,
button.ezEditButton:enabled:focus:active:hover,
button.editButton:enabled:active,
button.editButton:enabled:active:hover,
button.editButton:enabled:focus:active,
button.editButton:enabled:focus:active:hover {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  text-align: center;
  font-size: 10pt;
  vertical-align: middle;
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

button.ezEditButton:disabled,
button.ezEditButton:disabled:hover,
button.ezEditButton:disabled:active,
button.editButton:disabled,
button.editButton:disabled:hover,
button.editButton:disabled:active {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderYellow);
  cursor: default;
}

button.ezDisabledEditButton,
button.disabledEditButton {
  padding: 4px;
  margin: 1px;
  min-width: 75px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderYellow);
  cursor: default;
  border-radius: 3px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSquareEditButton {
  width: 28px;
  height: 28px;
  padding: 4px;
  padding-left: 3px;
  margin: 1px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

button.ezSquareEditButton:hover:enabled {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezSquareEditButton:focus {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

button.ezSquareEditButton:hover:active {
  padding: 4px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezSquareEditButton:disabled {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  cursor: default;
}

button.ezDisabledSquareEditButton {
  padding: 4px;
  background-color: var(--ezLightYellow);
  color: var(--ezBorderYellow);
  font-size: 10pt;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  cursor: default;
}

img.ezSquarEditButtonImg {
  width: 20px;
  height: 20px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-24x24
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-24x24 {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-24x24:hover:enabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-24x24:focus {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
}

button.ezButtons-edit-navy-24x24:hover:active {
  padding: 4px;
  width: 24px;
  height: 24px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-24x24:disabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-24x24-disabled {
  padding: 4px;
  width: 24px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-24x24 {
  padding: 0;
  margin: 0;
  text-align: center;
  vertical-align: center;
  width: 24px;
  height: 24px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-24x48
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-24x48 {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-24x48:hover:enabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-24x48:focus {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  text-align: center;
  vertical-align: middle;
  font-size: 10pt;
}

button.ezButtons-edit-navy-24x48:hover:active {
  padding: 4px;
  width: 48px;
  height: 24px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-24x48:disabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-24x48-disabled {
  padding: 4px;
  width: 48px;
  height: 24px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-24xA {
  padding: 0;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  height: 24px;
  width: auto;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-edit-navy-48x48
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezButtons-edit-navy-48x48 {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezButtons-edit-navy-48x48:hover:enabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);
}

button.ezButtons-edit-navy-48x48:focus {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: middle;
}

button.ezButtons-edit-navy-48x48:hover:active {
  padding: 4px;
  width: 48px;
  height: 48px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);
}

button.ezButtons-edit-navy-48x48:disabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  cursor: default;
}

button.ezButtons-edit-navy-48x48-disabled {
  padding: 4px;
  width: 48px;
  height: 48px;
  background-color: var(--ezLightNavy);
  color: var(--ezBorderNavy);
  font-size: 10pt;
  text-align: center;
  vertical-align: center;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
  cursor: default;
}

img.ezButtons-square-img-48xA {
  padding: 0;
  margin: 0;
  height: 48px;
  width: auto;
  text-align: center;
  vertical-align: center;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ezButtons-delete-button {
  padding: 4px;
  margin: 1px;
  background-color: #ff7673;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: #a60400;
  border-radius: 3px;
}

.ezButtons-delete-button:hover:enabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
}

.ezButtons-delete-button:hover:active {
  padding: 4px;
  margin: 1px;
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  background-color: #BF3330;
}

.ezButtons-delete-button:disabled {
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerOffWhite);
  color: #808080;
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezDeleteEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezDeleteEditButton,
button.ezDeleteEditButton:enabled {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:enabled:focus {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  outline-width: 0;
  box-shadow: var(--ezFocusBoxShadowBlack);
}

button.ezDeleteEditButton:enabled:hover,
button.ezDeleteEditButton:enabled:focus:hover {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:enabled:active,
button.ezDeleteEditButton:enabled:active:hover,
button.ezDeleteEditButton:enabled:focus:active,
button.ezDeleteEditButton:enabled:focus:active:hover {
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezDarkAlertRed);
  color: var(--ezClockerWhite);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
}

button.ezDeleteEditButton:disabled,
button.ezDeleteEditButton:disabled:hover,
button.ezDeleteEditButton:disabled:active {
  opacity: 50%;
  width: 28px;
  height: 28px;
  padding: 4px;
  margin: 1px;
  background-color: var(--ezLightAlertRed);
  color: var(--ezBorderAlertRed);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderAlertRed);
  border-radius: 3px;
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMiniActionButton styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMiniActionButton,
button.miniActionButton {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezMiniActionButton:enabled:hover,
button.miniActionButton:enabled:hover {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezLightSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.3);
}

button.ezMiniActionButton:enabled:focus,
button.miniActionButton:enabled:focus {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezLightSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  outline-color: var(--ezClockerSilver-alpha-50);
}

button.miniActionButton:enabled:active,
button.ezMiniActionButton:enabled:active:hover,
button.miniActionButton:enabled:active:hover {
  opacity: 1;
  padding: 2px;
  margin: 0;
  background-color: var(--ezSilver);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.5);
}

button.ezMiniActionButton:disabled,
button.ezMiniActionButton:disabled:active,
button.ezMiniActionButton:disabled:active:hover,
button.ezMiniActionButton:disabled:hover,
button.miniActionButton:disabled,
button.miniActionButton:disabled:hover,
button.miniActionButton:disabled:active,
button.miniActionButton:disabled:active:hover {
  padding: 2px;
  margin: 0;
  background-color: rgba(224, 224, 224, 0.5);
  color: var(--ezClockerBlack);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
  /*
  padding: 2px;
  margin: 0;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerStone);
  font-size: 10pt;
  font-weight: normal;
  border-color: var(--ezBorderSilver);
  cursor: default;
  */
}

button.ezDisabledMiniActionButton,
button.disabledMiniActionButton {
  opacity: 0.8;
  padding: 2px;
  margin: 0;
  background-color: var(--ezClockerGray);
  color: var(--ezClockerStone);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSilverActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSilverActionButton {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezSilverActionButton:hover,
button.ezSilverActionButton:hover:enabled {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);
  cursor: pointer;
}

button.ezSilverActionButton:focus {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  cursor: pointer;
}

button.ezSilverActionButton:active,
button.ezSilverActionButton:hover:active {
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-weight: bold;
  font-size: 10pt;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);
  cursor: pointer;
}

button.ezSilverActionButton:disabled {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

button.ezDisabledSilverActionButton {
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSilverEditButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSilverEditButton,
button.silverEditButton {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerSilver);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderSilver);
  cursor: pointer;
  border-radius: 3px;
}

button.ezSilverEditButton:focus,
button.ezSilverEditButton:hover:enabled,
button.silverEditButton:hover:enabled {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);
}

button.ezSilverEditButton:active,
button.ezSilverEditButton:active:focus,
button.ezSilverEditButton:hover,
button.ezSilverEditButton:hover:active,
button.ezSilverEditButto:hover:active {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  color: var(--ezClockerBlack);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);
}

button.ezSilverEditButton:disabled,
button.silverEditButton:disabled {
  padding: 2px 4px;
  margin: 0;
  margin-right: 2px;
  background-color: var(--ezClockerOffWhite);
  color: var(--ezBorderSilver);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderSilver);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezMiniDeleteActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezMiniDeleteActionButton,
button.miniDeleteActionButton {
  font-size: 8pt;
  font-weight: bold;
  padding: 2px;
  margin: 0;
  color: var(--ezClockerWhite);
  background-color: #CE0F0C;
  border-color: #A60400;
  cursor: pointer;
  border-radius: 3px;
}

button.ezMiniDeleteActionButton:hover:enabled,
button.miniDeleteActionButton:hover:enabled {
  background-color: var(--ezClockerAlertRed);
  color: var(--ezClockerWhite);
}

button.ezMiniDeleteActionButton:hover:active,
button.miniDeleteActionButton:hover:active {
  background-color: #BF3330;
}

button.ezMiniDeleteActionButton:disabled,
button.miniDeleteActionButtonn:disabled {
  color: var(--ezClockerStone);
  background-color: #FFf0f0;
  border-color: var(--ezClockerStone);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezButtons-quick-help
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
.ui-widget button.ezButtons-quick-help,
.ezButtons-quick-help {
  margin-top: 2px;
  margin-right: 1px;
  margin-bottom: 2px;
  margin-left: 1px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-color: transparent;
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  cursor: pointer;
}

.ui-widget button.ezButtons-quick-help:hover,
.ui-widget button.ezButtons-quick-help:focus,
.ui-widget button.ezButtons-quick-help:focus:hover,
.ui-widget button.ezButtons-quick-help:enabled:hover,
.ezButtons-quick-help:hover,
.ezButtons-quick-help:focus,
.ezButtons-quick-help:focus:hover,
.ezButtons-quick-help:enabled:hover {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezClockerSilver);
  border-style: dashed;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

.ui-widget button.ezButtons-quick-help:active,
.ui-widget button.ezButtons-quick-help:active:hover,
.ezButtons-quick-help:active,
.ezButtons-quick-help:active:hover {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-color: var(--ezClockerGray);
  border-style: dashed;
  border-width: 1px;
  border-radius: 3px;
  box-shadow: unset;
  cursor: pointer;
}

.ui-widget.button.ezButtons-quick-help:disabled,
.ezButtons-quick-help:disabled {
  margin: 4px;
  padding-left: 25px;
  padding-top: 4px;
  padding-right: 4px;
  padding-bottom: 4px;
  opacity: 1;
  background-color: transparent;
  background-image: url("/public/images/icons/info.svg");
  background-position: 4px center;
  background-repeat: no-repeat;
  background-size: 18px;
  color: var(--ezClockerNavy);
  font-weight: normal;
  font-size: 10pt;
  border-style: none;
  cursor: pointer;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Default Action Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen,
button.ezButtons-action-ezActionGreen:enabled,
button.ezActionButton,
button.ezActionButton:enabled,
button.actionButton,
button.actionButton:enabled {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerActionGreen);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezActionGreenBorderColor);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:focus,
button.ezActionButton:enabled:focus,
button.actionButton:enabled:focus {
  outline-color: var(--ezActionGreen-alpha-50);
  outline-style: auto;
  outline-width: 1px;
  outline-offset: 2px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:hover,
button.ezButtons-action-ezActionGreen:enabled:focus:hover,
button.ezActionButton:enabled:hover,
button.ezActionButton:enabled:focus:hover,
button.actionButton:enabled:hover,
button.actionButton:enabled:focus:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezActionGreenHoverColor);
  box-shadow: var(--ezBoxShadow-ezGray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:enabled:active,
button.ezButtons-action-ezActionGreen:enabled:active:hover,
button.ezButtons-action-ezActionGreen:enabled:focus:active,
button.ezButtons-action-ezActionGreen:enabled:focus:active:hover,
button.ezActionButton:enabled:active,
button.ezActionButton:enabled:active:hover,
button.ezActionButton:enabled:focus:active,
button.ezActionButton:enabled:focus:active:hover,
button.actionButton:enabled:active,
button.actionButton:enabled:active:hover,
button.actionButton:enabled:focus:active,
button.actionButton:enabled:focus:active:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezActionGreenHoverColor);
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-80);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezActionGreen
        (DEPRECATED) button.ezActionButton
        (DEPRECATED) button.actionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezActionGreen:disabled,
button.ezButtons-action-ezActionGreen:disabled:hover,
button.ezActionButton:disabled,
button.ezActionButton:disabled:hover,
button.actionButton:disabled,
button.actionButton:disabled:hover {
  background-color: var(--ezActionGreenHoverColor);
  color: var(--ezActionGreenBorderColor);
  font-size: 14pt;
  font-weight: normal;
  border-color: var(--ezActionGreenBorderColor);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        (DEPRECATED) button.ezDisabledActionButton
        (DEPRECATED) button.disabledActionButton
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
/* DEPRECATED: button.ezDisabledActionButton */
button.ezDisabledActionButton,
button.ezDisabledActionButton:disabled,
button.ezDisabledActionButton:disabled:hover,
button.disabledActionButton,
button.disabledActionButton:disabled,
button.disabledActionButton:disabled:hover {
  background-color: var(--ezActionGreenHoverColor);
  color: var(--ezActionGreenBorderColor);
  font-weight: normal;
  border-color: var(--ezActionGreenBorderColor);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow,
button.ezButtons-action-ezClockerYellow:enabled {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerYellow);
  font-size: 14pt;
  font-weight: bold;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:focus {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezHoverYellow);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:hover,
button.ezButtons-action-ezClockerYellow:enabled:focus:hover {
  font-size: 14pt;
  font-weight: bold;
  background-color: var(--ezHoverYellow);
  box-shadow: var(--ezBoxShadow-ezGray-30);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:enabled:active,
button.ezButtons-action-ezClockerYellow:enabled:active:hover,
button.ezButtons-action-ezClockerYellow:enabled:focus:active,
button.ezButtons-action-ezClockerYellow:enabled:focus:active:hover {
  font-size: 14pt;
  font-weight: bold;
  box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        button.ezButtons-action-ezClockerYellow
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
button.ezButtons-action-ezClockerYellow:disabled,
button.ezButtons-action-ezClockerYellow:disabled:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezBorderYellow);
  font-size: 14pt;
  font-weight: normal;
  border-color: var(--ezBorderYellow);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezNavyActionButton {
  padding: 6px 24px;
  margin: 0;
  background-color: var(--ezClockerNavy);
  color: var(--ezNavyContainerTextColor);
  font-weight: bold;
  border-color: var(--ezBorderNavy);
  border-radius: 3px;
}

button.ezNavyActionButton:hover:enabled {
  font-weight: bold;
  background-color: var(--ezHoverNavy);
}

button.ezNavyActionButton:focus {
  font-weight: bold;
  background-color: var(--ezHoverNavy);
}

button.ezNavyActionButton:hover:active {
  font-weight: bold;
  box-shadow: var(--ezNavyInsetShadow);
}

button.ezNavyActionButton:disabled {
  background-color: var(--ezLightNavy);
  border-color: var(--ezClockerNavy);
  font-weight: normal;
  color: var(--ezNavyContainerDisabledTextColor);
  cursor: default;
}

button.ezDisabledNavyActionButton {
  background-color: var(--ezLightNavy);
  border-color: var(--ezBorderNavy);
  font-weight: normal;
  color: var(--ezNavyContainerDisabledTextColor);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezInvisibleButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezInvisibleButtonLink {
  padding: 0;
  margin: 0;
  background-color: transparent;
  color: transparent;
  text-decoration: none;
  border-color: transparent;
  border-style: none;
  cursor: pointer;
}

button.ezInvisibleButtonLink:disabled {
  opacity: 50%;
  background-color: var(--ezClockerGrayRGB);
  cursor: default;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezSuperActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezSuperActionButton,
button.superActionButton {
  margin: 0;
  background-color: var(--ezClockerNavy);
  border-color: var(--ezClockerGray);
  color: var(--ezClockerWhite);
  font-weight: bold;
  font-size: 18pt;
  padding: 6px 24px;
  border-radius: 3px;
}

button.ezSuperActionButton:hover:enabled,
button.superActionButton:hover:enabled {
  background-color: #0d58a6;
}

button.ezSuperActionButton:hover:active,
button.superActionButton:hover:active {
  background-color: #0d58a6;
}

button.ezSuperActionButton:disabled,
button.superActionButton:disabled {
  cursor: default;
  background-color: #5387bd;
  border-color: var(--ezClockerNavy);
  font-weight: normal;
  color: var(--ezClockerNavy);
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWizardNavButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWizardNavButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  font-weight: bold;
  border-radius: 3px;
}

button.ezWizardHiddenNavButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  display: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| ezWizardActionButton Styles
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
button.ezWizardActionButton {
  /* background-color: var(--ezClockerHotGreen); */
  background-color: var(--ezDarkHotGreen);
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  font-weight: bold;
  /* color: var(--ezHotGreenContainerFontColor) */
  color: var(--ezClockerBlack);
  /* border-color: var(--ezBorderHotGreen); */
  border-color: var(--ezBorderHotGreen);
  border-radius: 3px;
}

button.ezWizardHiddenActionButton {
  /* font-family: var(--ezFontFamily); */
  font-family: var(--ezButtons-font-family);
  display: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| DIV Button
| HTML Tags: <div/>
|-------------------------------------------------
| Template: ezDivButton_{name}-{size}-{color}
|
| Official Classes:
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="")
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="UNSELECTED")
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="SELECTED")
|
| Deprecated Classes:
|   ez-navy-left-nav-button (data-state="")
|   ez-navy-left-nav-button (data-state="UNSELECTED")
|   ez-navy-left-nav-button (data-state="SELECTED")
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: normal;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:hover {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:focus {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:enabled:active,
.ez-navy-left-nav-button[data-state=""]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=""]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:active,
.ezDivButton_LeftNavv-normal-ezClockerNavy[data-state=""]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=""]:disabled,
.ez-navy-left-nav-button[data-state=""]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=""]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="UNSELECTED")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="UNSELECTED")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: normal;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:hover {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:focus {
  background-color: var(--ezClockerLightNavy);
  color: var(--ezClockerWhite);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active,
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=UNSELECTED]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=UNSELECTED]:disabled,
.ez-navy-left-nav-button[data-state=UNSELECTED]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=UNSELECTED]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  font-weight: bold;
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state="SELECTED")
|   (DEPRECATED) ez-navy-left-nav-button (data-state="SELECTED")
------------------------------------------------- */
/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED],
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED] {
  padding-left: 8px;
  padding-top: 14px;
  padding-right: 24px;
  padding-bottom: 15px;
  margin: 0;
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:hover,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:focus,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active:focus,
.ez-navy-left-nav-button[data-state=SELECTED]:enabled:active:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active:focus,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:enabled:active:hover {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  border-width: 1px;
  border-style: solid;
  border-right-style: none;
  border-color: var(--ezClockerNavy);
  border-top-right-radius: 0;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 0;
  outline-color: var(--ezClockerBlack);
  outline-width: 0;
  outline-style: groove;
  text-align: left;
  cursor: pointer;
}

/* DEPRECATED: .ez-navy-left-nav-button */
.ez-navy-left-nav-button[data-state=SELECTED]:disabled,
.ez-navy-left-nav-button[data-state=SELECTED]:disabled:hover,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:disabled,
.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=SELECTED]:disabled:hover {
  background-color: var(--ezClockerWhite);
  color: var(--ezClockerGray);
  font-weight: bold;
  cursor: default;
}

/* -------------------------------------------------
| [DIV Button]
|   ezDivButton_Menu-normal-ezClockerOrange
|   (DEPRECATED) div.ezMenuButton
------------------------------------------------- */
/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton,
.ezDivButton_Menu-normal-ezClockerOrange {
  background-color: var(--ezClockerOrange);
  font-family: var(--ezButtons-font-family);
  color: var(--ezClockerWhite);
  border-style: solid;
  border-color: var(--ezBorderOrange);
  border-width: 1px;
  border-radius: 3px;
}

/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton:hover:enabled,
.ezDivButton_Menu-normal-ezClockerOrange:hover:enabled {
  background-color: var(--ezHoverOrange);
}

/* DEPRECATED: div.ezMenuButton */
div.ezMenuButton:hover:active,
.ezDivButton_Menu-normal-ezClockerOrange:hover:active {
  border-width: 1px;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Button Content
| HTML Tags: <div/>,<label/>,<span/>
|-------------------------------------------------
| Template: ezButtonContent_{name}-{size}-{color}
|
| Official Classes:
|   ezButtonContent_SubLabel-normal-black
|
| Deprecated Classes:
|   ezButtonSubLabel
|   buttonSubLabel
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: label.ezButtonSubLabel */
label.ezButtonSubLabel,
label.buttonSubLabel {
  font-weight: normal;
}

.ezButtonContent_SubLabel-normal-black {
  color: var(--ezClockerBlack);
  font-size: 12px;
  font-weight: normal;
}

label.ezEditButtonLabel,
.ezButtonContent_EditLabel-small-black {
  padding-left: 4px;
  padding-right: 2px;
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 10pt;
  cursor: pointer;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Button Images
| HTML Tags: <img/>
|-------------------------------------------------
| Template: ezButtonImage_{size}
|
| Official Classes:
|   ezButtonImage_16x16
|   ezButtonImage_24x24
|   ezBtnImage_24xA
|
| Deprecated Classes:
|   ezEditButtonImage
|   ezLargeEditButtonImage
|   ezMiniButtonImg
|   miniButtonIcon
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: img.ezEditButtonImage */
img.ezEditButtonImage,
img.ezButtonImage_16x16 {
  margin: 0;
  padding: 0;
  height: 16px;
  width: 16px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezButtonImage-disable_16x16 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 16px;
  width: 16px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage_18x18 {
  margin: 0;
  padding: 0;
  height: 18px;
  width: 18px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage-disable_18x18 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 18px;
  width: 18px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage_20x20 {
  margin: 0;
  padding: 0;
  height: 20px;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezEditButtonImage-disable_20x20 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 20px;
  width: 20px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

/* DEPRECATED: img.ezLargeEditButtonImage */
img.ezLargeEditButtonImage,
img.ezButtonImage_24x24 {
  margin: 0;
  padding: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezButtonImage-disable_24x24 {
  opacity: 0.5;
  margin: 0;
  padding: 0;
  height: 24px;
  width: 24px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
}

img.ezMiniButtonImg,
img.miniButtonIcon,
img.ezBtnImage_24xA {
  box-sizing: border-box;
  padding-right: 4px;
  width: 24px;
  vertical-align: middle;
  border-style: none;
}

/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
| Select Button
| HTML Tags: <select/>
|-------------------------------------------------
| Template: ezSelectButton_{name}-{size}-{color}
|
| Official Classes:
|   ezSelectButton_Default-normal-ezClockerOrange
|
| Deprecated Classes:
|   ezMajorSelectButton
~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton,
select.ezSelectButton_Default-normal-ezClockerYellow {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezClockerGray);
  border-radius: 3px;
  /*
  margin: 2px;
  padding: 6px 24px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 10pt;
  font-weight: bold;
  border-color: var(--ezBorderYellow);
  border-radius: 3px;
  border-style: solid;
  border-width: 1px;
  outline-width: 0;
  cursor: pointer;
  */
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:hover:enabled,
select.ezSelectButton_Default-normal-ezClockerOrange:hover:enabled {
  background-color: var(--ezLightYellow);
  box-shadow: var(--ezBoxShadowStone);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:hover:active,
select.ezSelectButton_Default-normal-ezClockerOrange:hover:active {
  box-shadow: var(--ezBoxShadowDarkYellow);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:disabled,
select.ezSelectButton_Default-normal-ezClockerOrange:disabled {
  background-color: var(--ezExtraLightYellow);
  color: var(--ezDarkYellow);
  border-color: var(--ezDarkYellow);
}

/* DEPRECATED: select.ezMajorSelectButton */
select.ezMajorSelectButton:focus,
select.ezSelectButton_Default-normal-ezClockerOrange:focus {
  box-shadow: var(--ezFocusBoxShadowBlack);
}

/*
    ##########################################################################################################################################################
    [Class Section]
    Select/Drop Down/Menu Buttons
    ##########################################################################################################################################################
    Name Templates:
        ezSelectButton-{name}-{color}
        ezSelectButton-{name}-{other-properties}-color}
        ezDropDownButton-{name}-{color}
        ezDropDownButton-{name}-{other-properties}-color}
        ezMenuButton-{name}-{color}
        ezMenuButton-{name}-{other-properties}-color}
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    EzClocker Select Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange,
select.ezSelectButton-default-ezClockerOrange:enabled {
  padding: 5px 24px;
  margin: 2px;
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 10pt;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezBorderYellow);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
  height: 29px;
  width: 161px;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Focus]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:focus {
  background-color: var(--ezHoverYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent;
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class State Definition: Enabled Hover and Active Hover]:
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:hover,
select.ezSelectButton-default-ezClockerOrange:enabled:focus:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:enabled:active,
select.ezSelectButton-default-ezClockerOrangeenabled:active:hover,
select.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active,
select.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active:hover {
  background-color: var(--ezClockerYellow);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezBorderYellow);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-default-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-default-ezClockerOrange:disabled,
select.ezSelectButton-default-ezClockerOrange:disabled:hover {
  background-color: var(--ezHoverYellow);
  color: var(--ezBorderYellow);
  border-color: var(--ezClockerYellow);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        select.ezSelectButton-header-ezClockerOrange
        (DEPRECATED) select.ezSelectButton-major-ezClockerOrange
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
select.ezSelectButton-header-ezClockerOrange,
select.ezSelectButton-header-ezClockerOrange:enabled,
select.ezSelectButton-major-ezClockerOrange,
select.ezSelectButton-major-ezClockerOrange:enabled {
  padding: 4px;
  margin: 2px;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtonFontFamily);
  font-size: 12pt;
  font-weight: bold;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderOrange);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-width: 0;
  cursor: pointer;
}

select.ezSelectButton-header-ezClockerOrange:hover:enabled,
select.ezSelectButton-major-ezClockerOrange:hover:enabled {
  background-color: var(--ezLightOrange);
  box-shadow: var(--ezBoxShadowStone);
}

select.ezSelectButton-header-ezClockerOrange:hover:active,
select.ezSelectButton-major-ezClockerOrange:hover:active {
  box-shadow: var(--ezBoxShadowDarkOrnage);
}

select.ezSelectButton-header-ezClockerOrange:focus,
select.ezSelectButton-major-ezClockerOrange:focus {
  box-shadow: var(--ezFocusBoxShadowBlack);
}

select.ezSelectButton-header-ezClockerOrange:disabled,
select.ezSelectButton-major-ezClockerOrange:disabled {
  background-color: var(--ezLightOrange);
  color: var(--ezDarkOrange);
  border-color: var(--ezDarkOrange);
  font-weight: normal;
}

option.ezSelectButton-option-title,
option.ezSelectButton-option-title:hover,
option.ezSelectButton-option-title:active,
option.ezSelectButton-option-title:disabled,
option.ezSelectButton-option-title:focus {
  background-color: var(--ezClockerNavy);
  color: var(--ezClockerWhite);
  font-size: 12pt;
  font-weight: bold;
  text-align: center;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: default;
}

option.ezSelectButton-option {
  font-size: 12pt;
  text-align: left;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: pointer;
}

option.ezSelectButton-option:hover option.ezSelectButton-option:focus option.ezSelectButton-option:active {
  background-color: var(--ezClockerStone);
  font-weight: bold;
  cursor: pointer;
}

option.ezSelectButton-option:disabled {
  color: var(--ezClockerStone);
  font-size: 12pt;
  font-weight: normal;
  text-align: left;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  cursor: default;
}

/* -------------------------------------------------------------------
| Large Tablet Screen Styles (https://yesviz.com/laptops.php)
------------------------------------------------------------------- */
/*
@media screen and (max-width: 1023px) {

}
*/
/* -------------------------------------------------------------------
| Small Tablet Screen Styles (https://yesviz.com/tablets.php)
------------------------------------------------------------------- */
/*
@media screen and (max-width: 768px) {

}
*/
/* -------------------------------------------------------------------
| Phone Screen Styles  (https://yesviz.com/mobiles.php)
------------------------------------------------------------------- */
@media screen and (max-width: 480px) {
  /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  | ezDialogButton Styles
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  button.ezDialogButton {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezDialogButton:hover {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:active {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:disabled {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledDialogButton {
    padding: 10px 18px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezWhiteDialogButton {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton:hover {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezWhiteDialogButton:hover:active,
  button.ezWhiteDialogButton:active {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);
  }
  button.ezWhiteDialogButton:disabled {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledWhiteDialogButton {
    padding: 10px 18px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
}
/* -------------------------------------------------------------------
| Wearable Screen Style  (https://yesviz.com/watches.php)
------------------------------------------------------------------- */
@media screen and (max-width: 319px) {
  /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  | ezDialogButton Styles
  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */
  button.ezDialogButton {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezDialogButton:hover {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:active {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezDialogButton:disabled {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledDialogButton {
    padding: 4px 10px;
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    border-radius: 3px;
  }
  button.ezWhiteDialogButton:hover {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
  }
  button.ezWhiteDialogButton:hover:active,
  button.ezWhiteDialogButton:active {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerBlack);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: bold;
    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);
  }
  button.ezWhiteDialogButton:disabled {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
  }
  button.ezDisabledWhiteDialogButton {
    padding: 4px 10px;
    background-color: var(--ezClockerWhite);
    color: var(--ezClockerStone);
    vertical-align: middle;
    font-size: 12pt;
    font-weight: normal;
    border-radius: 3px;
  }
}
.ezFullWidthButton {
  width: 100%;
}

/*
    ===================================================================================================================
    [Class Group]
    EzClocker Tab Link Buttons
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ezTabLink-ezClockerNavy
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none (Active)
        :hover (Inactive Hover)
        :disabled (Inactive)
        :active (Active Mouse Down/Click)
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ezTabLink-ezClockerNavy {
  color: var(--ezClockerNavy);
  font-weight: bold;
  text-decoration: none;
  cursor: pointer;
  padding: 8px 16px;
  margin-right: 8px;
  display: inline-block;
  border-bottom: 2px solid var(--ezClockerNavy);
}

.ezTabLink-ezClockerNavy:hover {
  color: var(--ezClockerNavy);
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
}

.ezTabLink-ezClockerNavy:disabled {
  color: var(--ezClockerDarkGray);
  font-weight: normal;
  text-decoration: none;
  cursor: default;
  border-bottom: 2px solid transparent;
}

.ezTabLink-ezClockerNavy:active {
  color: var(--ezClockerNavy);
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
}

.ezTabLink-ezClockerNavy-inactive {
  color: var(--ezClockerDarkGray);
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
  padding: 8px 16px;
  margin-right: 8px;
  display: inline-block;
  border-bottom: 2px solid transparent;
}

.ezTabLink-ezClockerNavy-inactive:hover {
  color: var(--ezClockerNavy);
  font-weight: normal;
  text-decoration: none;
  cursor: pointer;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    JQuery Button Style Overrides
    ##########################################################################################################################################################
*/
/*
    ===================================================================================================================
    [Class Group]
    JQuery Style Overrides
    ===================================================================================================================
*/
/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon,
.ui-icon:enabled,
.ui-button .ui-icon,
.ui-button .ui-icon:enabled {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:focus,
.ui-button .ui-icon:enabled:focus {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:hover,
.ui-icon:enabled:focus:hover,
.ui-button .ui-icon:enabled:hover,
.ui-button .ui-icon:enabled:focus:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:enabled:active,
.ui-icon:enabled:active:hover,
.ui-icon:enabled:focus:active,
.ui-icon:enabled:focus:active:hover,
.ui-button .ui-icon:enabled:active,
.ui-button .ui-icon:enabled:active:hover,
.ui-button .ui-icon:enabled:focus:active,
.ui-button .ui-icon:enabled:focus:active:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-icon
        .ui-button .ui-icon
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-icon:disabled,
.ui-icon:disabled:hover,
.ui-button .ui-icon:disabled,
.ui-button .ui-icon:disabled:hover {
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        none
        :enabled
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button,
.ui-button:enabled {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  font-family: var(--ezButtons-font-family);
  font-size: 12pt;
  font-weight: normal;
  text-align: center;
  vertical-align: middle;
  border-color: var(--ezClockerGray);
  border-width: 1px;
  border-style: solid;
  border-radius: 3px;
  box-shadow: 0 0 1px 1px transparent;
  outline-style: none;
  cursor: pointer;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:focus
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:focus {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent;
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :enabled:hover
        :enabled:focus:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:hover,
.ui-button:enabled:focus:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:enabled:active,
.ui-button:enabled:active:hover,
.ui-button:enabled:focus:active,
.ui-button:enabled:focus:active:hover {
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  box-shadow: 0 0 1px 1px transparent, inset 0 0 4px 2px rgba(198, 118, 0, 0.5);
  outline-color: var(--ezClockerGray);
  outline-width: 0;
  outline-style: groove;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-button
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Defined states:
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button:disabled,
.ui-button:disabled:hover {
  background-color: var(--ezHoverOrange);
  color: var(--ezBorderOrange);
  border-color: var(--ezClockerOrange);
  cursor: default;
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-state-active .ui-icon,
        .ui-button .ui-icon,
        .ui-button:enabled .ui-icon:enabled,
        .ui-button:enabled:active .ui-icon:enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        none
        :enabled
        :enabled:active
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-button .ui-icon,
.ui-button:enabled .ui-icon:enabled,
.ui-button:enabled:active .ui-icon:enabled:active,
.ui-state-active .ui-icon {
  /* Using black icons only */
  background-image: url("/jquery-ui/images/ui-icons_000000_256x240.png");
}

/*
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    [Class Definition]
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    Classes:
        .ui-dialog-titlebar-close
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    States:
        none
        :enabled
        :enabled:focus
        :enabled:hover
        :enabled:focus:hover
        :enabled:active
        :enabled:active:hover
        :enabled:focus:active
        :enabled:focus:active:hover
        :disabled
        :disabled:hover
    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
*/
.ui-dialog-titlebar-close,
.ui-dialog-titlebar-close:enabled,
.ui-dialog-titlebar-close:enabled:focus,
.ui-dialog-titlebar-close:enabled:hover,
.ui-dialog-titlebar-close:enabled:focus:hover,
.ui-dialog-titlebar-close:enabled:active,
.ui-dialog-titlebar-close:enabled:active:hover,
.ui-dialog-titlebar-close:enabled:focus:active,
.ui-dialog-titlebar-close:enabled:focus:active:hover,
.ui-dialog-titlebar-close:disabled,
.ui-dialog-titlebar-close:disabled:hover {
  /* Hide all JQuery UI dialog's top right X butons */
  display: none;
}

/*
    ##########################################################################################################################################################
    [Class Section]
    DEPRECATED STYLES
    DO NOT USE CLASS IN THIS SECTION
    ##########################################################################################################################################################
*/
/* @DEPRECATED: a.navButton */
a.navButton {
  font-size: medium;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--ezActionGreenBorderColor);
  background-color: #8ef13c;
  color: var(--ezClockerBlack);
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 3px;
}

/* @DEPRECATED: a.navButton */
a.navButton:hover:enabled {
  /* DEPRECATED: DO NOT USE */
  border-top-color: var(--ezActionGreenHoverColor);
  border-left-color: var(--ezActionGreenHoverColor);
  border-bottom-color: #66cc99;
  border-right-color: #66cc99;
  background-color: #a9f16c;
}

/* @DEPRECATED: a.navButton */
a.navButton:hover:active {
  border-top-color: #66cc99;
  border-left-color: #66cc99;
  border-bottom-color: var(--ezActionGreenHoverColor);
  border-right-color: var(--ezActionGreenHoverColor);
  color: #a9f16c;
  background-color: var(--ezActionGreenBorderColor);
}

/* @DEPRECATED: a.toolButton */
a.toolButton {
  font-size: small;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: #996600;
  background-color: var(--ezClockerOrange);
  color: var(--ezClockerBlack);
  cursor: pointer;
  padding: 2px 4px;
  border-radius: 3px;
}

/* @DEPRECATED: a.toolButton */
a.toolButton:hover:enabled {
  border-top-color: #ffee00;
  border-left-color: #ffee00;
  border-bottom-color: #ff9933;
  border-right-color: #ff9933;
  background-color: #ffcc66;
}

/* @DEPRECATED: a.toolButton */
a.toolButton:hover:active {
  border-top-color: #ff9933;
  border-left-color: #ff9933;
  border-bottom-color: #ffee00;
  border-right-color: #ffee00;
  background-color: #ffcc66;
}

/* @DEPRECATED: a.disabledToolButton */
a.disabledToolButton {
  font-size: small;
  font-weight: normal;
  margin: 2px;
  border-style: solid;
  border-width: 1px;
  border-color: #808080;
  background-color: var(--ezClockerStone);
  color: #808080;
  cursor: default;
  padding: 2px 4px;
  border-radius: 3px;
}

/* @DEPRECATED: .buttonText */
.buttonText {
  font-size: 12pt;
  font-family: verdana, sans-serif;
  font-weight: normal;
}

/* @DEPRECATED: .headerButtonText */
.headerButtonText {
  font-size: 12pt;
  font-family: verdana, sans-serif;
  font-weight: bold;
}

/* @DEPRECATED: button.ezNoButtonMargin */
button.ezNoButtonMargin {
  margin: 0;
}

/* @DEPRECATED: button.fullWidth */
button.fullWidth {
  width: 100%;
}

/* @DEPRECATED: button.paddButton10 */
button.paddButton10 {
  margin-left: 10px;
}

button.ezToolButtonWhite,
button.ezToolButtonWhite:active,
button.ezToolButtonWhite:enabled button.ezToolButtonWhite:focus,
button.ezToolButtonWhite:enabled:focus,
button.ezToolButtonWhite:hover:enabled {
  background-color: var(--ezClockerWhite);
  padding: 2px;
  margin: 1px;
  min-width: 28px;
  min-height: 28px;
  max-height: 28px;
  opacity: 1;
  color: var(--ezNavyContainerTextColor);
  font-size: 10pt;
  vertical-align: middle;
  text-align: center;
  border-color: var(--ezBorderNavy);
  border-style: solid;
  border-width: 1px;
  border-radius: 3px;
  outline-style: none;
  box-shadow: unset;
  cursor: pointer;
}

button.ezAddTimeButton {
  font-weight: bold;
  background-color: #ffc500;
  border-color: #6d6e70;
  border-style: solid;
  border-width: 1px;
  color: #000000;
  height: 45px;
  width: 130px;
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button {
  font-family: var(--ezFontFamily);
  max-height: var(--ezNavButtonMaxHeight);
  max-width: var(--ezNavButtonMaxWidth);
  min-width: var(--ezNavButtonMinWidth);
  font-size: var(--ezNavButtonFontSize);
  font-weight: var(--ezNavButtonFontWeight);
  background-color: var(--ezNavButtonColor);
  color: var(--ezNavButtonTextColor);
  text-transform: var(--ezNavButtonTextTransform);
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button > paper-ripple {
  color: var(--ezWhite);
}

/* @DEPRECATED: paper-button.ez-navigation-button */
paper-button.ez-navigation-button:hover:enabled {
  background-color: var(--ezNavButtonColorHover);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button {
  text-transform: var(--ezSignOutButtonTextTransform);
  max-height: var(--ezSignOutButtonMaxHeight);
  max-width: var(--ezSignOutButtonMaxWidth);
  min-width: var(--ezSignOutButtonMinWidth);
  font-size: var(--ezSignOutButtonFontSize);
  font-weight: var(--ezSignOutButtonFontWeight);
  background-color: var(--ezSignOutButtonColor);
  color: var(--ezSignOutButtonTextColor);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button > paper-ripple {
  color: var(--ezWhite);
}

/* @DEPRECATED: ez-signout-button */
paper-button.ez-signout-button:hover:enabled {
  background-color: var(--ezSignOutButtonHoverColor);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button {
  max-width: var(--ezSelectPlanButtonMaxWidth);
  min-width: var(--ezSelectPlanButtonMinWidth);
  max-height: var(--ezSelectPlanBtnMaxHeight);
  font-size: var(--ezSelectPlanBtnFontSize);
  font-weight: var(ezSelectPlanBtnFontWeight);
  background-color: var(--ezSelectPlanBtnColor);
  color: var(--ezSelectPlanBtnTextColor);
  text-transform: var(--ezSelectPlanTextTransform);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button > paper-ripple {
  color: var(--ezBorderGreen);
}

/* @DEPRECATED: paper-button.ez-select-plan-button */
paper-button.ez-select-plan-button:hover:enabled {
  background-color: var(--ezSelectPlanBtnHoverColor);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
}

/*
    ##########################################################################################################################################################
    END OF DEPRECATED CLASS SECTION
    ##########################################################################################################################################################
*/`, "",{"version":3,"sources":["webpack://./public/styles/common/ez-buttons.css"],"names":[],"mappings":"AAAA;;;;;;CAAA;AAQA;EACI,6BAAA;EACA;;GAAA;EAGA,iEAAA;EACA,2BAAA;EAEA,iCAAA;EACA,yCAAA;EACA,uCAAA;EACA,sCAAA;EACA,mCAAA;EAEA,gCAAA;EACA,oCAAA;EAEA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,6BAAA;EACA,wCAAA;EACA,+BAAA;EACA,kCAAA;EAEA,gCAAA;EACA,mCAAA;EACA,+CAAA;EACA,sCAAA;EACA,wCAAA;EACA,uDAAA;EACA,qDAAA;EACA,6DAAA;EACA,mDAAA;EACA,mDAAA;EACA,yCAAA;EACA,gCAAA;EAEA,8BAAA;EACA,4CAAA;EACA,0CAAA;EACA,4CAAA;EACA,8CAAA;EACA,2DAAA;EACA,iEAAA;EACA,yDAAA;EACA,uDAAA;EACA,uDAAA;EACA,4CAAA;EAEA,8CAAA;EACA,4CAAA;EACA,0CAAA;EACA,4CAAA;EACA,gDAAA;EACA,2DAAA;EACA,8DAAA;EACA,yDAAA;EACA,0DAAA;EACA,0DAAA;EACA,uCAAA;AANJ;;AASA;;;;;;;;;;;CAAA;AAaA;;;;;;;;;CAAA;AAYA;;;;EAAA;AAKA;EACI,2BAAA;EACA,qBAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AATJ;;AAYA;EACI,yBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,yBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,wBAAA;EACA,iBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,2BAAA;EACA,qBAAA;AATJ;;AAYA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AATJ;;AAYA;;;;EAAA;AAKA;EACI,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AATJ;;AAYA;EACI,yBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,yBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,wBAAA;EACA,iBAAA;EACA,0BAAA;AATJ;;AAYA;EACI,2BAAA;EACA,qBAAA;AATJ;;AAYA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AATJ;;AAYA;;;;;;;;;;;;;;;CAAA;AAgBA;EACI,aAAA;AATJ;;AAYA;EACI,cAAA;AATJ;;AAYA,gDAAA;AACA;;;;;;;;;EAWI,2BAAA;EACA,yCAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,+BAAA;EACA,qBAAA;AAXJ;;AAcA;;;;;;;;;;;;;;CAAA;AAeA,gDAAA;AACA;;;;;;;;;EAWI,yBAAA;EACA,0BAAA;AAbJ;;AAgBA,gDAAA;AACA;;;;;;;;;;;;EAcI,wBAAA;EACA,0BAAA;AAfJ;;AAkBA,gDAAA;AACA;;;;;;EAQI,2BAAA;EACA,qBAAA;EACA,eAAA;AAjBJ;;AAoBA,yCAAA;AACA;;EAEI,2BAAA;EACA,qBAAA;EACA,eAAA;AAjBJ;;AAoBA;;;;;;;;CAAA;AAUA;;EAGI,2BAAA;EACA,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAnBJ;;AAsBA;;EAGI,yBAAA;EACA,0BAAA;AApBJ;;AAuBA;;EAGI,yBAAA;EACA,0BAAA;AArBJ;;AAwBA;;EAGI,wBAAA;EACA,0BAAA;AAtBJ;;AAyBA;;EAGI,2BAAA;EACA,qBAAA;AAvBJ;;AA0BA;;EAGI,2BAAA;EACA,qBAAA;EACA,eAAA;AAxBJ;;AA2BA,iBAAA;AACA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AAxBJ;;AA4BA;;;;;;;;;;;CAAA;AAaA;;;;;;;;;CAAA;AAWA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,wCAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA8BA;;;;;;;;;;;CAAA;AAYA;;EAEI,uDAAA;AA3BJ;;AA8BA;;;;;;;;;;;;;CAAA;AAcA;;;EAGI,sCAAA;EACA,iBAAA;AA3BJ;;AA8BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,sCAAA;EACA,4BAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA8BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,uCAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA8BA;;;;;;;;;;;CAAA;AAYA;;EAEI,qDAAA;AA3BJ;;AA8BA;;;;;;;;;;;;;CAAA;AAcA;;;EAGI,wCAAA;EACA,iBAAA;AA3BJ;;AA8BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,wCAAA;EACA,2BAAA;EACA,oCAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA8BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,SAAA;EACA,YAAA;EACA,sDAAA;EACA,0CAAA;EACA,qBAAA;EACA,yDAAA;EACA,gCAAA;EACA,iDAAA;EACA,gCAAA;EACA,wDAAA;EACA,mCAAA;EACA,0DAAA;EACA,uCAAA;EACA,yDAAA;EACA,qCAAA;EACA,qDAAA;EACA,qCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA8BA;;;;;;;;;;;CAAA;AAYA;;EAEI,wDAAA;AA3BJ;;AA8BA;;;;;;;;;;;;CAAA;AAaA;;;EAGI,wCAAA;EACA,iBAAA;AA3BJ;;AA8BA;;;;;;;;;;;;;;CAAA;AAeA;;;;;EAKI,wCAAA;EACA,8BAAA;EACA,sCAAA;EACA,iBAAA;EACA,eAAA;AA3BJ;;AA+BA;;;;;;;;;CAAA;AAWA;;;;;mDAAA;AAMA;;;EAKI,2BAAA;EACA,gCAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AA/BJ;;AAkCA;;;EAKI,yBAAA;EACA,0BAAA;AAjCJ;;AAoCA;;;EAKI,yBAAA;EACA,0BAAA;AAnCJ;;AAsCA;;;EAKI,wBAAA;EACA,0BAAA;AArCJ;;AAwCA;;;EAKI,2BAAA;EACA,qBAAA;AAvCJ;;AA0CA;;;EAKI,2BAAA;EACA,qBAAA;EACA,eAAA;AAzCJ;;AA4CA,iBAAA;AACA;EACI,2BAAA;EACA,qBAAA;EACA,eAAA;AAzCJ;;AA4CA;;;;;;;;CAAA;AAUA;;;;mDAAA;AAKA;;EAGI,SAAA;EACA,YAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;AA3CJ;;AA8CA;;EAGI,wCAAA;AA5CJ;;AA+CA;;EAGI,uCAAA;AA7CJ;;AAgDA;;EAGI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA9CJ;;AAiDA;;;;;;;;CAAA;AAUA;;;;;;;;;;CAAA;AAWA;;EAGI,SAAA;EACA,YAAA;EACA,sCAAA;EACA,qBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAhDJ;;AAmDA;;;;;;;;;;CAAA;AAWA;;EAGI,oCAAA;AAjDJ;;AAoDA;;;;;;;;;;CAAA;AAWA;;EAGI,mCAAA;AAlDJ;;AAqDA;;;;;;;;;;CAAA;AAWA;;EAGI,SAAA;EACA,YAAA;EACA,qBAAA;EACA,sCAAA;EACA,kBAAA;EACA,4BAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAnDJ;;AAsDA;;EAGI,oCAAA;EACA,6BAAA;EACA,gCAAA;EACA,eAAA;AApDJ;;AAuDA;;;;;;;;CAAA;AAUA;;;;;;;;;;CAAA;AAWA;EACI,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AArDJ;;AAwDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AArDJ;;AAwDA;;;;;;;;;;CAAA;AAWA;EACI,eAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AArDJ;;AAwDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AArDJ;;AAwDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;EACA,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,sEAAA;EACA,qCAAA;EACA,2BAAA;EACA,mBAAA;EACA,uCAAA;EACA,iCAAA;EACA,qBAAA;EACA,kBAAA;EACA,eAAA;AArDJ;;AAyDA;;;;;;;;;;CAAA;AAWA;EACI,0BAAA;AAtDJ;;AA0DA;;;;;;;;;;;CAAA;AAaA;;;;;CAAA;AAOA;;;;;;;;;;;;;;;;;;mDAAA;AAmBA,iBAAA;AACA;;EAEI,0BAAA;EACA,qBAAA;EACA,wCAAA;EACA,iBAAA;EACA,yCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,eAAA;EACA,kBAAA;AAzDJ;;AA4DA,iBAAA;AACA;;EAEI,yBAAA;AAzDJ;;AA4DA,iBAAA;AACA;;EAEI,yBAAA;AAzDJ;;AA4DA;;;;;CAAA;AAQA;;;;mDAAA;AAKA;;EAEI,sCAAA;EACA,iDAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;AA3DJ;;AA8DA;;EAEI,gDAAA;AA3DJ;;AA8DA;;EAEI,qCAAA;EACA,iDAAA;AA3DJ;;AA+DA;;;;;CAAA;AAOA;;;;mDAAA;AAKA;;EAGI,qBAAA;EACA,YAAA;EACA,0CAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;AA9DJ;;AAiEA;;EAGI,wCAAA;AA/DJ;;AAmEA;;EAGI,uCAAA;AAjEJ;;AAoEA;;;;;;;;;;;CAAA;AAaA;;;;;CAAA;AAOA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AArEJ;;AAwEA;;;;;;;;;;;;;CAAA;AAcA;;;;EAMI,sCAAA;EACA,4BAAA;EACA,yCAAA;EACA,gBAAA;EACA,wCAAA;AAvEJ;;AA0EA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AAzEJ;;AA4EA;;;;;;;;;;;;;;;;CAAA;AAiBA;;;;;;;;;;;;;;;;EAkBI,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,mCAAA;EACA,gBAAA;EACA,qBAAA;AA7EJ;;AAgFA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AA/EJ;;AAkFA;;;;;;;;;;;CAAA;AAYA,uCAAA;AACA;;;;;;EAOI,iBAAA;EACA,WAAA;EACA,sCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AAhFJ;;AAmFA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;AAnFJ;;AAsFA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,eAAA;EACA,iBAAA;AArFJ;;AAwFA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;AAvFJ;;AA0FA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;;;;;;;;;EAYI,eAAA;EACA,iBAAA;AAvFJ;;AA0FA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,mBAAA;AAzFJ;;AA4FA;;;;;;;;;;;;;CAAA;AAcA,8CAAA;AACA;;;;;;EAOI,eAAA;EACA,mBAAA;AA1FJ;;AA6FA;;;;;;;;;;;;;;;;CAAA;AAiBA;;;;;;;;;;;;EAaI,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,4BAAA;EACA,oCAAA;EACA,wCAAA;EACA,uCAAA;EACA,mCAAA;EACA,oCAAA;AA3FJ;;AA8FA;;;;;;;CAAA;AASA;;;;;;;;;;CAAA;AAWA;EACI,aAAA;EACA,gCAAA;EACA,iBAAA;EACA,oBAAA;EACA,uBAAA;EACA,qBAAA;EACA,mBAAA;EACA,aAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AA5FJ;;AA+FA;;;;;;;;;;;CAAA;AAYA;;EAEI,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA5FJ;;AA+FA;;;;;;;;;;;CAAA;AAYA;;EAEI,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA5FJ;;AA+FA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,8CAAA;EACA,qCAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;AA5FJ;;AA+FA;;;;;;;;;;;CAAA;AAYA;;EAEI,0CAAA;EACA,2BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;AA5FJ;;AA+FA;;;;;;;;;;;;;;;;;;CAAA;AAmBA;;;;;;;;;EASI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA5FJ;;AA+FA;;;;;;;;;;;CAAA;AAYA;;EAEI,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AA5FJ;;AAgGA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,cAAA;EACA,iBAAA;EACA,wCAAA;EACA,kCAAA;EACA,4BAAA;EACA,kBAAA;AAhGJ;;AAmGA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,4DAAA;AAlGJ;;AAqGA;;;;;;;;;;;;;CAAA;AAcA;;;;EAMI,sCAAA;AApGJ;;AAuGA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAtGJ;;AAyGA;;;;;;;;;;;;;CAAA;AAcA,iDAAA;AACA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAvGJ;;AA2GA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,wCAAA;EACA,4BAAA;EACA,cAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AA3GJ;;AA+GA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;AA9GJ;;AAiHA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,oDAAA;AAhHJ;;AAmHA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAlHJ;;AAqHA;;;;;;;;;;;;;CAAA;AAcA,gDAAA;AACA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,iCAAA;AAnHJ;;AAwHA;;sEAAA;AAGA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AArHJ;;AAwHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AArHJ;;AAwHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AArHJ;;AAwHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AArHJ;;AAwHA;EACI,aAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AArHJ;;AAwHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AArHJ;;AAwHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;AArHJ;;AAwHA;;EAEI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,iBAAA;EACA,uDAAA;AArHJ;;AAwHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AArHJ;;AAwHA;EACI,kBAAA;EACA,uCAAA;EACA,4BAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AArHJ;;AAyHA;;sEAAA;AAGA;;;;EAKI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AAvHJ;;AA0HA;;EAGI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;AAxHJ;;AA2HA;;;;EAKI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;EACA,4DAAA;AAzHJ;;AA4HA;;;;;;;;EASI,iBAAA;EACA,kCAAA;EACA,4BAAA;EACA,eAAA;EACA,sCAAA;EACA,oDAAA;AA1HJ;;AA6HA;;;;;;EAOI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,yCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA3HJ;;AA8HA,6CAAA;AACA;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,yCAAA;EACA,iCAAA;EACA,eAAA;EACA,gBAAA;AA5HJ;;AA+HA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,kCAAA;EACA,kBAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,4DAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;AA5HJ;;AA+HA;;EAEI,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,oDAAA;AA5HJ;;AA+HA;;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA5HJ;;AA+HA;EACI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,iCAAA;EACA,kBAAA;AA5HJ;;AAgIA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;AA7HJ;;AAgIA;EACI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,4DAAA;AA7HJ;;AAgIA;EACI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;AA7HJ;;AAgIA;;EAEI,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,kCAAA;EACA,oDAAA;AA7HJ;;AAgIA;;;EAGI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA7HJ;;AAgIA;EACI,sCAAA;EACA,0BAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA7HJ;;AAiIA;;sEAAA;AAGA;EACI,sCAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AA9HJ;;AAiIA;EACI,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;EACA,kCAAA;AA9HJ;;AAiIA;EACI,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;AA9HJ;;AAiIA;;EAEI,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,oCAAA;EACA,uCAAA;AA9HJ;;AAiIA;;;EAGI,mCAAA;EACA,8CAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA9HJ;;AAiIA;EACI,mCAAA;EACA,8CAAA;EACA,eAAA;EACA,mBAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AA9HJ;;AAkIA;;sEAAA;AAGA;;EAGI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,4BAAA;EACA,kBAAA;AAhIJ;;AAmIA;;EAGI,0CAAA;EACA,4BAAA;AAjIJ;;AAoIA;;EAGI,4BAAA;EACA,yBAAA;AAlIJ;;AAqIA;;;;EAOI,4BAAA;EACA,yBAAA;EACA,mCAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AArIJ;;AAyIA;;sEAAA;AAGA;;;;EAKI,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,qCAAA;EACA,kBAAA;AAvIJ;;AA0IA;;EAGI,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;AAxIJ;;AA2IA;;;;EAKI,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AAzIJ;;AA4IA;;;;;;;;EASI,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AA1IJ;;AA6IA;;;;EAKI,SAAA;EACA,iBAAA;EACA,wCAAA;EACA,8BAAA;EACA,eAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AA3IJ;;AA+IA;;sEAAA;AAGA;;EAEI,sBAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;AA5IJ;;AA+IA;;EAEI,0CAAA;EACA,gDAAA;AA5IJ;;AA+IA;;EAEI,0CAAA;AA5IJ;;AA+IA;;EAEI,gDAAA;AA5IJ;;AA+IA;;EAEI,cAAA;EACA,0CAAA;EACA,qBAAA;EACA,mBAAA;AA5IJ;;AA+IA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,kBAAA;AA5IJ;;AA+IA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA5IJ;;AA+IA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kDAAA;AA5IJ;;AA+IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,6BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AA5IJ;;AA+IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AA5IJ;;AA+IA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA5IJ;;AA+IA;EACI,0CAAA;AA5IJ;;AA+IA;EACI,yBAAA;AA5IJ;;AA+IA;EACI,0CAAA;EACA,cAAA;EACA,mCAAA;EACA,eAAA;AA5IJ;;AAgJA;;;;;CAAA;AAOA;;;;;;;;;;;CAAA;AAYA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AA/IJ;;AAkJA;;;;;;;;;;;CAAA;AAYA;;EAGI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;AAhJJ;;AAmJA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAjJJ;;AAoJA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EASI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,8CAAA;EACA,eAAA;AAlJJ;;AAqJA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAnJJ;;AAsJA;;;;;;;;;;;CAAA;AAYA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAnJJ;;AAsJA;;;;;;;;;;;CAAA;AAYA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AAnJJ;;AAsJA;;;;;;;;;;;;CAAA;AAaA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AAnJJ;;AAsJA;;;;;;;;;;;;;;CAAA;AAeA;;;;EAII,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;EACA,eAAA;AAnJJ;;AAsJA;;;;;;;;;;;;CAAA;AAaA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,oCAAA;EACA,YAAA;EACA,0BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAnJJ;;AAwJA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AArJJ;;AAwJA;;;;;;;;;;;CAAA;AAYA;EACI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AArJJ;;AAwJA;;;;;;;;;;;CAAA;AAYA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,iBAAA;EACA,eAAA;AArJJ;;AAwJA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qCAAA;EACA,8CAAA;EACA,eAAA;AArJJ;;AAyJA;;EAEI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;AAtJJ;;AAyJA;EACI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wCAAA;AAtJJ;;AAyJA;;EAEI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;EACA,wCAAA;AAtJJ;;AAyJA;;;;EAII,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,uFACI;EAEJ,gBAAA;AAxJJ;;AA2JA;;EAEI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,2BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AAxJJ;;AA4JA;EACI,UAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,sCAAA;AAzJJ;;AA4JA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;AAzJJ;;AA4JA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,gBAAA;AAzJJ;;AA4JA;EACI,6BAAA;EACA,4BAAA;EACA,mCAAA;EACA,sDAAA;AAzJJ;;AA4JA;;;EAGI,YAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAzJJ;;AA4JA;;sEAAA;AAGA;EACI,YAAA;EACA,SAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;AAzJJ;;AA4JA;;sEAAA;AAGA;;;;EAKI,YAAA;EACA,WAAA;EACA,wCAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;AA1JJ;;AA6JA;;EAGI,YAAA;EACA,WAAA;EACA,sCAAA;EACA,eAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AA3JJ;;AA8JA;;;;EAKI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,4DAAA;AA5JJ;;AA+JA;;;;;;;;EASI,YAAA;EACA,WAAA;EACA,eAAA;EACA,wCAAA;EACA,4BAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,oDAAA;AA7JJ;;AAgKA;;;;;;EAOI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AA9JJ;;AAiKA;;EAEI,YAAA;EACA,WAAA;EACA,eAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AA9JJ;;AAiKA;;sEAAA;AAGA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,gDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,oDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mCAAA;EACA,kBAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,WAAA;EACA,YAAA;AA9JJ;;AAiKA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AA9JJ;;AAiKA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,UAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;AA9JJ;;AAiKA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,gDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,4BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,oDAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,kBAAA;EACA,eAAA;AA9JJ;;AAiKA;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;AA9JJ;;AAiKA;;sEAAA;AAGA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;AA9JJ;;AAiKA;EACI,YAAA;EACA,WAAA;EACA,0CAAA;EACA,cAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AA9JJ;;AAmKA;;sEAAA;AAGA;;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AAhKJ;;AAmKA;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;AAhKJ;;AAmKA;;EAEI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AAhKJ;;AAmKA;;;;EAII,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;AAhKJ;;AAmKA;;;EAGI,YAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,wCAAA;EACA,8BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,qCAAA;EACA,kBAAA;EACA,eAAA;AAhKJ;;AAmKA;;sEAAA;AAGA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AAhKJ;;AAmKA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,gDAAA;AAhKJ;;AAmKA;;EAEI,UAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AAhKJ;;AAmKA;;;EAGI,UAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,8CAAA;AAhKJ;;AAmKA;;;;;;;;EAQI,YAAA;EACA,SAAA;EACA,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EAEA;;;;;;;;;GAAA;AAxJJ;;AAoKA;;EAEI,YAAA;EACA,YAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AAjKJ;;AAqKA;;sEAAA;AAGA;EACI,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AAlKJ;;AAqKA;;EAEI,0CAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,gDAAA;EACA,eAAA;AAlKJ;;AAqKA;EACI,0CAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AAlKJ;;AAqKA;;EAEI,wCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,8CAAA;EACA,eAAA;AAlKJ;;AAqKA;EACI,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AAlKJ;;AAqKA;EACI,0CAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;EACA,mCAAA;EACA,eAAA;AAlKJ;;AAqKA;;sEAAA;AAGA;;EAEI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,kBAAA;AAlKJ;;AAqKA;;;EAGI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,uCAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gDAAA;AAlKJ;;AAqKA;;;;;EAKI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,8CAAA;AAlKJ;;AAqKA;;EAEI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,0CAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;AAlKJ;;AAsKA;;sEAAA;AAGA;;EAEI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,4BAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAnKJ;;AAsKA;;EAEI,0CAAA;EACA,4BAAA;AAnKJ;;AAsKA;;EAEI,yBAAA;AAnKJ;;AAsKA;;EAEI,4BAAA;EACA,yBAAA;EACA,mCAAA;EACA,eAAA;AAnKJ;;AAuKA;;sEAAA;AAGA;;EAEI,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AApKJ;;AAuKA;;;;;;;;EAQI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,oCAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AApKJ;;AAuKA;;;;EAII,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AApKJ;;AAuKA;;EAEI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;EACA,6BAAA;EACA,sDAAA;EACA,+BAAA;EACA,4BAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;AApKJ;;AAuKA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;;;;;;EAQI,iBAAA;EACA,SAAA;EACA,6CAAA;EACA,eAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;AAvKJ;;AA0KA;;;;;;;;;;;;CAAA;AAaA;;;EAKI,4CAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAzKJ;;AA4KA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,wCAAA;AA3KJ;;AA8KA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;;;;;;;;;EAcI,eAAA;EACA,iBAAA;EACA,gDAAA;EACA,oDAAA;AA7KJ;;AAgLA;;;;;;;;;;;;;CAAA;AAcA;;;;;;EAQI,gDAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,6CAAA;AA/KJ;;AAkLA;;;;;;;;;;;;CAAA;AAaA,8CAAA;AACA;;;;;;EAOI,gDAAA;EACA,sCAAA;EACA,mBAAA;EACA,6CAAA;EACA,eAAA;AAhLJ;;AAmLA;;;;;;;;;;CAAA;AAWA;;EAEI,iBAAA;EACA,SAAA;EACA,wCAAA;EACA,eAAA;EACA,iBAAA;EACA,mCAAA;EACA,kBAAA;AAhLJ;;AAmLA;;;;;;;;;;CAAA;AAWA;EACI,eAAA;EACA,iBAAA;EACA,sCAAA;AAhLJ;;AAmLA;;;;;;;;;;;CAAA;AAYA;;EAEI,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,wCAAA;AAhLJ;;AAmLA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,eAAA;EACA,iBAAA;EACA,oDAAA;AAhLJ;;AAmLA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,mCAAA;AAhLJ;;AAoLA;;sEAAA;AAGA;EACI,iBAAA;EACA,SAAA;EACA,sCAAA;EACA,sCAAA;EACA,iBAAA;EACA,iCAAA;EACA,kBAAA;AAjLJ;;AAoLA;EACI,iBAAA;EACA,oCAAA;AAjLJ;;AAoLA;EACI,iBAAA;EACA,oCAAA;AAjLJ;;AAoLA;EACI,iBAAA;EACA,oCAAA;AAjLJ;;AAoLA;EACI,oCAAA;EACA,kCAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;AAjLJ;;AAoLA;EACI,oCAAA;EACA,iCAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;AAjLJ;;AAqLA;;sEAAA;AAGA;EACI,UAAA;EACA,SAAA;EACA,6BAAA;EACA,kBAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AAlLJ;;AAqLA;EACI,YAAA;EACA,yCAAA;EACA,eAAA;AAlLJ;;AAsLA;;sEAAA;AAGA;;EAEI,SAAA;EACA,sCAAA;EACA,kCAAA;EACA,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAnLJ;;AAsLA;;EAEI,yBAAA;AAnLJ;;AAsLA;;EAEI,yBAAA;AAnLJ;;AAsLA;;EAEI,eAAA;EACA,yBAAA;EACA,kCAAA;EACA,mBAAA;EACA,2BAAA;AAnLJ;;AAuLA;;sEAAA;AAGA;EACI,sCAAA;EACA,yCAAA;EACA,iBAAA;EACA,kBAAA;AApLJ;;AAuLA;EACI,sCAAA;EACA,yCAAA;EACA,aAAA;AApLJ;;AAwLA;;sEAAA;AAGA;EACI,gDAAA;EACA,uCAAA;EAEA,sCAAA;EACA,yCAAA;EACA,iBAAA;EAEA,+CAAA;EACA,4BAAA;EAEA,2CAAA;EACA,qCAAA;EACA,kBAAA;AAxLJ;;AA2LA;EACI,sCAAA;EACA,yCAAA;EACA,aAAA;AAxLJ;;AA4LA;;;;;;;;;;;;;;;sEAAA;AAiBA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,uCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AA1LJ;;AA6LA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;EACA,0CAAA;AA1LJ;;AA6LA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;;;EAMI,sCAAA;EACA,4BAAA;EACA,oDAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,eAAA;AA1LJ;;AA6LA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,uCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AA1LJ;;AA6LA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;EACA,0CAAA;AA1LJ;;AA6LA,yCAAA;AACA;;EAEI,2CAAA;EACA,4BAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;;;EAMI,sCAAA;EACA,4BAAA;EACA,oDAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AA1LJ;;AA6LA;;;;mDAAA;AAKA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,SAAA;EACA,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;;;;;;;EAUI,sCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wBAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,8BAAA;EACA,6BAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AA1LJ;;AA6LA,yCAAA;AACA;;;;EAII,uCAAA;EACA,2BAAA;EACA,iBAAA;EACA,eAAA;AA1LJ;;AA6LA;;;;mDAAA;AAKA,iCAAA;AACA;;EAEI,wCAAA;EACA,yCAAA;EACA,4BAAA;EACA,mBAAA;EACA,mCAAA;EACA,iBAAA;EACA,kBAAA;AA1LJ;;AA6LA,iCAAA;AACA;;EAEI,sCAAA;AA1LJ;;AA6LA,iCAAA;AACA;;EAEI,iBAAA;AA1LJ;;AA8LA;;;;;;;;;;;;sEAAA;AAaA,uCAAA;AACA;;EAGI,mBAAA;AA5LJ;;AA+LA;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;AA5LJ;;AA+LA;;EAEI,iBAAA;EACA,kBAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,eAAA;AA5LJ;;AAgMA;;;;;;;;;;;;;;;;sEAAA;AAiBA,sCAAA;AACA;;EAEI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA,2CAAA;AACA;;EAEI,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AA7LJ;;AAgMA;;;EAGI,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;AA7LJ;;AAiMA;;;;;;;;;;;sEAAA;AAYA,2CAAA;AACA;;EAEI,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EAEA;;;;;;;;;;;;;;GAAA;AAjLJ;;AAkMA,2CAAA;AACA;;EAEI,sCAAA;EACA,mCAAA;AA/LJ;;AAkMA,2CAAA;AACA;;EAEI,wCAAA;AA/LJ;;AAkMA,2CAAA;AACA;;EAEI,2CAAA;EACA,0BAAA;EACA,iCAAA;AA/LJ;;AAkMA,2CAAA;AACA;;EAEI,wCAAA;AA/LJ;;AAkMA;;;;;;;;;;;;;CAAA;AAeA;;;;;CAAA;AAOA;;;;;;;;;;CAAA;AAWA;;EAEI,iBAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,mCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;AAjMJ;;AAoMA;;;;;;;;;;CAAA;AAWA;EACI,sCAAA;EACA,4BAAA;EACA,mCAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;AAjMJ;;AAoMA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,oCAAA;EACA,gBAAA;EACA,qBAAA;AAjMJ;;AAoMA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,oCAAA;EACA,gBAAA;EACA,qBAAA;AAnMJ;;AAsMA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AAnMJ;;AAsMA;;;;;;;;;;;;CAAA;AAaA;;;;EAKI,YAAA;EACA,WAAA;EACA,wCAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AApMJ;;AAuMA;;EAEI,sCAAA;EACA,mCAAA;AApMJ;;AAuMA;;EAEI,wCAAA;AApMJ;;AAuMA;;EAEI,wCAAA;AApMJ;;AAuMA;;EAEI,sCAAA;EACA,0BAAA;EACA,iCAAA;EACA,mBAAA;AApMJ;;AAuMA;;;;;EAKI,sCAAA;EACA,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AApMJ;;AAuMA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AApMJ;;AAuMA;EACI,uCAAA;EACA,iBAAA;EACA,eAAA;AApMJ;;AAuMA;EACI,4BAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,8BAAA;EACA,+BAAA;EACA,eAAA;AApMJ;;AAuMA;;qEAAA;AAGA;;;;CAAA;AAOA;;qEAAA;AAGA;;;;CAAA;AAMA;;qEAAA;AAGA;EAEI;;wEAAA;EAGA;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAxMN;EA2ME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAzMN;EA4ME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EA1MN;EA6ME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EA3MN;EA8ME;IACI,kBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EA5MN;EA+ME;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EA7MN;EAgNE;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EA9MN;EAiNE;;IAEI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,gDAAA;EA/MN;EAkNE;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAhNN;EAmNE;IACI,kBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAjNN;AACF;AAqNA;;qEAAA;AAGA;EAEI;;wEAAA;EAGA;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EApNN;EAuNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EArNN;EAwNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EAtNN;EAyNE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EAvNN;EA0NE;IACI,iBAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EAxNN;EA2NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;EAzNN;EA4NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;EA1NN;EA6NE;;IAEI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,iBAAA;IACA,gDAAA;EA3NN;EA8NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;EA5NN;EA+NE;IACI,iBAAA;IACA,uCAAA;IACA,4BAAA;IACA,sBAAA;IACA,eAAA;IACA,mBAAA;IACA,kBAAA;EA7NN;AACF;AAgOA;EACI,WAAA;AA9NJ;;AAiOA;;;;;CAAA;AAOA;;;;;;;;;;;;;CAAA;AAcA;EACI,2BAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,6CAAA;AA/NJ;;AAkOA;EACI,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA/NJ;;AAkOA;EACI,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,oCAAA;AA/NJ;;AAkOA;EACI,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA/NJ;;AAkOA;EACI,+BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,qBAAA;EACA,oCAAA;AA/NJ;;AAkOA;EACI,2BAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;AA/NJ;;AAkOA;;;;;CAAA;AAOA;;;;;CAAA;AAOA;;;;;;;;;;;;CAAA;AAaA;;;;EAII,sEAAA;AAjOJ;;AAoOA;;;;;;;;;;;CAAA;AAYA;;EAEI,sEAAA;AAjOJ;;AAoOA;;;;;;;;;;;CAAA;AAYA;;;;EAII,sEAAA;AAjOJ;;AAoOA;;;;;;;;;;;;;;CAAA;AAeA;;;;;;;;EAQI,sEAAA;AAjOJ;;AAoOA;;;;;;;;;;;;CAAA;AAaA;;;;EAII,sEAAA;AAjOJ;;AAoOA;;;;;;;;;;;CAAA;AAYA;;EAEI,wCAAA;EACA,4BAAA;EACA,yCAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mCAAA;EACA,mBAAA;EACA,eAAA;AAjOJ;;AAoOA;;;;;;;;;;CAAA;AAWA;EACI,sCAAA;EACA,4BAAA;EACA,mCAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AAjOJ;;AAoOA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,0CAAA;EACA,mCAAA;EACA,gBAAA;EACA,qBAAA;AAjOJ;;AAoOA;;;;;;;;;;;;;CAAA;AAcA;;;;EAII,wCAAA;EACA,4BAAA;EACA,6EACI;EAEJ,mCAAA;EACA,gBAAA;EACA,qBAAA;AAnOJ;;AAsOA;;;;;;;;;;;CAAA;AAYA;;EAEI,sCAAA;EACA,4BAAA;EACA,oCAAA;EACA,eAAA;AAnOJ;;AAsOA;;;;;;;;;;;;;;;CAAA;AAgBA;;;;EAII,2BAAA;EACA,sEAAA;AAnOJ;;AAsOA;;;;;;;;;;;;;;;;;;;;CAAA;AAqBA;;;;;;;;;;;EAWI,mDAAA;EACA,aAAA;AAnOJ;;AAsOA;;;;;;CAAA;AAQA,6BAAA;AACA;EACI,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,6CAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApOJ;;AAuOA,6BAAA;AACA;EACI,2BAAA;EACA,gDAAA;EACA,iDAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AApOJ;;AAuOA,6BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,mDAAA;EACA,kDAAA;EACA,cAAA;EACA,iDAAA;AApOJ;;AAuOA,8BAAA;AACA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,wCAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApOJ;;AAuOA,8BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AApOJ;;AAuOA,8BAAA;AACA;EACI,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,yBAAA;AApOJ;;AAuOA,sCAAA;AACA;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,uCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AApOJ;;AAuOA,6BAAA;AACA;EACI,eAAA;EACA,gCAAA;EACA,mBAAA;AApOJ;;AAuOA,mCAAA;AACA;EACI,eAAA;EACA,gCAAA;EACA,iBAAA;AApOJ;;AAuOA,yCAAA;AACA;EACI,SAAA;AApOJ;;AAuOA,kCAAA;AACA;EACI,WAAA;AApOJ;;AAuOA,qCAAA;AACA;EACI,iBAAA;AApOJ;;AAwOA;;;;;EAKI,uCAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;EACA,sCAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,iCAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AArOJ;;AAwOA;EACI,iBAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;AArOJ;;AAwOA,mDAAA;AACA;EACI,gCAAA;EACA,uCAAA;EACA,qCAAA;EACA,qCAAA;EACA,qCAAA;EACA,yCAAA;EACA,yCAAA;EACA,kCAAA;EACA,+CAAA;AArOJ;;AAwOA,mDAAA;AACA;EACI,qBAAA;AArOJ;;AAwOA,mDAAA;AACA;EACI,8CAAA;EACA,+GACI;AAtOR;;AA2OA,mCAAA;AACA;EACI,mDAAA;EACA,2CAAA;EACA,yCAAA;EACA,yCAAA;EACA,yCAAA;EACA,6CAAA;EACA,6CAAA;EACA,sCAAA;AAxOJ;;AA2OA,mCAAA;AACA;EACI,qBAAA;AAxOJ;;AA2OA,mCAAA;AACA;EACI,kDAAA;EACA,+GACI;AAzOR;;AA8OA,oDAAA;AACA;EACI,4CAAA;EACA,4CAAA;EACA,2CAAA;EACA,yCAAA;EACA,2CAAA;EACA,6CAAA;EACA,sCAAA;EACA,gDAAA;AA3OJ;;AA8OA,oDAAA;AACA;EACI,2BAAA;AA3OJ;;AA8OA,oDAAA;AACA;EACI,kDAAA;EACA,+GACI;AA5OR;;AAiPA;;;;CAAA","sourcesContent":["/*\n    ##########################################################################################################################################################\n    EzClocker Button UX CSS Classes\n    Requires:\n        /src/main/webapp/public/styles/common/ez-body.css (for css variables used in this file)\n    ##########################################################################################################################################################\n*/\n\n:root {\n    /* General Button Variables */\n    /*\n    --ezButtons-font-family: 'Font-Family-ezClocker', 'Roboto', 'Verdana', 'Arial', sans-serif;\n    */\n    --ezButtons-font-family: 'Roboto', 'Verdana', 'Arial', sans-serif;\n    --ezButtons-cursor: pointer;\n\n    /* Link Button Common Variables */\n    --ezSmallLinkButton-text-decoration: none;\n    --ezSmallLinkButton-font-weight: normal;\n    --ezSmallLinkButton-font-style: normal;\n    --ezSmallLinkButton-cursor: pointer;\n\n    /* Small Link Button Variables */\n    --ezLinkButton-small-font-size: 10pt;\n\n    /* Large Button Variables */\n    --ezLargeButtonMaxHeight: 32px;\n    --ezLargeButtonMaxWidth: 175px;\n    --ezLargeButtonMinWidth: 32px;\n    --ezLargeButtonTextTransform: capitalize;\n    --ezLargeButtonFontWeight: bold;\n    --ezLargeButton-border-radius: 4px;\n\n    /* Navigation Button Variables */\n    --ezNavButtonColor: var(--ezOrange);\n    --ezNavButtonColorHover: var(--ezClockerOrange);\n    --ezNavButtonTextColor: var(--ezBlack);\n    --ezNavButtonFontSize: var(--ezFontSize);\n    --ezNavButtonFontWeight: var(--ezLargeButtonFontWeight);\n    --ezNavButtonMaxHeight: var(--ezLargeButtonMaxHeight);\n    --ezNavButtonTextTransform: var(--ezLargeButtonTextTransform);\n    --ezNavButtonMaxWidth: var(--ezLargeButtonMaxWidth);\n    --ezNavButtonMinWidth: var(--ezLargeButtonMinWidth);\n    --ezNavButtonRippleEffect: var(--ezWhite);\n    --ezNavButton-border-radius: 4px;\n\n    /* Sign-out Button Variables */\n    --ezSignOutButtonColor: var(--ezClockerAqua);\n    --ezSignOutButtonTextColor: var(--ezWhite);\n    --ezSignOutButtonFontSize: var(--ezFontSize);\n    --ezSignOutButtonHoverColor: var(--ezDarkAqua);\n    --ezSignOutButtonFontWeight: var(--ezLargeButtonFontWeight);\n    --ezSignOutButtonTextTransform: var(--ezLargeButtonTextTransform);\n    --ezSignOutButtonMaxHeight: var(--ezLargeButtonMaxHeight);\n    --ezSignOutButtonMaxWidth: var(--ezLargeButtonMaxWidth);\n    --ezSignOutButtonMinWidth: var(--ezLargeButtonMinWidth);\n    --ezSignOutButtonMinWidth-border-radius: 4px;\n\n    /* Subscription Plan Select Button Variables */\n    --ezSelectPlanBtnColor: var(--ezActionGreen);\n    --ezSelectPlanBtnTextColor: var(--ezBlack);\n    --ezSelectPlanBtnFontSize: var(--ezFontSize);\n    --ezSelectPlanBtnHoverColor: var(--ezHoverGreen);\n    --ezSelectPlanBtnFontWeight: var(--ezLargeButtonFontWeight);\n    --ezSelectPlanTextTransform: var(--ezLargeButtonTextTransform);\n    --ezSelectPlanBtnMaxHeight: var(--ezLargeButtonMaxHeight);\n    --ezSelectPlanButtonMaxWidth: var(--ezLargeButtonMaxWidth);\n    --ezSelectPlanButtonMinWidth: var(--ezLargeButtonMinWidth);\n    --ezSelectPlanButton-border-radius: 4px;\n}\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    HTML Link Buttons\n    ##########################################################################################################################################################\n    Applies to HTML Tags:\n        <a/>\n    Name Templates:\n        ezButtons-{name}-{color}\n        ezButtons-{name}-{other-properties}-color}\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Large Link Buttons\n    Classes:\n        (DEPRECATED) a.ezButtonLink_default-large-navy\n        (DEPRECATED) a.ez-button-link-large-navy\n        (DEPRECATED) a.ezLargeNavyLink\n    ===================================================================================================================\n*/\n\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Default Anchor Tag Style\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\na {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n    font-family: var(--ezButtons-font-family);\n    font-weight: normal;\n    font-style: normal;\n    cursor: pointer;\n}\n\na:hover {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na:enabled {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na:hover:active {\n    color: var(--ezDarkNavy);\n    font-weight: bold;\n    text-decoration: underline;\n}\n\na:visited {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n}\n\na:disabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/*\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n * Button acting as a link or anchor\n * ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n */\nbutton.ezLink {\n    background-color: transparent;\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n    font-family: var(--ezButtons-font-family);\n    font-weight: normal;\n    font-style: normal;\n    border-color: transparent;\n    border-style: none;\n    border-width: 0;\n    cursor: pointer;\n}\n\nbutton.ezLink:hover {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\nbutton.ezLink:enabled {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\nbutton.ezLink:hover:active {\n    color: var(--ezDarkNavy);\n    font-weight: bold;\n    text-decoration: underline;\n}\n\nbutton.ezLink:visited {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n}\n\nbutton.ezLink:disabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButtonLink-hidden\n        a.ezButtonLink-visible\n        (DEPRECATED) a.ezButtonLink_default-large-navy\n        (DEPRECATED) a.ez-button-link-large-navy\n        (DEPRECATED) a.ezLargeNavyLink\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButtonLink-hidden {\n    display: none;\n}\n\na.ezButtonLink-visible {\n    display: unset;\n}\n\n/* DEPRECATED: ezButtonLink_default-large-navy */\na.ezButtonLink_default-large-navy,\na.ezButtonLink_default-large-navy:enabled,\na.ezButtonLink_default-large-navy:enabled:visited,\n/* DEPRECATED: a.ez-button-link-large-navy */\na.ez-button-link-large-navy,\na.ez-button-link-large-navy:enabled,\na.ez-button-link-large-navy:enabled:visited,\n/* DEPRECATED: a.ezLargeNavyLink */\na.ezLargeNavyLink,\na.ezLargeNavyLink:enabled,\na.ezLargeNavyLink:enabled:visited {\n    color: var(--ezClockerNavy);\n    font-family: var(--ezButtons-font-family);\n    font-weight: normal;\n    font-style: normal;\n    font-size: 14pt;\n    cursor: var(--ezButtons-cursor);\n    text-decoration: none;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) a.ezButtonLink_default-large-navy\n        (DEPRECATED) a.ez-button-link-large-navy\n        (DEPRECATED) a.ezLargeNavyLink\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n        :enabled:visited:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: ezButtonLink_default-large-navy */\na.ezButtonLink_default-large-navy:enabled:hover,\na.ezButtonLink_default-large-navy:enabled:focus:hover,\na.ezButtonLink_default-large-navy:enabled:visited:hover,\n/* DEPRECATED a.ez-button-link-large-navy */\na.ez-button-link-large-navy:enabled:hover,\na.ez-button-link-large-navy:enabled:focus:hover,\na.ez-button-link-large-navy:enabled:visited:hover,\n/* DEPRECATED a.ezLargeNavyLink */\na.ezLargeNavyLink:enabled:hover,\na.ezLargeNavyLink:enabled:focus:hover,\na.ezLargeNavyLink:enabled:visited:hover {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\n/* DEPRECATED: ezButtonLink_default-large-navy */\na.ezButtonLink_default-large-navy:enabled:active,\na.ezButtonLink_default-large-navy:enabled:active:hover,\na.ezButtonLink_default-large-navy:enabled:visited:active,\na.ezButtonLink_default-large-navy:enabled:visited:active:hover,\n/* DEPRECATED a.ez-button-link-large-navy */\na.ez-button-link-large-navy:enabled:active,\na.ez-button-link-large-navy:enabled:active:hover,\na.ez-button-link-large-navy:enabled:visited:active,\na.ez-button-link-large-navy:enabled:visited:active:hover,\n/* DEPRECATED a.ezLargeNavyLink */\na.ezLargeNavyLink:enabled:active,\na.ezLargeNavyLink:enabled:active:hover,\na.ezLargeNavyLink:enabled:visited:active,\na.ezLargeNavyLink:enabled:visited:active:hover {\n    color: var(--ezDarkNavy);\n    text-decoration: underline;\n}\n\n/* DEPRECATED: ezButtonLink_default-large-navy */\na.ezButtonLink_default-large-navy:disabled,\na.ezButtonLink_default-large-navy:disabled:hover,\n/* DEPRECATED a.ez-button-link-large-navy */\na.ez-button-link-large-navy:disabled,\na.ez-button-link-large-navy:disabled:hover,\n/* DEPRECATED a.ezLargeNavyLink */\na.ezLargeNavyLink:disabled,\na.ezLargeNavyLink:disabled:hover {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/* DEPRECATED a.ezLargeNavyLinkDisabled */\na.ezLargeNavyLinkDisabled,\na.ezLargeNavyLinkDisabled:disabled a.ezLargeNavyLinkDisabled:disabled:hover {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Link Buttons\n    Classes:\n        a.ezLink-ezClockerNavy\n        (DEPRECATED) a.ezNavyLink\n    ===================================================================================================================\n*/\n\na.ezLink-ezClockerNavy,\n/* DEPRECATED:  */\na.ezNavyLink {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n    font-family: var(--ezButtons-font-family);\n    font-size: 12pt;\n    font-weight: normal;\n    font-style: normal;\n    cursor: pointer;\n}\n\na.ezLink-ezClockerNavy:hover,\n/* DEPRECATED:  */\na.ezNavyLink:hover {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na.ezLink-ezClockerNavy:hover:enabled,\n/* DEPRECATED:  */\na.ezNavyLink:hover:enabled {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na.ezLink-ezClockerNavy:hover:active,\n/* DEPRECATED:  */\na.ezNavyLink:hover:active {\n    color: var(--ezDarkNavy);\n    text-decoration: underline;\n}\n\na.ezLink-ezClockerNavy:visited,\n/* DEPRECATED:  */\na.ezNavyLink:visited {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n}\n\na.ezLink-ezClockerNavy:disabled,\n/* DEPRECATED:  */\na.ezNavyLink:disabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/* DEPRECATED:  */\na.ezNavyLinkDisabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    HTML Link 'Button' Classes\n    ##########################################################################################################################################################\n    Applies to HTML Tags:\n        <a/>\n    Name Templates:\n        ezButtons-link-{name}-{color}\n        ezButtons-link-{name}-{other-properties}-color}\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Link Buttons\n    Classes:\n        a.ezButton-link-ezClockerOrange\n        a.ezButton-link-ezClockerWhite\n        a.ezButton-link-ezClockerHotGreen\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :link\n        :visited\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerOrange,\na.ezButton-link-ezClockerOrange:link,\na.ezButton-link-ezClockerOrange:visited {\n    margin: 0;\n    padding: 4px;\n    /* Variable --ezClockerOrange defined in ez-body.css */\n    background-color: var(--ezClockerOrange);\n    text-decoration: none;\n    /* Variable --ezContentFontColor defined in ez-body.css */\n    color: var(--ezContentFontColor);\n    /* Variable ezFontFamily defined in ez-body.css */\n    font-family: var(--ezFontFamily);\n    /* Variable --ezContentFontSize defined in ez-body.css */\n    font-size: var(--ezContentFontSize);\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\n    font-weight: var(--ezContentFontWeigth);\n    /* Variable --ezContentFontStyle defined in ez-body.css */\n    font-style: var(--ezContentFontStyle);\n    /* Variable --ezBorderOrange defined in ez-body.css */\n    border-color: var(--ezBorderOrange);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :active\n        :active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezclockerOrange:active,\na.ezButton-link-ezclockerOrange:active:hover {\n    box-shadow: var(--ezBoxShadow-inset-ezClockerOrange-50);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n        :visited:hove\n        :active:hover\n        :link:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerOrange:hover,\na.ezButton-link-ezClockerOrange:visited:hover,\na.ezButton-link-ezClockerOrange:link:hover {\n    background-color: var(--ezHoverOrange);\n    box-shadow: unset;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n        :disabled:visited\n        :disabled:link\n        :disabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerOrange:disabled,\na.ezButton-link-ezClockerOrange:disabled:active,\na.ezButton-link-ezClockerOrange:disabled:hover,\na.ezButton-link-ezClockerOrange:disabled:visited,\na.ezButton-link-ezClockerOrange:disabled:link {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezBorderOrange);\n    border-color: var(--ezOrange);\n    box-shadow: unset;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerWhite\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :link\n        :visited\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerWhite,\na.ezButton-link-ezClockerWhite:link,\na.ezButton-link-ezClockerWhite:visited {\n    margin: 0;\n    padding: 4px;\n    /* Variable --ezClockerOrange defined in ez-body.css */\n    background-color: var(--ezClockerWhite);\n    text-decoration: none;\n    /* Variable --ezContentFontColor defined in ez-body.css */\n    color: var(--ezContentFontColor);\n    /* Variable ezFontFamily defined in ez-body.css */\n    font-family: var(--ezFontFamily);\n    /* Variable --ezContentFontSize defined in ez-body.css */\n    font-size: var(--ezContentFontSize);\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\n    font-weight: var(--ezContentFontWeigth);\n    /* Variable --ezContentFontStyle defined in ez-body.css */\n    font-style: var(--ezContentFontStyle);\n    /* Variable --ezBorderOrange defined in ez-body.css */\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerWhite\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :active\n        :active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerWhite:active,\na.ezButton-link-ezClockerWhite:active:hover {\n    box-shadow: var(--ezBoxShadow-inset-ezClockerGray-50);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerWhite\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n        :visited:hove\n        :active:hover\n        :link:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerWhite:hover,\na.ezButton-link-ezClockerWhite:visited:hover,\na.ezButton-link-ezClockerWhite:link:hover {\n    background-color: var(--ezClockerSilver);\n    box-shadow: unset;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerWhite\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n        :disabled:visited\n        :disabled:link\n        :disabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerWhite:disabled,\na.ezButton-link-ezClockerWhite:disabled:hover,\na.ezButton-link-ezClockerWhite:disabled:visited,\na.ezButton-link-ezClockerWhite:disabled:link,\na.ezButton-link-ezClockerWhite:disabled:active {\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerGray);\n    border-color: var(--ezClockerSilver);\n    box-shadow: unset;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerHotGreen\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :link\n        :visited\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerHotGreen,\na.ezButton-link-ezClockerHotGreen:link,\na.ezButton-link-ezClockerHotGreen:visited {\n    margin: 0;\n    padding: 4px;\n    /* Variable --ezClockerOrange defined in ez-body.css */\n    background-color: var(--ezClockerHotGreen);\n    text-decoration: none;\n    /* Variable --ezContentFontColor defined in ez-body.css */\n    color: var(--ezContentFontColor);\n    /* Variable ezFontFamily defined in ez-body.css */\n    font-family: var(--ezFontFamily);\n    /* Variable --ezContentFontSize defined in ez-body.css */\n    font-size: var(--ezContentFontSize);\n    /* Variable --ezContentFontWeigth defined in ez-body.css */\n    font-weight: var(--ezContentFontWeigth);\n    /* Variable --ezContentFontStyle defined in ez-body.css */\n    font-style: var(--ezContentFontStyle);\n    /* Variable --ezBorderOrange defined in ez-body.css */\n    border-color: var(--ezBorderHotGreen);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerHotGreen\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :active\n        :active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerHotGreen:active,\na.ezButton-link-ezClockerHotGreen:active:hover {\n    box-shadow: var(--ezBoxShadow-inset-ezBorderHotGreen-50);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerHotGreen\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n        :visited:hove\n        :link:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerHotGreen:hover,\na.ezButton-link-ezClockerHotGreen:visited:hover,\na.ezButton-link-ezClockerHotGreen:link:hover {\n    background-color: var(--ezHoverHotGreen);\n    box-shadow: unset;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-link-ezClockerHotGreen\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n        :disabled:visited\n        :disabled:link\n        :disabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-link-ezClockerHotGreen:disabled,\na.ezButton-link-ezClockerHotGreen:disabled:hover,\na.ezButton-link-ezClockerHotGreen:disabled:visited,\na.ezButton-link-ezClockerHotGreen:disabled:link,\na.ezButton-link-ezClockerHotGreen:disabled:active {\n    background-color: var(--ezHoverHotGreen);\n    color: var(--ezBorderHotGreen);\n    border-color: var(--ezClockerHotGreen);\n    box-shadow: unset;\n    cursor: default;\n}\n\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Small Link Buttons\n        a.ezButtonLink_default-small-navy\n        (DEPRECATED) a.ezSmallNavyLink\n        (DEPRECATED) a.ez-button-link-small-navy\n        (DEPRECATED) a.ezSmallNavyLinkDisabled\n    ===================================================================================================================\n*/\n\n/* -------------------------------------------------\n| [Link Button]\n|   ezButtonLink_default-small-navy\n|   (DEPRECATED) ez-button-link-small-navy\n|   (DEPRECATED) ezSmallNavyLink\n------------------------------------------------- */\na.ezButtonLink_default-small-navy,\n/* DEPRECATED:  */\na.ezSmallNavyLink,\n/* DEPRECATED:  */\na.ez-button-link-small-navy {\n    color: var(--ezClockerNavy);\n    font-family: var(--ezFontFamily);\n    text-decoration: none;\n    font-size: 10pt;\n    font-weight: normal;\n    font-style: normal;\n    cursor: pointer;\n}\n\na.ezButtonLink_default-small-navy:hover,\n/* DEPRECATED:  */\na.ezSmallNavyLink:hover,\n/* DEPRECATED:  */\na.ez-button-link-small-navy:hover {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na.ezButtonLink_default-small-navy:hover:enabled,\n/* DEPRECATED:  */\na.ezSmallNavyLink:hover:enabled,\n/* DEPRECATED:  */\na.ez-button-link-small-navy:hover:enabled {\n    color: var(--ezHoverNavy);\n    text-decoration: underline;\n}\n\na.ezButtonLink_default-small-navy:hover:active,\n/* DEPRECATED:  */\na.ezSmallNavyLink:hover:active,\n/* DEPRECATED:  */\na.ez-button-link-small-navy:hover:active {\n    color: var(--ezDarkNavy);\n    text-decoration: underline;\n}\n\na.ezButtonLink_default-small-navy:visited,\n/* DEPRECATED:  */\na.ezSmallNavyLink:visited,\n/* DEPRECATED:  */\na.ez-button-link-small-navy:visited {\n    color: var(--ezClockerNavy);\n    text-decoration: none;\n}\n\na.ezButtonLink_default-small-navy:disabled,\n/* DEPRECATED:  */\na.ezSmallNavyLink:disabled,\n/* DEPRECATED:  */\na.ez-button-link-small-navy:disabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/* DEPRECATED:  */\na.ezSmallNavyLinkDisabled {\n    color: var(--ezClockerGray);\n    text-decoration: none;\n    cursor: default;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Action Link Buttons\n    Classes:\n        a.ezButtonLink_action-normal-green\n        (DEPRECATED) a.ezActionLink\n    ===================================================================================================================\n*/\n\n/* -------------------------------------------------\n| [Link Button]\n|   ezButtonLink_action-normal-green\n|   (DEPRECATED) ezActionLink\n------------------------------------------------- */\na.ezButtonLink_action-normal-green:link,\n/* DEPRECATED:  */\na.ezActionLink:link {\n    margin: 0;\n    padding: 8px;\n    background-color: var(--ezActionGreen);\n    text-decoration: none;\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    cursor: pointer;\n    border-radius: 3px;\n}\n\na.ezButtonLink_action-normal-green:hover:enabled,\n/* DEPRECATED:  */\na.ezActionLink:hover:enabled {\n    background-color: var(--ezHoverHotGreen);\n}\n\na.ezButtonLink_action-normal-green:hover:active,\n/* DEPRECATED:  */\na.ezActionLink:hover:active {\n    background-color: var(--ezDarkHotGreen);\n}\n\na.ezButtonLink_action-normal-green:visited,\n/* DEPRECATED:  */\na.ezActionLink:visited {\n    margin: 0;\n    padding: 8px;\n    text-decoration: none;\n    background-color: var(--ezActionGreen);\n    font-style: normal;\n    color: var(--ezClockerBlack);\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    cursor: pointer;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Download Link Buttons\n    Classes:\n        a.ezButtonLink_download-normal-navy\n        (DEPRECATED) a.ezDownloadLink\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButtonLink_download-normal-navy\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :link\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButtonLink_download-normal-navy:link,\n/* DEPRECATED: ezDownloadLink */\na.ezDownloadLink:link {\n    margin: 0;\n    padding: 8px;\n    background-color: var(--ezClockerNavy);\n    text-decoration: none;\n    color: var(--ezClockerWhite);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButtonLink_download-normal-navy\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover:enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButtonLink_download-normal-navy:hover:enabled,\n/* DEPRECATED: ezDownloadLink */\na.ezDownloadLink:hover:enabled {\n    background-color: var(--ezHoverNavy);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButtonLink_download-normal-navy\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButtonLink_download-normal-navy:hover:active,\n/* DEPRECATED: ezDownloadLink */\na.ezDownloadLink:hover:active {\n    background-color: var(--ezDarkNavy);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButtonLink_download-normal-navy\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :visited\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButtonLink_download-normal-navy:visited,\n/* DEPRECATED: ezDownloadLink */\na.ezDownloadLink:visited {\n    margin: 0;\n    padding: 8px;\n    text-decoration: none;\n    background-color: var(--ezClockerNavy);\n    font-style: normal;\n    color: var(--ezClockerWhite);\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    cursor: pointer;\n}\n\na.ezButtonLink_download-normal-navy:disabled,\n/* DEPRECATED: ezDownloadLink */\na.ezDownloadLink:disabled {\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerSilver);\n    border-color: var(--ezLightNavy);\n    cursor: default;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Help/More Info Link Buttons\n    Classes:\n        a.ezButton-what-is-this-link\n        a.ezButton-what-is-this-link-margin-top4px\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-what-is-this-link {\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: small;\n    text-decoration: none;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-what-is-this-link:hover {\n    text-decoration: underline;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link-margin-top4px\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-what-is-this-link-margin-top4px {\n    margin-top: 4px;\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: small;\n    text-decoration: none;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link-margin-top4px\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-what-is-this-link-margin-top4px:hover {\n    text-decoration: underline;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-show-more-details-link {\n    /* top right bottom left */\n    padding: 4px 4px 4px 18px;\n    background-color: transparent;\n    background-size: 10px 10px;\n    background-position: 4px center;\n    background-repeat: no-repeat;\n    background-image: url('/public/images/icons/expand-ezClockerNavy.svg');\n    /* --ezClockerNavy from ez-body.css */\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    /* --ezSmallFontSize from ez-text.css */\n    font-size: var(--ezSmallFontSize);\n    text-decoration: none;\n    border-style: none;\n    cursor: pointer;\n\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        a.ezButton-what-is-this-link\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\na.ezButton-show-more-details-link:hover {\n    text-decoration: underline;\n}\n\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    HTML Input Buttons\n    ##########################################################################################################################################################\n    Applies to HTML Tags:\n        <input type=\"button\"/>\n    Name Templates:\n        ezButtons-{name}-{color}\n        ezButtons-{name}-{other-properties}-color}\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Major Input Buttons\n    ===================================================================================================================\n*/\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Input Buttons\n| HTML Tags: <input type=\"button\"/>\n|-------------------------------------------------\n| Template: ezInputButton_{name}-{size}-{color}\n|\n| Official Classes:\n|   ezInputButton_major-normal-orange\n|   ezInputButton_action-normal-ezActionGreen\n|\n| Deprecated Classes:\n|   ez-major-button\n|   ez-action-button\n/*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n/*-------------------------------------------------\n| [Input Button]\n|   ezInputButton_major-normal-orange\n|   (DEPRECATED) ez-major-button\n------------------------------------------------- */\n/* DEPRECATED:  */\ninput[type=\"button\"].ez-major-button,\ninput[type=\"button\"].ezInputButton_major-normal-orange {\n    /* ez-major-button style */\n    display: inline-block;\n    background-color: var(--ezClockerOrange);\n    padding: 6px 24px;\n    font-family: var(--ezButtons-font-family);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    text-decoration: none;\n    border: 1px solid var(--ezClockerBlack);\n    cursor: pointer;\n    border-radius: 3px;\n}\n\n/* DEPRECATED:  */\ninput[type=\"button\"].ez-major-button:hover:enabled,\ninput[type=\"button\"].ezInputButton_major-normal-orange:hover:enabled {\n    background-color: #ffcc66;\n}\n\n/* DEPRECATED:  */\ninput[type=\"button\"].ez-major-button:hover:active,\ninput[type=\"button\"].ezInputButton_major-normal-orange:hover:active {\n    background-color: #ff9933;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Action Input Buttons\n    ===================================================================================================================\n*/\n\n\n/* -------------------------------------------------\n| [Input Button]\n|   ezInputButton_action-normal-ezActionGreen\n|   (DEPRECATED) ez-action-button\n------------------------------------------------- */\ninput[type=\"button\"].ez-action-button,\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen {\n    background-color: var(--ezActionGreen);\n    border: 1px solid var(--ezActionGreenBorderColor);\n    display: inline-block;\n    cursor: pointer;\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtons-font-family);\n    font-size: 12px;\n    font-weight: bold;\n    padding: 6px 24px;\n    text-decoration: none;\n    border-radius: 3px;\n}\n\ninput[type=\"button\"].ez-action-button:hover:enabled,\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen:hover:enabled {\n    background-color: var(--ezActionGreenHoverColor);\n}\n\ninput[type=\"button\"].ez-action-button:hover:active,\ninput[type=\"button\"].ezInputButton_action-normal-ezActionGreen:hover:active {\n    color: var(--ezActionGreenHoverColor);\n    background-color: var(--ezActionGreenBorderColor);\n}\n\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Edit Input Buttons\n    ===================================================================================================================\n*/\n\n/* -------------------------------------------------\n| [Input Button]\n|   ezInputButton_edit-normal-ezClockerOffWhite\n|   (DEPRECATED) ez-edit-button\n------------------------------------------------- */\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite,\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\ninput[type=\"button\"].ez-edit-button {\n    display: inline-block;\n    padding: 4px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtons-font-family);\n    font-size: 12px;\n    font-weight: normal;\n    text-decoration: none;\n    border: 1px solid var(--ezBorderOffWhite);\n    cursor: pointer;\n    border-radius: 3px;\n}\n\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite:hover:enabled,\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\ninput[type=\"button\"].ez-edit-button:hover:enabled {\n    background-color: var(--ezHoverOffWhite);\n}\n\n\ninput[type=\"button\"].ezInputButton_edit-normal-ezClockerOffWhite:hover:active,\n/* DEPRECATED: input[type=\"button\"].ez-edit-button */\ninput[type=\"button\"].ez-edit-button:hover:active {\n    background-color: var(--ezDarkOffWhite);\n}\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    HTML Button Classes\n    ##########################################################################################################################################################\n    Applies to HTML Tags:\n        <button/>\n    Name Templates:\n        ezButtons-{name}-{color}\n        ezButtons-{name}-{other-properties}-color}\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Buttons\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezButton\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton,\nbutton:enabled,\nbutton.ezButton-default-ezClockerOrange,\nbutton.ezButton-default-ezClockerOrange:enabled,\n/* DEPRECATED: ezButton */\nbutton.ezButton,\nbutton.ezButton:enabled,\n/* DEPRECATED: ezButton_default-normal-ezClockerOrange */\nbutton.ezButton_default-normal-ezClockerOrange,\nbutton.ezButton_default-normal-ezClockerOrange:enabled {\n    padding: 6px 24px;\n    margin: 2px;\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtons-font-family);\n    font-size: 10pt;\n    font-weight: normal;\n    text-align: center;\n    vertical-align: middle;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 3px;\n    box-shadow: 0 0 1px 1px transparent;\n    outline-style: none;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezButton\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton:enabled:focus,\nbutton.ezButton-default-ezClockerOrange:enabled:focus,\n/* DEPRECATED: button.ezButton */\nbutton.ezButton:enabled:focus,\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezClockerBlack);\n    /* box-shadow: 0 0 1px 1px transparent; */\n    outline-width: 0;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezButton\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton:enabled:hover,\nbutton:enabled:focus:hover,\nbutton.ezButton-default-ezClockerOrange:enabled:hover,\nbutton.ezButton-default-ezClockerOrange:enabled:focus:hover,\n/* DEPRECATED: button.ezButton */\nbutton.ezButton:enabled:hover,\nbutton.ezButton:enabled:focus:hover,\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\nbutton.ezButton_default-normal-ezClockerOrange:enabled:hover,\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:hover {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezClockerBlack);\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\n    outline-color: var(--ezClockerGray);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezButton\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    States:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton:enabled:active,\nbutton:enabled:active:hover,\nbutton:enabled:focus:active,\nbutton:enabled:focus:active:hover,\nbutton.ezButton-default-normal-ezClockerOrange:enabled:active,\nbutton.ezButton-default-normal-ezClockerOrange:enabled:active:hover,\nbutton.ezButton-default-normal-ezClockerOrange:enabled:focus:active,\nbutton.ezButton-default-normal-ezClockerOrange:enabled:focus:active:hover,\n/* DEPRECATED: button.ezButton */\nbutton.ezButton:enabled:active,\nbutton.ezButton:enabled:active:hover,\nbutton.ezButton:enabled:focus:active,\nbutton.ezButton:enabled:focus:active:hover,\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\nbutton.ezButton_default-normal-ezClockerOrange:enabled:active,\nbutton.ezButton_default-normal-ezClockerOrange:enabled:active:hover,\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:active,\nbutton.ezButton_default-normal-ezClockerOrange:enabled:focus:active:hover {\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    box-shadow:\n        0 0 1px 1px transparent,\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\n    outline-color: var(--ezClockerGray);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezButton\n        (DEPRECATED) button.ezButton_default-normal-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton:disabled,\nbutton:disabled:hover,\nbutton.ezButton-default-normal-ezClockerOrange:disabled,\nbutton.ezButton-default-normal-ezClockerOrange:disabled:hover,\n/* DEPRECATED: button.ezButton */\nbutton.ezButton:disabled,\nbutton.ezButton:disabled:hover,\n/* DEPRECATED: button.ezButton_default-normal-ezClockerOrange */\nbutton.ezButton_default-normal-ezClockerOrange:disabled,\nbutton.ezButton_default-normal-ezClockerOrange:disabled:hover {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezBorderOrange);\n    border-color: var(--ezClockerOrange);\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]:\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) button.disabledButton\n        (DEPRECATED) button.ezDisabledButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        all\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: button.disabledButton  */\nbutton.disabledButton,\nbutton.disabledButton:disabled,\nbutton.disabledButton:disabled:hover,\n/* DEPRECATED: button.ezDisabledButton  */\nbutton.ezDisabledButton,\nbutton.ezDisabledButton:disabled,\nbutton.ezDisabledButton:disabled:hover {\n    padding: 6px 24px;\n    margin: 2px;\n    background-color: var(--ezHoverOrange);\n    color: var(--ezBorderOrange);\n    font-family: var(--ezButtons-font-family);\n    font-size: 10pt;\n    font-weight: normal;\n    text-align: center;\n    vertical-align: middle;\n    border-color: var(--ezClockerOrange);\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 3px;\n    box-shadow: 0 0 1px 1px transparent;\n    outline-style: none;\n    cursor: default;\n}\n\n/*\n====================================================================================================================\n| [Class Group]\n| EzClocker Header Buttons\n====================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButton\n        (DEPRECATED) button.headerButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-ezClockerOrange,\nbutton.ezButtons-header-ezClockerOrange:enabled,\n/* DEPRECATED: button.ezHeaderButton */\nbutton.ezHeaderButton,\nbutton.ezHeaderButton:enabled,\n/* DEPRECATED: button.headerButton */\nbutton.headerButton,\nbutton.headerButton:enabled {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButton\n        (DEPRECATED) button.headerButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-ezClockerOrange:enabled:focus,\n/* DEPRECATED: button.ezHeaderButton */\nbutton.ezHeaderButton:enabled:focus,\n/* DEPRECATED: button.headerButton */\nbutton.headerButton:enabled:focus {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButton\n        (DEPRECATED) button.headerButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-ezClockerOrange:enabled:hover,\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:hover,\n/* DEPRECATED: button.headerButton */\nbutton.headerButton:enabled:hover,\nbutton.headerButton:enabled:focus:hover,\n/* DEPRECATED: button.ezHeaderButton */\nbutton.ezHeaderButton:enabled:hover,\nbutton.ezHeaderButton:enabled:focus:hover {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButton\n        (DEPRECATED) button.headerButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-ezClockerOrange:enabled:active,\nbutton.ezButtons-header-ezClockerOrange:enabled:active:hover,\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:active,\nbutton.ezButtons-header-ezClockerOrange:enabled:focus:active:hover,\nbutton.ezHeaderButton:enabled:active,\nbutton.ezHeaderButton:enabled:active:hover,\nbutton.ezHeaderButton:enabled:focus:active,\nbutton.ezHeaderButton:enabled:focus:active:hover,\nbutton.headerButton:enabled:active,\nbutton.headerButton:enabled:active:hover,\nbutton.headerButton:enabled:focus:active,\nbutton.headerButton:enabled:focus:active:hover {\n    font-size: 12pt;\n    font-weight: bold;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButton\n        (DEPRECATED) button.headerButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-ezClockerOrange:disabled,\nbutton.ezButtons-header-ezClockerOrange:disabled:hover,\n/* DEPRECATED: button.headerButton */\nbutton.ezHeaderButton:disabled,\nbutton.ezHeaderButton:disabled:hover,\n/* DEPRECATED: button.headerButton */\nbutton.headerButton:disabled,\nbutton.headerButton:disabled:hover {\n    font-size: 12pt;\n    font-weight: normal;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) button.ezDisabledHeaderButton\n        (DEPRECATED) button.disabledHeaderButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: button.ezDisabledHeaderButton */\nbutton.ezDisabledHeaderButton,\nbutton.ezDisabledHeaderButton:disabled,\nbutton.ezDisabledHeaderButton:disabled:hover,\n/* DEPRECATED: button.disabledHeaderButton */\nbutton.disabledHeaderButton,\nbutton.disabledHeaderButton:disabled,\nbutton.disabledHeaderButton:disabled:hover {\n    font-size: 12pt;\n    font-weight: normal;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-header-down-ezClockerOrange\n        (DEPRECATED) button.ezHeaderButtonDown\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled\n        :enabled:hover,\n        :enabled:active,\n        :enabled:focus,\n        :disabled,\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-header-down-ezClockerOrange,\nbutton.ezButtons-header-down-ezClockerOrange:enabled,\nbutton.ezButtons-header-down-ezClockerOrange:enabled:hover,\nbutton.ezButtons-header-down-ezClockerOrange:enabled:active,\nbutton.ezButtons-header-down-ezClockerOrange:enabled:focus,\n/* DEPRECATED: button.ezHeaderButtonDown */\nbutton.ezHeaderButtonDown,\nbutton.ezHeaderButtonDown:enabled,\nbutton.ezHeaderButtonDown:enabled:hover,\nbutton.ezHeaderButtonDown:enabled:active,\nbutton.ezHeaderButtonDown:enabled:focus,\nbutton.ezHeaderButtonDown:disabled,\nbutton.ezHeaderButtonDown:disabled:hover {\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n    color: var(--ezClockerBlack);\n    background-color: var(--ezDimOrange);\n    border-left-color: var(--ezBorderOrange);\n    border-top-color: var(--ezBorderOrange);\n    border-right-color: var(--ezOrange);\n    border-bottom-color: var(--ezOrange);\n}\n\n/*\n\n/*\n====================================================================================================================\n| [Class Group]\n| EzClocker Toggle Buttons\n====================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezLargeToggleButton-2col-container\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        all\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-toggle-button-large-2col-container {\n    display: grid;\n    grid-template-columns: auto auto;\n    grid-row-gap: 4px;\n    grid-column-gap: 4px;\n    justify-content: center;\n    align-content: center;\n    margin: 10px 10px 0;\n    padding: 10px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-size: 14pt;\n    border-color: var(--ezClockerGray);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-unselected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-toggle-button-large-unselected,\nbutton.ezButtons-toggle-button-large-unselected:enabled {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: 14pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-unselected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-toggle-button-large-unselected:enabled:hover,\n.ezButtons-toggle-button-large-unselected:enabled:focus:hover {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: 14pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-unselected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-toggle-button-large-unselected:enabled:active,\nbutton.ezButtons-toggle-button-large-unselected:enabled:active:hover,\nbutton.ezButtons-toggle-button-large-unselected:enabled:focus:active,\nbutton.ezButtons-toggle-button-large-unselected:enabled:focus:active:hover {\n    background-color: var(--ezHoverNavy);\n    color: var(--ezClockerWhite);\n    font-size: 14pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\n    outline-color: var(--ezNavy-alpha-50);\n    outline-width: 1px;\n    outline-style: auto;\n    outline-offset: 2px;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-unselected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-toggle-button-large-unselected:disabled,\nbutton.ezButtons-toggle-button-large-unselected:disabled:hover {\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerGray);\n    font-size: 14pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerSilver);\n    border-radius: 3px;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-selected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n        :enabled:hover\n        :enabled:active,\n        :enabled:active:hover\n        :enabled:focus\n        :enabled:focus:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-toggle-button-large-selected,\nbutton.ezButtons-toggle-button-large-selected:enabled,\nbutton.ezButtons-toggle-button-large-selected:enabled:hover,\nbutton.ezButtons-toggle-button-large-selected:enabled:active,\nbutton.ezButtons-toggle-button-large-selected:enabled:active:hover,\nbutton.ezButtons-toggle-button-large-selected:enabled:focus,\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:hover,\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:active,\nbutton.ezButtons-toggle-button-large-selected:enabled:focus:active:hover {\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 14pt;\n    font-weight: bold;\n    border-color: var(--ezBorderNavy);\n    border-width: 2px;\n    box-shadow: none;\n    outline-style: none;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-toggle-button-large-selected\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-toggle-button-large-selected:disabled,\nbutton.ezButtons-toggle-button-large-selected:disabled:hover {\n    background-color: var(--ezHoverNavy);\n    color: var(--ezBorderNavy);\n    font-size: 14pt;\n    font-weight: bold;\n    border-color: var(--ezClockerNavy);\n    box-shadow: none;\n    outline-style: none;\n    cursor: default;\n}\n\n\n/*\n====================================================================================================================\n| [Class Group]\n| EzClocker Major Buttons\n====================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-major-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniMajorButton\n        (DEPRECATED) button.miniMajorButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-major-mini-ezClockerYellow,\n.ezButtons-major-mini-ezClockerYellow:enabled,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.ezMiniMajorButton,\nbutton.ezMiniMajorButton:enabled,\n/* DEPRECATED:  */\nbutton.miniMajorButton,\nbutton.miniMajorButton:enabled {\n    font-size: 8pt;\n    font-weight: bold;\n    background-color: var(--ezClockerYellow);\n    border-color: var(--ezClockerGray);\n    color: var(--ezClockerBlack);\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-major-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniMajorButton\n        (DEPRECATED) button.miniMajorButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:hover,\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:active:hover,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.ezMiniMajorButton:enabled:hover,\nbutton.ezMiniMajorButton:enabled:active:hover,\n/* DEPRECATED: button.miniMajorButton */\nbutton.miniMajorButton:enabled:hover,\nbutton.miniMajorButton:enabled:active:hover {\n    background-color: var(--ezLightYellow);\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezMiniMajorButton\n        (DEPRECATED) button.miniMajorButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:focus:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:active,\nbutton.ezButtons-major-mini-ezClockerYellow:enabled:focus:active,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.ezMiniMajorButton:enabled:active,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.miniMajorButton:enabled:focus:active {\n    background-color: var(--ezLightYellow);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButton-default-normal-ezClockerOrange\n        (DEPRECATED) button.ezMiniMajorButton\n        (DEPRECATED) button.miniMajorButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-major-mini-ezClockerYellow:disabled,\nbutton.ezButtons-major-mini-ezClockerYellow:disabled:hover,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.ezMiniMajorButton:disabled,\nbutton.ezMiniMajorButton:disabled:hover,\n/* DEPRECATED: button.ezMiniMajorButton */\nbutton.miniMajorButton:disabled,\nbutton.miniMajorButton:disabled:hover {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    border-color: var(--ezDarkYellow);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) button.ezDisabledMiniMajorButton\n        (DEPRECATED) button.disabledMiniMajorButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: button.ezDisabledMiniMajorButton */\nbutton.ezDisabledMiniMajorButton,\nbutton.ezDisabledMiniMajorButton:disabled,\nbutton.ezDisabledMiniMajorButton:disabled:hover,\n/* DEPRECATED: button.ezDisabledMiniMajorButton */\nbutton.disabledMiniMajorButton:disabled,\nbutton.disabledMiniMajorButton:disabled:hover,\nbutton.disabledMiniMajorButton {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    border-color: var(--ezDarkYellow);\n}\n\n\n/*\n====================================================================================================================\n| [Class Group]\n| EzClocker Mini Buttons\n====================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-default-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniNormalButton\n        (DEPRECATED) button.miniNormalButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-default-mini-ezClockerYellow,\nbutton.ezButtons-default-mini-ezClockerYellow:enabled,\n/* DEPRECATED: button.ezMiniNormalButton */\nbutton.ezMiniNormalButton,\nbutton.ezMiniNormalButton:enabled,\n/* DEPRECATED: button.miniNormalButton */\nbutton.miniNormalButton,\nbutton.miniNormalButton:enabled {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 8pt;\n    font-weight: normal;\n    border-color: var(--ezClockerGray);\n    border-radius: 3px;\n}\n\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-default-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniNormalButton\n        (DEPRECATED) button.miniNormalButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:hover,\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:focus:hover,\n/* DEPRECATED: button.ezMiniNormalButton */\nbutton.ezMiniNormalButton:enabled:hover,\nbutton.ezMiniNormalButton:enabled:focus:hover,\n/* DEPRECATED: button.miniNormalButton */\nbutton.miniNormalButton:enabled:hover,\nbutton.miniNormalButton:enabled:focus:hover {\n    background-color: var(--ezLightYellow);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-default-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniNormalButton\n        (DEPRECATED) button.miniNormalButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-default-mini-ezClockerYellow:enabled:active,\n/* DEPRECATED: button.ezMiniNormalButton */\nbutton.ezMiniNormalButton:enabled:active,\n/* DEPRECATED: button.miniNormalButton */\nbutton.miniNormalButton:enabled:active {\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-default-mini-ezClockerYellow\n        (DEPRECATED) button.ezMiniNormalButton\n        (DEPRECATED) button.miniNormalButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-default-mini-ezClockerYellow:disabled,\nbutton.ezButtons-default-mini-ezClockerYellow:disabled:hover,\n/* DEPRECATED: button.ezMiniNormalButton */\nbutton.ezMiniNormalButton:disabled,\nbutton.ezMiniNormalButton:disabled:hover,\n/* DEPRECATED: button.miniNormalButton */\nbutton.miniNormalButton:disabled,\nbutton.miniNormalButton:disabled:hover {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    border-color: var(--ezDarkYellow);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) button.ezDisabledMiniNormalButton\n        (DEPRECATED) button.disabledMiniNormalButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: button.disabledMiniNormalButton */\nbutton.ezDisabledMiniNormalButton,\nbutton.ezDisabledMiniNormalButton:disabled,\nbutton.ezDisabledMiniNormalButton:disabled:hover,\n/* DEPRECATED: button.disabledMiniNormalButton */\nbutton.disabledMiniNormalButton,\nbutton.disabledMiniNormalButton:disabled,\nbutton.disabledMiniNormalButton:disabled:hover {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    border-color: var(--ezDarkYellow);\n}\n\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezDialogButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezDialogButton {\n    padding: 18px;\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n    border-radius: 3px;\n}\n\nbutton.ezDialogButton:hover {\n    padding: 18px;\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n}\n\nbutton.ezDialogButton:active {\n    padding: 18px;\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n}\n\nbutton.ezDialogButton:disabled {\n    padding: 18px;\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: normal;\n}\n\nbutton.ezDisabledDialogButton {\n    padding: 18px;\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: normal;\n    border-radius: 3px;\n}\n\nbutton.ezWhiteDialogButton {\n    padding: 18px 24px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n    border-radius: 3px;\n}\n\nbutton.ezWhiteDialogButton:hover {\n    padding: 18px 24px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n}\n\nbutton.ezWhiteDialogButton:hover:active,\nbutton.ezWhiteDialogButton:active {\n    padding: 18px 24px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: bold;\n    box-shadow: var(--ezBoxShadow-inset-ezclocker-black-50);\n}\n\nbutton.ezWhiteDialogButton:disabled {\n    padding: 18px 24px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerStone);\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: normal;\n}\n\nbutton.ezDisabledWhiteDialogButton {\n    padding: 18px 24px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerStone);\n    vertical-align: middle;\n    font-size: 12pt;\n    font-weight: normal;\n    border-radius: 3px;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezMajorButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezMajorButton,\nbutton.ezMajorButton:enabled,\n/* DEPRECATED: button.majorButton */\nbutton.majorButton,\nbutton.majorButton:enabled {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    border-radius: 3px;\n}\n\nbutton.ezMajorButton:enabled:focus,\n/* DEPRECATED: button.majorButton */\nbutton.majorButton:enabled:focus {\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    background-color: var(--ezLightYellow);\n}\n\nbutton.ezMajorButton:enabled:hover,\nbutton.ezMajorButton:enabled:focus:hover,\n/* DEPRECATED: button.majorButton */\nbutton.majorButton:enabled:hover,\nbutton.majorButton:enabled:focus:hover {\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    background-color: var(--ezLightYellow);\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\n}\n\nbutton.ezMajorButton:enabled:active,\nbutton.ezMajorButton:enabled:active:hover,\nbutton.ezMajorButton:enabled:focus:active,\nbutton.ezMajorButton:enabled:focus:active:hover,\n/* DEPRECATED: button.majorButton */\nbutton.majorButton:enabled:active,\nbutton.majorButton:enabled:active:hover,\nbutton.majorButton:enabled:focus:active,\nbutton.majorButton:enabled:focus:active:hover {\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    background-color: var(--ezLightYellow);\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\n}\n\nbutton.ezMajorButton:disabled,\nbutton.ezMajorButton:disabled:hover,\nbutton.ezMajorButton:disabled:active,\n/* DEPRECATED: button.majorButton */\nbutton.majorButton:disabled,\nbutton.majorButton:disabled:hover,\nbutton.majorButton:disabled:active {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 10pt;\n    font-family: var(--ezButtons-font-family);\n    border-color: var(--ezDarkYellow);\n    cursor: default;\n    box-shadow: none;\n}\n\n/* DEPRECATED: button.ezDisabledMajorButton */\nbutton.ezDisabledMajorButton,\n/* DEPRECATED: button.disabledMajorButton */\nbutton.disabledMajorButton {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 10pt;\n    font-family: var(--ezButtons-font-family);\n    border-color: var(--ezDarkYellow);\n    cursor: default;\n    box-shadow: none;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezNormalButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezNormalButton {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: normal;\n    border-color: var(--ezClockerGray);\n    border-radius: 3px;\n}\n\nbutton.ezNormalButton:hover:enabled {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 12pt;\n    border-color: var(--ezClockerGray);\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\n}\n\nbutton.ezNormalButton:focus {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 12pt;\n    border-color: var(--ezClockerGray);\n}\n\nbutton.ezNormalButton:hover,\nbutton.ezNormalButton:hover:active {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 12pt;\n    border-color: var(--ezClockerGray);\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50)\n}\n\nbutton.ezNormalButton:disabled,\nbutton.ezNormalButton:disabled:hover,\nbutton.ezNormalButton:disabled:hover:active {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 12pt;\n    font-weight: normal;\n    border-color: var(--ezDarkYellow);\n    box-shadow: none;\n    cursor: default;\n}\n\nbutton.ezDisabledNormalButton {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 12pt;\n    border-color: var(--ezDarkYellow);\n    border-radius: 3px;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezNormalButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezDefaultNormalButton {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    border-radius: 3px;\n}\n\nbutton.ezDefaultNormalButton:hover:enabled {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\n}\n\nbutton.ezDefaultNormalButton:focus {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-size: 12pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n}\n\nbutton.ezDefaultNormalButton:hover,\nbutton.ezDefaultNormalButton:hover:active {\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    font-size: 12pt;\n    border-color: var(--ezClockerGray);\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\n}\n\nbutton.ezDefaultNormalButton:disabled,\nbutton.ezDefaultNormalButton:disabled:hover,\nbutton.ezDefaultNormalButton:disabled:active {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 12pt;\n    font-weight: normal;\n    border-color: var(--ezDarkYellow);\n    box-shadow: none;\n    cursor: default;\n}\n\nbutton.ezDisabledDefaultNormalButton {\n    background-color: var(--ezLightYellow);\n    color: var(--ezDarkYellow);\n    font-size: 12pt;\n    font-weight: normal;\n    border-color: var(--ezDarkYellow);\n    border-radius: 3px;\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezTealMajorButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezTealMajorButton {\n    background-color: var(--ezClockerTeal);\n    color: var(--ezTealContainerTextColor);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezTealBorder);\n    border-radius: 3px;\n}\n\nbutton.ezTealMajorButton:hover:enabled {\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezTealBorder);\n    background-color: var(--ezTealHover);\n    box-shadow: var(--ezTealBoxShadow);\n}\n\nbutton.ezTealMajorButton:focus {\n    color: var(--ezTealContainerTextColor);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezTealBorder);\n    background-color: var(--ezTealHover);\n}\n\nbutton.ezTealMajorButton:hover,\nbutton.ezTealMajorButton:hover:active {\n    color: var(--ezTealContainerTextColor);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezTealBorder);\n    background-color: var(--ezTealHover);\n    box-shadow: var(--ezTealInsetBoxShadow);\n}\n\nbutton.ezTealMajorButton:disabled,\nbutton.ezTealMajorButton:disabled:hover,\nbutton.ezTealMajorButton:disabled:active {\n    background-color: var(--ezDarkteal);\n    color: var(--ezTealContainerDisabledTextColor);\n    font-size: 10pt;\n    font-weight: normal;\n    border-color: var(--ezTealBorder);\n    box-shadow: none;\n    cursor: default;\n}\n\nbutton.ezTealMajorButtonDisabled {\n    background-color: var(--ezDarkteal);\n    color: var(--ezTealContainerDisabledTextColor);\n    font-size: 10pt;\n    font-weight: normal;\n    border-color: var(--ezTealBorder);\n    box-shadow: none;\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezWarningMajorButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezWarningMajorButton,\n/* DEPRECATED: button.warningMajorButton */\nbutton.warningMajorButton {\n    font-weight: bold;\n    background-color: #CE0F0C;\n    border-color: #A60400;\n    color: var(--ezClockerWhite);\n    border-radius: 3px;\n}\n\nbutton.ezWarningMajorButton:hover:enabled,\n/* DEPRECATED: button.warningMajorButton */\nbutton.warningMajorButton:hover:enabled {\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n}\n\nbutton.ezWarningMajorButton:hover:active,\n/* DEPRECATED: button.warningMajorButton */\nbutton.warningMajorButton:hover:active {\n    color: var(--ezClockerWhite);\n    background-color: #BF3330;\n}\n\nbutton.ezWarningMajorButton:disabled,\nbutton.ezWarningMajorButton:disabled:hover,\nbutton.ezWarningMajorButton:disabled:active\n\n/* DEPRECATED: button.warningMajorButton */\nbutton.warningMajorButton:disabled button.warningMajorButton:disabled:hover,\nbutton.warningMajorButton:disabled:active {\n    color: var(--ezClockerStone);\n    background-color: #FFf0f0;\n    border-color: var(--ezClockerStone);\n    font-weight: normal;\n    box-shadow: none;\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezDeleteMajorButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezDeleteMajorButton,\nbutton.ezDeleteMajorButton:enabled,\n/* DEPRECATED: button.deleteMajorButton */\nbutton.deleteMajorButton,\nbutton.deleteMajorButton:enabled {\n    margin: 0;\n    padding: 6px 24px;\n    background-color: var(--ezDarkAlertRed);\n    color: var(--ezClockerWhite);\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\nbutton.ezDeleteMajorButton:enabled:focus,\n/* DEPRECATED: button.deleteMajorButton */\nbutton.deleteMajorButton:enabled:focus {\n    margin: 0;\n    padding: 6px 24px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n}\n\nbutton.ezDeleteMajorButton:enabled:hover,\nbutton.ezDeleteMajorButton:enabled:focus:hover,\n/* DEPRECATED: button.deleteMajorButton */\nbutton.deleteMajorButton:enabled:hover,\nbutton.deleteMajorButton:enabled:focus:hover {\n    margin: 0;\n    padding: 6px 24px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezDeleteMajorButton:enabled:active,\nbutton.ezDeleteMajorButton:enabled:active:hover,\nbutton.ezDeleteMajorButton:enabled:focus:active,\nbutton.ezDeleteMajorButton:enabled:focus:active:hover,\n/* DEPRECATED: button.deleteMajorButton */\nbutton.deleteMajorButton:enabled:active,\nbutton.deleteMajorButton:enabled:active:hover,\nbutton.deleteMajorButton:enabled:focus:active,\nbutton.deleteMajorButton:enabled:focus:active:hover {\n    margin: 0;\n    padding: 6px 24px;\n    background-color: var(--ezDarkAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);\n}\n\nbutton.ezDeleteMajorButton:disabled,\nbutton.ezDeleteMajorButton:disabled:hover,\n/* DEPRECATED: button.deleteMajorButton */\nbutton.deleteMajorButton:disabled,\nbutton.deleteMajorButton:disabled:hover {\n    margin: 0;\n    padding: 6px 24px;\n    background-color: var(--ezHoverAlertRed);\n    color: var(--ezBorderAlertRed);\n    font-size: 10pt;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n    box-shadow: none;\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezWarningHeaderButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezWarningHeaderButton,\nbutton.warningHeaderButton {\n    vertical-align: middle;\n    color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-weight: bold;\n    background-color: #CE0F0C;\n    border-color: #BF3330;\n    border-radius: 3px;\n}\n\nbutton.ezWarningHeaderButton:hover:enabled,\nbutton.warningHeaderButton:hover:enabled {\n    background-color: var(--ezClockerAlertRed);\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezWarningHeaderButton:focus,\nbutton.warningHeaderButton:focus {\n    background-color: var(--ezClockerAlertRed);\n}\n\nbutton.ezWarningHeaderButton:hover:active,\nbutton.warningHeaderButton:hover:active {\n    box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.4);\n}\n\nbutton.ezWarningHeaderButton:disabled,\nbutton.warningHeaderButton:disabled {\n    color: #BF3330;\n    background-color: var(--ezClockerAlertRed);\n    border-color: #BF3330;\n    font-weight: normal;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezLargeToolButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezLargeToolButton {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\nbutton.ezLargeToolButton:hover,\nbutton.ezLargeToolButton:hover:enabled {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: var(--ezHoverNavy);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n}\n\nbutton.ezLargeToolButton:active,\nbutton.ezLargeToolButton:hover:active {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    box-shadow: inset 0 0 4px 2px rgba(6, 56, 97, 0.5);\n}\n\nbutton.ezLargeToolButton:disabled {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerSilver);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezLightNavy);\n    cursor: default;\n}\n\nbutton.disabledEzLargeToolButton {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: #063565;\n    color: #0d58a6;\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: #0d58a6;\n    cursor: default;\n    border-radius: 3px;\n}\n\nbutton.ezRedLargeToolButton {\n    padding: 2px;\n    margin: 1px;\n    min-width: 32px;\n    min-height: 32px;\n    max-height: 32px;\n    background-color: #ff7673;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: #a60400;\n    border-radius: 3px;\n}\n\nbutton.ezRedLargeToolButton:hover:enabled {\n    background-color: var(--ezClockerAlertRed);\n}\n\nbutton.ezRedLargeToolButton:hover:active {\n    background-color: #BF3330;\n}\n\nbutton.ezRedLargeToolButton:disabled {\n    background-color: var(--ezClockerOffWhite);\n    color: #808080;\n    border-color: var(--ezClockerStone);\n    cursor: default;\n}\n\n\n/*\n====================================================================================================================\n| [Class Group]\n| EzClocker Tool Buttons\n====================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy,\n.ezButtons-tool-navy:enabled,\n/* DEPRECATED .ezToolButton */\n.ezToolButton,\n.ezToolButton:enabled {\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy:enabled:focus,\n/* DEPRECATED .ezToolButton */\n.ezToolButton:enabled:focus {\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy:enabled:hover,\n.ezButtons-tool-navy:enabled:focus:hover,\n/* DEPRECATED .ezToolButton */\n.ezToolButton:enabled:hover,\n.ezToolButton:enabled:focus:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezHoverNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy:enabled:active,\n.ezButtons-tool-navy:enabled:active:hover,\n.ezButtons-tool-navy:enabled:focus:active,\n.ezButtons-tool-navy:enabled:focus:active:hover,\n/* DEPRECATED .ezToolButton */\n.ezToolButton:enabled:active,\n.ezToolButton:enabled:active:hover,\n.ezToolButton:enabled:focus:active,\n.ezToolButton:enabled:focus:active:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy:disabled,\n.ezButtons-tool-navy:disabled:hover,\n/* DEPRECATED .ezToolButton */\n.ezToolButton:disabled,\n.ezToolButton:disabled:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezHoverNavy);\n    opacity: 0.5;\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy-large\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy-large,\n.ezButtons-tool-navy-large:enabled {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy-large:enabled:focus {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy-large:enabled:hover,\n.ezButtons-tool-navy-large:enabled:focus:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezHoverNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy-large:enabled:active,\n.ezButtons-tool-navy-large:enabled:active:hover,\n.ezButtons-tool-navy-large:enabled:focus:active,\n.ezButtons-tool-navy-large:enabled:focus:active:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerNavy);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-navy\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-navy-large:disabled,\n.ezButtons-tool-navy-large:disabled:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezHoverNavy);\n    opacity: 0.5;\n    color: var(--ezBorderNavy);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: default;\n}\n\n\n\n.ezButtons-tool-stone-large,\n.ezButtons-tool-stone-large:enabled {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerStone);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerStone);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~-~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-stone\n        (DEPRECATED) .ezToolButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-stone-large:enabled:focus {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerStone);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerStone);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-stone\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-stone-large:enabled:hover,\n.ezButtons-tool-stone-large:enabled:focus:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezHoverStone);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderStone);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezButtons-tool-stone\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezButtons-tool-stone-large:enabled:active,\n.ezButtons-tool-stone-large:enabled:active:hover,\n.ezButtons-tool-stone-large:enabled:focus:active,\n.ezButtons-tool-stone-large:enabled:focus:active:hover {\n    padding: 2px;\n    margin: 1px;\n    min-width: 38px;\n    min-height: 38px;\n    max-height: 38px;\n    background-color: var(--ezClockerStone);\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 12pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderStone);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: auto;\n    outline-width: 1px;\n    outline-color: var(--ezNavy-alpha-50);\n    box-shadow: var(--ezBoxShadow-inset-ezNavy-50);\n    cursor: pointer;\n}\n\n\nbutton.ezRedToolButton,\nbutton.ezRedToolButton:enabled {\n    opacity: 1;\n    padding: 0;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n}\n\nbutton.ezRedToolButton:enabled:focus {\n    opacity: 1;\n    padding: 0;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    outline-width: 0;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\nbutton.ezRedToolButton:enabled:hover,\nbutton.ezRedToolButton:enabled:focus:hover {\n    opacity: 1;\n    padding: 0;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezLightAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    outline-width: 0;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\nbutton.ezRedToolButton:enabled:active,\nbutton.ezRedToolButton:enabled:active:hover,\nbutton.ezRedToolButton:enabled:focus:active,\nbutton.ezRedToolButton:enabled:focus:active:hover {\n    opacity: 1;\n    padding: 0;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezDarkAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    box-shadow:\n        0 0 1px 1px transparent,\n        inset 0 0 4px 2px var(--ezBorderAlertRed-alpha-50);\n    outline-width: 0;\n}\n\nbutton.ezRedToolButton:disabled,\nbutton.ezRedToolButton:disabled:hover {\n    opacity: 0.50;\n    padding: 0;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: var(--ezHoverAlertRed);\n    color: var(--ezClockerGray);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerGray);\n    cursor: default;\n}\n\n\nbutton.ezTransparentToolButton {\n    opacity: 1;\n    padding: 0;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: rgba(255, 255, 255, 0.2);\n}\n\nbutton.ezTransparentToolButton:hover:enabled {\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    border-color: var(--ezClockerWhite);\n}\n\nbutton.ezTransparentToolButton:focus button.ezTransparentToolButton:active {\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    border-color: var(--ezClockerWhite);\n    box-shadow: none;\n}\n\nbutton.ezTransparentToolButton:hover:active {\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    border-color: var(--ezClockerWhite);\n    box-shadow: inset 0 0 4px 2px rgba(255, 255, 255, 0.5);\n}\n\nbutton.ezTransparentToolButton:hover:disabled,\nbutton.ezTransparentToolButton:active:disabled,\nbutton.ezTransparentToolButton:disabled {\n    opacity: 0.50;\n    padding: 0;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    background-color: transparent;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: transparent;\n    cursor: default;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezButton-hidden-egg\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n.ezButton-hidden-egg {\n    padding: 4px;\n    margin: 0;\n    background-color: transparent;\n    min-width: 18px;\n    min-height: 18px;\n    color: transparent;\n    font-size: xx-small;\n    vertical-align: middle;\n    text-align: center;\n    border-style: none;\n    cursor: url('/secure/account/hack.cur'), auto;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezEditButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezEditButton,\nbutton.ezEditButton:enabled,\n/* DEPRECATED: editButton */\nbutton.editButton,\nbutton.editButton:enabled {\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezClockerYellow);\n    min-width: 75px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerBlack);\n    border-radius: 3px;\n}\n\nbutton.ezEditButton:enabled:focus,\n/* DEPRECATED: editButton */\nbutton.editButton:enabled:focus {\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezLightYellow);\n    min-width: 75px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerBlack);\n    border-radius: 3px;\n    outline-width: 0;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\nbutton.ezEditButton:enabled:hover,\nbutton.ezEditButton:enabled:focus:hover,\n/* DEPRECATED: editButton */\nbutton.editButton:enabled:hover,\nbutton.editButton:enabled:focus:hover {\n    padding: 4px;\n    margin: 1px;\n    min-width: 75px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    text-align: center;\n    font-size: 10pt;\n    vertical-align: middle;\n    box-shadow: 0 0 1px 1px var(--ezBoxShadow-ezclocker-gray-30);\n}\n\nbutton.ezEditButton:enabled:active,\nbutton.ezEditButton:enabled:active:hover,\nbutton.ezEditButton:enabled:focus:active,\nbutton.ezEditButton:enabled:focus:active:hover,\n/* DEPRECATED: editButton */\nbutton.editButton:enabled:active,\nbutton.editButton:enabled:active:hover,\nbutton.editButton:enabled:focus:active,\nbutton.editButton:enabled:focus:active:hover {\n    padding: 4px;\n    margin: 1px;\n    min-width: 75px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    text-align: center;\n    font-size: 10pt;\n    vertical-align: middle;\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\n}\n\nbutton.ezEditButton:disabled,\nbutton.ezEditButton:disabled:hover,\nbutton.ezEditButton:disabled:active,\n/* DEPRECATED: editButton */\nbutton.editButton:disabled,\nbutton.editButton:disabled:hover,\nbutton.editButton:disabled:active {\n    padding: 4px;\n    margin: 1px;\n    min-width: 75px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezBorderYellow);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderYellow);\n    cursor: default;\n}\n\nbutton.ezDisabledEditButton,\nbutton.disabledEditButton {\n    padding: 4px;\n    margin: 1px;\n    min-width: 75px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezBorderYellow);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderYellow);\n    cursor: default;\n    border-radius: 3px;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezEditButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezSquareEditButton {\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    padding-left: 3px;\n    margin: 1px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n}\n\nbutton.ezSquareEditButton:hover:enabled {\n    padding: 4px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezSquareEditButton:focus {\n    padding: 4px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n}\n\nbutton.ezSquareEditButton:hover:active {\n    padding: 4px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    border-color: var(--ezBorderYellow);\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\n}\n\nbutton.ezSquareEditButton:disabled {\n    padding: 4px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezBorderYellow);\n    font-size: 10pt;\n    border-color: var(--ezBorderYellow);\n    cursor: default;\n}\n\nbutton.ezDisabledSquareEditButton {\n    padding: 4px;\n    background-color: var(--ezLightYellow);\n    color: var(--ezBorderYellow);\n    font-size: 10pt;\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n    cursor: default;\n}\n\nimg.ezSquarEditButtonImg {\n    width: 20px;\n    height: 20px;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezButtons-edit-navy-24x24\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezButtons-edit-navy-24x24 {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\nbutton.ezButtons-edit-navy-24x24:hover:enabled {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezButtons-edit-navy-24x24:focus {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: middle;\n}\n\nbutton.ezButtons-edit-navy-24x24:hover:active {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\n}\n\nbutton.ezButtons-edit-navy-24x24:disabled {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    cursor: default;\n}\n\nbutton.ezButtons-edit-navy-24x24-disabled {\n    padding: 4px;\n    width: 24px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    cursor: default;\n}\n\nimg.ezButtons-square-img-24x24 {\n    padding: 0;\n    margin: 0;\n    text-align: center;\n    vertical-align: center;\n    width: 24px;\n    height: 24px;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezButtons-edit-navy-24x48\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezButtons-edit-navy-24x48 {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\nbutton.ezButtons-edit-navy-24x48:hover:enabled {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezButtons-edit-navy-24x48:focus {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    text-align: center;\n    vertical-align: middle;\n    font-size: 10pt;\n}\n\nbutton.ezButtons-edit-navy-24x48:hover:active {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\n}\n\nbutton.ezButtons-edit-navy-24x48:disabled {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    cursor: default;\n}\n\nbutton.ezButtons-edit-navy-24x48-disabled {\n    padding: 4px;\n    width: 48px;\n    height: 24px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    cursor: default;\n}\n\nimg.ezButtons-square-img-24xA {\n    padding: 0;\n    margin: 0;\n    text-align: center;\n    vertical-align: middle;\n    height: 24px;\n    width: auto;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezButtons-edit-navy-48x48\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezButtons-edit-navy-48x48 {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\nbutton.ezButtons-edit-navy-48x48:hover:enabled {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    box-shadow: 0 0 1px 1px rgba(109, 110, 112, 0.3);\n}\n\nbutton.ezButtons-edit-navy-48x48:focus {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: middle;\n}\n\nbutton.ezButtons-edit-navy-48x48:hover:active {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    box-shadow: inset 0 0 4px 2px rgba(198, 152, 0, 0.5);\n}\n\nbutton.ezButtons-edit-navy-48x48:disabled {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    cursor: default;\n}\n\nbutton.ezButtons-edit-navy-48x48-disabled {\n    padding: 4px;\n    width: 48px;\n    height: 48px;\n    background-color: var(--ezLightNavy);\n    color: var(--ezBorderNavy);\n    font-size: 10pt;\n    text-align: center;\n    vertical-align: center;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n    cursor: default;\n}\n\nimg.ezButtons-square-img-48xA {\n    padding: 0;\n    margin: 0;\n    height: 48px;\n    width: auto;\n    text-align: center;\n    vertical-align: center;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezDeleteEditButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n.ezButtons-delete-button {\n    padding: 4px;\n    margin: 1px;\n    background-color: #ff7673;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: #a60400;\n    border-radius: 3px;\n}\n\n.ezButtons-delete-button:hover:enabled {\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n}\n\n.ezButtons-delete-button:hover:active {\n    padding: 4px;\n    margin: 1px;\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    background-color: #BF3330;\n}\n\n.ezButtons-delete-button:disabled {\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezClockerOffWhite);\n    color: #808080;\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezClockerStone);\n    cursor: default;\n}\n\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezDeleteEditButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezDeleteEditButton,\nbutton.ezDeleteEditButton:enabled {\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\nbutton.ezDeleteEditButton:enabled:focus {\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezLightAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n    outline-width: 0;\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\nbutton.ezDeleteEditButton:enabled:hover,\nbutton.ezDeleteEditButton:enabled:focus:hover {\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezLightAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\nbutton.ezDeleteEditButton:enabled:active,\nbutton.ezDeleteEditButton:enabled:active:hover,\nbutton.ezDeleteEditButton:enabled:focus:active,\nbutton.ezDeleteEditButton:enabled:focus:active:hover {\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezDarkAlertRed);\n    color: var(--ezClockerWhite);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n}\n\nbutton.ezDeleteEditButton:disabled,\nbutton.ezDeleteEditButton:disabled:hover,\nbutton.ezDeleteEditButton:disabled:active {\n    opacity: 50%;\n    width: 28px;\n    height: 28px;\n    padding: 4px;\n    margin: 1px;\n    background-color: var(--ezLightAlertRed);\n    color: var(--ezBorderAlertRed);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderAlertRed);\n    border-radius: 3px;\n    cursor: default;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezMiniActionButton styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezMiniActionButton,\nbutton.miniActionButton {\n    opacity: 1;\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezSilver);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: pointer;\n    border-radius: 3px;\n}\n\nbutton.ezMiniActionButton:enabled:hover,\nbutton.miniActionButton:enabled:hover {\n    opacity: 1;\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezLightSilver);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 10pt;\n    box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.3);\n}\n\nbutton.ezMiniActionButton:enabled:focus,\nbutton.miniActionButton:enabled:focus {\n    opacity: 1;\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezLightSilver);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 10pt;\n    outline-color: var(--ezClockerSilver-alpha-50);\n}\n\nbutton.miniActionButton:enabled:active,\nbutton.ezMiniActionButton:enabled:active:hover,\nbutton.miniActionButton:enabled:active:hover {\n    opacity: 1;\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezSilver);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 10pt;\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.5)\n}\n\nbutton.ezMiniActionButton:disabled,\nbutton.ezMiniActionButton:disabled:active,\nbutton.ezMiniActionButton:disabled:active:hover,\nbutton.ezMiniActionButton:disabled:hover,\nbutton.miniActionButton:disabled,\nbutton.miniActionButton:disabled:hover,\nbutton.miniActionButton:disabled:active,\nbutton.miniActionButton:disabled:active:hover {\n    padding: 2px;\n    margin: 0;\n    background-color: rgba(224, 224, 224, 0.5);\n    color: var(--ezClockerBlack);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n\n    /*\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerStone);\n    font-size: 10pt;\n    font-weight: normal;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n    */\n}\n\nbutton.ezDisabledMiniActionButton,\nbutton.disabledMiniActionButton {\n    opacity: 0.8;\n    padding: 2px;\n    margin: 0;\n    background-color: var(--ezClockerGray);\n    color: var(--ezClockerStone);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezSilverActionButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezSilverActionButton {\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: pointer;\n    border-radius: 3px;\n}\n\nbutton.ezSilverActionButton:hover,\nbutton.ezSilverActionButton:hover:enabled {\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    font-size: 10pt;\n    box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);\n    cursor: pointer;\n}\n\nbutton.ezSilverActionButton:focus {\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    font-size: 10pt;\n    cursor: pointer;\n}\n\nbutton.ezSilverActionButton:active,\nbutton.ezSilverActionButton:hover:active {\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-weight: bold;\n    font-size: 10pt;\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);\n    cursor: pointer;\n}\n\nbutton.ezSilverActionButton:disabled {\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezBorderSilver);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n}\n\nbutton.ezDisabledSilverActionButton {\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezBorderSilver);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n}\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezSilverEditButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezSilverEditButton,\nbutton.silverEditButton {\n    padding: 2px 4px;\n    margin: 0;\n    margin-right: 2px;\n    background-color: var(--ezClockerSilver);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderSilver);\n    cursor: pointer;\n    border-radius: 3px;\n}\n\nbutton.ezSilverEditButton:focus,\nbutton.ezSilverEditButton:hover:enabled,\nbutton.silverEditButton:hover:enabled {\n    padding: 2px 4px;\n    margin: 0;\n    margin-right: 2px;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    box-shadow: 0 0 1px 1px rgba(224, 224, 224, 0.3);\n}\n\nbutton.ezSilverEditButton:active,\nbutton.ezSilverEditButton:active:focus,\nbutton.ezSilverEditButton:hover,\nbutton.ezSilverEditButton:hover:active,\nbutton.ezSilverEditButto:hover:active {\n    padding: 2px 4px;\n    margin: 0;\n    margin-right: 2px;\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.8);\n}\n\nbutton.ezSilverEditButton:disabled,\nbutton.silverEditButton:disabled {\n    padding: 2px 4px;\n    margin: 0;\n    margin-right: 2px;\n    background-color: var(--ezClockerOffWhite);\n    color: var(--ezBorderSilver);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderSilver);\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezMiniDeleteActionButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezMiniDeleteActionButton,\nbutton.miniDeleteActionButton {\n    font-size: 8pt;\n    font-weight: bold;\n    padding: 2px;\n    margin: 0;\n    color: var(--ezClockerWhite);\n    background-color: #CE0F0C;\n    border-color: #A60400;\n    cursor: pointer;\n    border-radius: 3px;\n}\n\nbutton.ezMiniDeleteActionButton:hover:enabled,\nbutton.miniDeleteActionButton:hover:enabled {\n    background-color: var(--ezClockerAlertRed);\n    color: var(--ezClockerWhite);\n}\n\nbutton.ezMiniDeleteActionButton:hover:active,\nbutton.miniDeleteActionButton:hover:active {\n    background-color: #BF3330;\n}\n\nbutton.ezMiniDeleteActionButton:disabled,\nbutton.miniDeleteActionButtonn:disabled {\n    color: var(--ezClockerStone);\n    background-color: #FFf0f0;\n    border-color: var(--ezClockerStone);\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezButtons-quick-help\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n.ui-widget button.ezButtons-quick-help,\n.ezButtons-quick-help {\n    margin-top: 2px;\n    margin-right: 1px;\n    margin-bottom: 2px;\n    margin-left: 1px;\n    padding-left: 25px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    opacity: 1;\n    background-color: transparent;\n    background-image: url('/public/images/icons/info.svg');\n    background-position: 4px center;\n    background-repeat: no-repeat;\n    background-size: 18px;\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: transparent;\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    cursor: pointer;\n}\n\n.ui-widget button.ezButtons-quick-help:hover,\n.ui-widget button.ezButtons-quick-help:focus,\n.ui-widget button.ezButtons-quick-help:focus:hover,\n.ui-widget button.ezButtons-quick-help:enabled:hover,\n.ezButtons-quick-help:hover,\n.ezButtons-quick-help:focus,\n.ezButtons-quick-help:focus:hover,\n.ezButtons-quick-help:enabled:hover {\n    margin: 4px;\n    padding-left: 25px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    opacity: 1;\n    background-color: transparent;\n    background-image: url('/public/images/icons/info.svg');\n    background-position: 4px center;\n    background-repeat: no-repeat;\n    background-size: 18px;\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezClockerSilver);\n    border-style: dashed;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n.ui-widget button.ezButtons-quick-help:active,\n.ui-widget button.ezButtons-quick-help:active:hover,\n.ezButtons-quick-help:active,\n.ezButtons-quick-help:active:hover {\n    margin: 4px;\n    padding-left: 25px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    opacity: 1;\n    background-color: transparent;\n    background-image: url('/public/images/icons/info.svg');\n    background-position: 4px center;\n    background-repeat: no-repeat;\n    background-size: 18px;\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: 10pt;\n    border-color: var(--ezClockerGray);\n    border-style: dashed;\n    border-width: 1px;\n    border-radius: 3px;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\n.ui-widget.button.ezButtons-quick-help:disabled,\n.ezButtons-quick-help:disabled {\n    margin: 4px;\n    padding-left: 25px;\n    padding-top: 4px;\n    padding-right: 4px;\n    padding-bottom: 4px;\n    opacity: 1;\n    background-color: transparent;\n    background-image: url('/public/images/icons/info.svg');\n    background-position: 4px center;\n    background-repeat: no-repeat;\n    background-size: 18px;\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    font-size: 10pt;\n    border-style: none;\n    cursor: pointer;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Default Action Buttons\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezActionGreen\n        (DEPRECATED) button.ezActionButton\n        (DEPRECATED) button.actionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezActionGreen,\nbutton.ezButtons-action-ezActionGreen:enabled,\n/* DEPRECATED: button.ezActionButton */\nbutton.ezActionButton,\nbutton.ezActionButton:enabled,\n/* DEPRECATED: button.actionButton */\nbutton.actionButton,\nbutton.actionButton:enabled {\n    padding: 6px 24px;\n    margin: 0;\n    background-color: var(--ezClockerActionGreen);\n    font-size: 14pt;\n    font-weight: bold;\n    border-color: var(--ezActionGreenBorderColor);\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Focus]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezActionGreen\n        (DEPRECATED) button.ezActionButton\n        (DEPRECATED) button.actionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezActionGreen:enabled:focus,\n/* DEPRECATED: button.ezActionButton */\nbutton.ezActionButton:enabled:focus,\n/* DEPRECATED: button.actionButton */\nbutton.actionButton:enabled:focus {\n    outline-color: var(--ezActionGreen-alpha-50);\n    outline-style: auto;\n    outline-width: 1px;\n    outline-offset: 2px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Hover and Active Hover]:\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezActionGreen\n        (DEPRECATED) button.ezActionButton\n        (DEPRECATED) button.actionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezActionGreen:enabled:hover,\nbutton.ezButtons-action-ezActionGreen:enabled:focus:hover,\n/* DEPRECATED: button.ezActionButton */\nbutton.ezActionButton:enabled:hover,\nbutton.ezActionButton:enabled:focus:hover,\n/* DEPRECATED: button.actionButton */\nbutton.actionButton:enabled:hover,\nbutton.actionButton:enabled:focus:hover {\n    font-size: 14pt;\n    font-weight: bold;\n    background-color: var(--ezActionGreenHoverColor);\n    box-shadow: var(--ezBoxShadow-ezGray-30);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezActionGreen\n        (DEPRECATED) button.ezActionButton\n        (DEPRECATED) button.actionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezActionGreen:enabled:active,\nbutton.ezButtons-action-ezActionGreen:enabled:active:hover,\nbutton.ezButtons-action-ezActionGreen:enabled:focus:active,\nbutton.ezButtons-action-ezActionGreen:enabled:focus:active:hover,\n/* DEPRECATED: button.ezActionButton */\nbutton.ezActionButton:enabled:active,\nbutton.ezActionButton:enabled:active:hover,\nbutton.ezActionButton:enabled:focus:active,\nbutton.ezActionButton:enabled:focus:active:hover,\n/* DEPRECATED: button.actionButton */\nbutton.actionButton:enabled:active,\nbutton.actionButton:enabled:active:hover,\nbutton.actionButton:enabled:focus:active,\nbutton.actionButton:enabled:focus:active:hover {\n    font-size: 14pt;\n    font-weight: bold;\n    background-color: var(--ezActionGreenHoverColor);\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-80);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezActionGreen\n        (DEPRECATED) button.ezActionButton\n        (DEPRECATED) button.actionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezActionGreen:disabled,\nbutton.ezButtons-action-ezActionGreen:disabled:hover,\n/* DEPRECATED: button.ezActionButton */\nbutton.ezActionButton:disabled,\nbutton.ezActionButton:disabled:hover,\n/* DEPRECATED: button.actionButton */\nbutton.actionButton:disabled,\nbutton.actionButton:disabled:hover {\n    background-color: var(--ezActionGreenHoverColor);\n    color: var(--ezActionGreenBorderColor);\n    font-size: 14pt;\n    font-weight: normal;\n    border-color: var(--ezActionGreenBorderColor);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        (DEPRECATED) button.ezDisabledActionButton\n        (DEPRECATED) button.disabledActionButton\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n/* DEPRECATED: button.ezDisabledActionButton */\nbutton.ezDisabledActionButton,\nbutton.ezDisabledActionButton:disabled,\nbutton.ezDisabledActionButton:disabled:hover,\n/* DEPRECATED: button.disabledActionButton */\nbutton.disabledActionButton,\nbutton.disabledActionButton:disabled,\nbutton.disabledActionButton:disabled:hover {\n    background-color: var(--ezActionGreenHoverColor);\n    color: var(--ezActionGreenBorderColor);\n    font-weight: normal;\n    border-color: var(--ezActionGreenBorderColor);\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezClockerYellow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezClockerYellow,\nbutton.ezButtons-action-ezClockerYellow:enabled {\n    padding: 6px 24px;\n    margin: 0;\n    background-color: var(--ezClockerYellow);\n    font-size: 14pt;\n    font-weight: bold;\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Focus]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezClockerYellow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezClockerYellow:enabled:focus {\n    font-size: 14pt;\n    font-weight: bold;\n    background-color: var(--ezHoverYellow);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Hover and Active Hover]:\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezClockerYellow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezClockerYellow:enabled:hover,\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:hover {\n    font-size: 14pt;\n    font-weight: bold;\n    background-color: var(--ezHoverYellow);\n    box-shadow: var(--ezBoxShadow-ezGray-30);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezClockerYellow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezClockerYellow:enabled:active,\nbutton.ezButtons-action-ezClockerYellow:enabled:active:hover,\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:active,\nbutton.ezButtons-action-ezClockerYellow:enabled:focus:active:hover {\n    font-size: 14pt;\n    font-weight: bold;\n    box-shadow: var(--ezBoxShadow-inset-ezDarkYellow-50);\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        button.ezButtons-action-ezClockerYellow\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nbutton.ezButtons-action-ezClockerYellow:disabled,\nbutton.ezButtons-action-ezClockerYellow:disabled:hover {\n    background-color: var(--ezHoverYellow);\n    color: var(--ezBorderYellow);\n    font-size: 14pt;\n    font-weight: normal;\n    border-color: var(--ezBorderYellow);\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezActionButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezNavyActionButton {\n    padding: 6px 24px;\n    margin: 0;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezNavyContainerTextColor);\n    font-weight: bold;\n    border-color: var(--ezBorderNavy);\n    border-radius: 3px;\n}\n\nbutton.ezNavyActionButton:hover:enabled {\n    font-weight: bold;\n    background-color: var(--ezHoverNavy);\n}\n\nbutton.ezNavyActionButton:focus {\n    font-weight: bold;\n    background-color: var(--ezHoverNavy);\n}\n\nbutton.ezNavyActionButton:hover:active {\n    font-weight: bold;\n    box-shadow: var(--ezNavyInsetShadow);\n}\n\nbutton.ezNavyActionButton:disabled {\n    background-color: var(--ezLightNavy);\n    border-color: var(--ezClockerNavy);\n    font-weight: normal;\n    color: var(--ezNavyContainerDisabledTextColor);\n    cursor: default;\n}\n\nbutton.ezDisabledNavyActionButton {\n    background-color: var(--ezLightNavy);\n    border-color: var(--ezBorderNavy);\n    font-weight: normal;\n    color: var(--ezNavyContainerDisabledTextColor);\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezInvisibleButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezInvisibleButtonLink {\n    padding: 0;\n    margin: 0;\n    background-color: transparent;\n    color: transparent;\n    text-decoration: none;\n    border-color: transparent;\n    border-style: none;\n    cursor: pointer;\n}\n\nbutton.ezInvisibleButtonLink:disabled {\n    opacity: 50%;\n    background-color: var(--ezClockerGrayRGB);\n    cursor: default;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezSuperActionButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezSuperActionButton,\nbutton.superActionButton {\n    margin: 0;\n    background-color: var(--ezClockerNavy);\n    border-color: var(--ezClockerGray);\n    color: var(--ezClockerWhite);\n    font-weight: bold;\n    font-size: 18pt;\n    padding: 6px 24px;\n    border-radius: 3px;\n}\n\nbutton.ezSuperActionButton:hover:enabled,\nbutton.superActionButton:hover:enabled {\n    background-color: #0d58a6;\n}\n\nbutton.ezSuperActionButton:hover:active,\nbutton.superActionButton:hover:active {\n    background-color: #0d58a6;\n}\n\nbutton.ezSuperActionButton:disabled,\nbutton.superActionButton:disabled {\n    cursor: default;\n    background-color: #5387bd;\n    border-color: var(--ezClockerNavy);\n    font-weight: normal;\n    color: var(--ezClockerNavy);\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezWizardNavButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezWizardNavButton {\n    /* font-family: var(--ezFontFamily); */\n    font-family: var(--ezButtons-font-family);\n    font-weight: bold;\n    border-radius: 3px;\n}\n\nbutton.ezWizardHiddenNavButton {\n    /* font-family: var(--ezFontFamily); */\n    font-family: var(--ezButtons-font-family);\n    display: none;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| ezWizardActionButton Styles\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\nbutton.ezWizardActionButton {\n    /* background-color: var(--ezClockerHotGreen); */\n    background-color: var(--ezDarkHotGreen);\n\n    /* font-family: var(--ezFontFamily); */\n    font-family: var(--ezButtons-font-family);\n    font-weight: bold;\n\n    /* color: var(--ezHotGreenContainerFontColor) */\n    color: var(--ezClockerBlack);\n\n    /* border-color: var(--ezBorderHotGreen); */\n    border-color: var(--ezBorderHotGreen);\n    border-radius: 3px;\n}\n\nbutton.ezWizardHiddenActionButton {\n    /* font-family: var(--ezFontFamily); */\n    font-family: var(--ezButtons-font-family);\n    display: none;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| DIV Button\n| HTML Tags: <div/>\n|-------------------------------------------------\n| Template: ezDivButton_{name}-{size}-{color}\n|\n| Official Classes:\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"\")\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"UNSELECTED\")\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"SELECTED\")\n|\n| Deprecated Classes:\n|   ez-navy-left-nav-button (data-state=\"\")\n|   ez-navy-left-nav-button (data-state=\"UNSELECTED\")\n|   ez-navy-left-nav-button (data-state=\"SELECTED\")\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n\n/* -------------------------------------------------\n| [DIV Button]\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"\")\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"\")\n------------------------------------------------- */\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"\"],\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"] {\n    padding-left: 8px;\n    padding-top: 14px;\n    padding-right: 24px;\n    padding-bottom: 15px;\n    margin: 0;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 12pt;\n    font-weight: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-right-style: none;\n    border-color: var(--ezClockerNavy);\n    outline-color: var(--ezClockerBlack);\n    outline-width: 0;\n    outline-style: groove;\n    text-align: left;\n    cursor: pointer;\n    border-top-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:hover {\n    background-color: var(--ezClockerLightNavy);\n    color: var(--ezClockerWhite);\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:focus {\n    background-color: var(--ezClockerLightNavy);\n    color: var(--ezClockerWhite);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active,\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active:focus,\n.ez-navy-left-nav-button[data-state=\"\"]:enabled:active:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:active,\n.ezDivButton_LeftNavv-normal-ezClockerNavy[data-state=\"\"]:enabled:active:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:enabled:active:hover {\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"\"]:disabled,\n.ez-navy-left-nav-button[data-state=\"\"]:disabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:disabled,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"\"]:disabled:hover {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerGray);\n    cursor: default;\n}\n\n/* -------------------------------------------------\n| [DIV Button]\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"UNSELECTED\")\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"UNSELECTED\")\n------------------------------------------------- */\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"],\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"] {\n    padding-left: 8px;\n    padding-top: 14px;\n    padding-right: 24px;\n    padding-bottom: 15px;\n    margin: 0;\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 12pt;\n    font-weight: normal;\n    border-width: 1px;\n    border-style: solid;\n    border-right-style: none;\n    border-color: var(--ezClockerNavy);\n    outline-color: var(--ezClockerBlack);\n    outline-width: 0;\n    outline-style: groove;\n    text-align: left;\n    cursor: pointer;\n    border-radius: 3px;\n    border-top-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:hover {\n    background-color: var(--ezClockerLightNavy);\n    color: var(--ezClockerWhite);\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:focus {\n    background-color: var(--ezClockerLightNavy);\n    color: var(--ezClockerWhite);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active,\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active:focus,\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:enabled:active:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:enabled:active:hover {\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    box-shadow: inset 0 0 4px 2px var(--ezDarkNavyAlpha);\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:disabled,\n.ez-navy-left-nav-button[data-state=\"UNSELECTED\"]:disabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:disabled,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"UNSELECTED\"]:disabled:hover {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerGray);\n    font-weight: bold;\n    cursor: default;\n}\n\n/* -------------------------------------------------\n| [DIV Button]\n|   ezDivButton_LeftNav-normal-ezClockerNavy (data-state=\"SELECTED\")\n|   (DEPRECATED) ez-navy-left-nav-button (data-state=\"SELECTED\")\n------------------------------------------------- */\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"SELECTED\"],\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"] {\n    padding-left: 8px;\n    padding-top: 14px;\n    padding-right: 24px;\n    padding-bottom: 15px;\n    margin: 0;\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 12pt;\n    font-weight: bold;\n    border-width: 1px;\n    border-style: solid;\n    border-right-style: none;\n    border-color: var(--ezClockerNavy);\n    outline-color: var(--ezClockerBlack);\n    outline-width: 0;\n    outline-style: groove;\n    text-align: left;\n    cursor: pointer;\n    border-top-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 0;\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:hover,\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:focus,\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active,\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active:focus,\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:enabled:active:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active:focus,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:enabled:active:hover {\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 12pt;\n    font-weight: bold;\n    border-width: 1px;\n    border-style: solid;\n    border-right-style: none;\n    border-color: var(--ezClockerNavy);\n    border-top-right-radius: 0;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 0;\n    outline-color: var(--ezClockerBlack);\n    outline-width: 0;\n    outline-style: groove;\n    text-align: left;\n    cursor: pointer;\n}\n\n/* DEPRECATED: .ez-navy-left-nav-button */\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:disabled,\n.ez-navy-left-nav-button[data-state=\"SELECTED\"]:disabled:hover,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:disabled,\n.ezDivButton_LeftNav-normal-ezClockerNavy[data-state=\"SELECTED\"]:disabled:hover {\n    background-color: var(--ezClockerWhite);\n    color: var(--ezClockerGray);\n    font-weight: bold;\n    cursor: default;\n}\n\n/* -------------------------------------------------\n| [DIV Button]\n|   ezDivButton_Menu-normal-ezClockerOrange\n|   (DEPRECATED) div.ezMenuButton\n------------------------------------------------- */\n/* DEPRECATED: div.ezMenuButton */\ndiv.ezMenuButton,\n.ezDivButton_Menu-normal-ezClockerOrange {\n    background-color: var(--ezClockerOrange);\n    font-family: var(--ezButtons-font-family);\n    color: var(--ezClockerWhite);\n    border-style: solid;\n    border-color: var(--ezBorderOrange);\n    border-width: 1px;\n    border-radius: 3px;\n}\n\n/* DEPRECATED: div.ezMenuButton */\ndiv.ezMenuButton:hover:enabled,\n.ezDivButton_Menu-normal-ezClockerOrange:hover:enabled {\n    background-color: var(--ezHoverOrange);\n}\n\n/* DEPRECATED: div.ezMenuButton */\ndiv.ezMenuButton:hover:active,\n.ezDivButton_Menu-normal-ezClockerOrange:hover:active {\n    border-width: 1px;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Button Content\n| HTML Tags: <div/>,<label/>,<span/>\n|-------------------------------------------------\n| Template: ezButtonContent_{name}-{size}-{color}\n|\n| Official Classes:\n|   ezButtonContent_SubLabel-normal-black\n|\n| Deprecated Classes:\n|   ezButtonSubLabel\n|   buttonSubLabel\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n/* DEPRECATED: label.ezButtonSubLabel */\nlabel.ezButtonSubLabel,\n/* DEPRECATED: label.buttonSubLabel */\nlabel.buttonSubLabel {\n    font-weight: normal;\n}\n\n.ezButtonContent_SubLabel-normal-black {\n    color: var(--ezClockerBlack);\n    font-size: 12px;\n    font-weight: normal;\n}\n\nlabel.ezEditButtonLabel,\n.ezButtonContent_EditLabel-small-black {\n    padding-left: 4px;\n    padding-right: 2px;\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 10pt;\n    cursor: pointer;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Button Images\n| HTML Tags: <img/>\n|-------------------------------------------------\n| Template: ezButtonImage_{size}\n|\n| Official Classes:\n|   ezButtonImage_16x16\n|   ezButtonImage_24x24\n|   ezBtnImage_24xA\n|\n| Deprecated Classes:\n|   ezEditButtonImage\n|   ezLargeEditButtonImage\n|   ezMiniButtonImg\n|   miniButtonIcon\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n/* DEPRECATED: img.ezEditButtonImage */\nimg.ezEditButtonImage,\nimg.ezButtonImage_16x16 {\n    margin: 0;\n    padding: 0;\n    height: 16px;\n    width: 16px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezButtonImage-disable_16x16 {\n    opacity: .5;\n    margin: 0;\n    padding: 0;\n    height: 16px;\n    width: 16px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezEditButtonImage_18x18 {\n    margin: 0;\n    padding: 0;\n    height: 18px;\n    width: 18px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezEditButtonImage-disable_18x18 {\n    opacity: .5;\n    margin: 0;\n    padding: 0;\n    height: 18px;\n    width: 18px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezEditButtonImage_20x20 {\n    margin: 0;\n    padding: 0;\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezEditButtonImage-disable_20x20 {\n    opacity: .5;\n    margin: 0;\n    padding: 0;\n    height: 20px;\n    width: 20px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n/* DEPRECATED: img.ezLargeEditButtonImage */\nimg.ezLargeEditButtonImage,\nimg.ezButtonImage_24x24 {\n    margin: 0;\n    padding: 0;\n    height: 24px;\n    width: 24px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezButtonImage-disable_24x24 {\n    opacity: .5;\n    margin: 0;\n    padding: 0;\n    height: 24px;\n    width: 24px;\n    text-align: center;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\nimg.ezMiniButtonImg,\nimg.miniButtonIcon,\nimg.ezBtnImage_24xA {\n    box-sizing: border-box;\n    padding-right: 4px;\n    width: 24px;\n    vertical-align: middle;\n    border-style: none;\n}\n\n\n/* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n| Select Button\n| HTML Tags: <select/>\n|-------------------------------------------------\n| Template: ezSelectButton_{name}-{size}-{color}\n|\n| Official Classes:\n|   ezSelectButton_Default-normal-ezClockerOrange\n|\n| Deprecated Classes:\n|   ezMajorSelectButton\n~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n/* DEPRECATED: select.ezMajorSelectButton */\nselect.ezMajorSelectButton,\nselect.ezSelectButton_Default-normal-ezClockerYellow {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezClockerGray);\n    border-radius: 3px;\n\n    /*\n    margin: 2px;\n    padding: 6px 24px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 10pt;\n    font-weight: bold;\n    border-color: var(--ezBorderYellow);\n    border-radius: 3px;\n    border-style: solid;\n    border-width: 1px;\n    outline-width: 0;\n    cursor: pointer;\n    */\n}\n\n/* DEPRECATED: select.ezMajorSelectButton */\nselect.ezMajorSelectButton:hover:enabled,\nselect.ezSelectButton_Default-normal-ezClockerOrange:hover:enabled {\n    background-color: var(--ezLightYellow);\n    box-shadow: var(--ezBoxShadowStone);\n}\n\n/* DEPRECATED: select.ezMajorSelectButton */\nselect.ezMajorSelectButton:hover:active,\nselect.ezSelectButton_Default-normal-ezClockerOrange:hover:active {\n    box-shadow: var(--ezBoxShadowDarkYellow);\n}\n\n/* DEPRECATED: select.ezMajorSelectButton */\nselect.ezMajorSelectButton:disabled,\nselect.ezSelectButton_Default-normal-ezClockerOrange:disabled {\n    background-color: var(--ezExtraLightYellow);\n    color: var(--ezDarkYellow);\n    border-color: var(--ezDarkYellow);\n}\n\n/* DEPRECATED: select.ezMajorSelectButton */\nselect.ezMajorSelectButton:focus,\nselect.ezSelectButton_Default-normal-ezClockerOrange:focus {\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    Select/Drop Down/Menu Buttons\n    ##########################################################################################################################################################\n    Name Templates:\n        ezSelectButton-{name}-{color}\n        ezSelectButton-{name}-{other-properties}-color}\n        ezDropDownButton-{name}-{color}\n        ezDropDownButton-{name}-{other-properties}-color}\n        ezMenuButton-{name}-{color}\n        ezMenuButton-{name}-{other-properties}-color}\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Select Buttons\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-default-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-default-ezClockerOrange,\nselect.ezSelectButton-default-ezClockerOrange:enabled {\n    padding: 5px 24px;\n    margin: 2px;\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtons-font-family);\n    font-size: 10pt;\n    font-weight: bold;\n    text-align: center;\n    vertical-align: middle;\n    border-color: var(--ezBorderYellow);\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 3px;\n    box-shadow: 0 0 1px 1px transparent;\n    outline-style: none;\n    cursor: pointer;\n    height: 29px;\n    width: 161px;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Focus]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-default-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-default-ezClockerOrange:enabled:focus {\n    background-color: var(--ezHoverYellow);\n    color: var(--ezClockerBlack);\n    box-shadow: 0 0 1px 1px transparent;\n    outline-color: var(--ezBorderYellow);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class State Definition: Enabled Hover and Active Hover]:\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-default-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-default-ezClockerOrange:enabled:hover,\nselect.ezSelectButton-default-ezClockerOrange:enabled:focus:hover {\n    background-color: var(--ezHoverYellow);\n    color: var(--ezClockerBlack);\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\n    outline-color: var(--ezBorderYellow);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-default-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-default-ezClockerOrange:enabled:active,\nselect.ezSelectButton-default-ezClockerOrangeenabled:active:hover,\nselect.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active,\nselect.ezSelectButton-default-ezClockerOrangeenabled:enabled:focus:active:hover {\n    background-color: var(--ezClockerYellow);\n    color: var(--ezClockerBlack);\n    box-shadow:\n        0 0 1px 1px transparent,\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\n    outline-color: var(--ezBorderYellow);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-default-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-default-ezClockerOrange:disabled,\nselect.ezSelectButton-default-ezClockerOrange:disabled:hover {\n    background-color: var(--ezHoverYellow);\n    color: var(--ezBorderYellow);\n    border-color: var(--ezClockerYellow);\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        select.ezSelectButton-header-ezClockerOrange\n        (DEPRECATED) select.ezSelectButton-major-ezClockerOrange\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\nselect.ezSelectButton-header-ezClockerOrange,\nselect.ezSelectButton-header-ezClockerOrange:enabled,\n/* DEPRECATED: select.ezSelectButton-major-ezClockerOrange */\nselect.ezSelectButton-major-ezClockerOrange,\nselect.ezSelectButton-major-ezClockerOrange:enabled {\n    padding: 4px;\n    margin: 2px;\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtonFontFamily);\n    font-size: 12pt;\n    font-weight: bold;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderOrange);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-width: 0;\n    cursor: pointer;\n}\n\nselect.ezSelectButton-header-ezClockerOrange:hover:enabled,\nselect.ezSelectButton-major-ezClockerOrange:hover:enabled {\n    background-color: var(--ezLightOrange);\n    box-shadow: var(--ezBoxShadowStone);\n}\n\nselect.ezSelectButton-header-ezClockerOrange:hover:active,\nselect.ezSelectButton-major-ezClockerOrange:hover:active {\n    box-shadow: var(--ezBoxShadowDarkOrnage);\n}\n\nselect.ezSelectButton-header-ezClockerOrange:focus,\nselect.ezSelectButton-major-ezClockerOrange:focus {\n    box-shadow: var(--ezFocusBoxShadowBlack);\n}\n\nselect.ezSelectButton-header-ezClockerOrange:disabled,\nselect.ezSelectButton-major-ezClockerOrange:disabled {\n    background-color: var(--ezLightOrange);\n    color: var(--ezDarkOrange);\n    border-color: var(--ezDarkOrange);\n    font-weight: normal;\n}\n\noption.ezSelectButton-option-title,\noption.ezSelectButton-option-title:hover,\noption.ezSelectButton-option-title:active,\noption.ezSelectButton-option-title:disabled,\noption.ezSelectButton-option-title:focus {\n    background-color: var(--ezClockerNavy);\n    color: var(--ezClockerWhite);\n    font-size: 12pt;\n    font-weight: bold;\n    text-align: center;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n    cursor: default;\n}\n\noption.ezSelectButton-option {\n    font-size: 12pt;\n    text-align: left;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n    cursor: pointer;\n}\n\noption.ezSelectButton-option:hover option.ezSelectButton-option:focus option.ezSelectButton-option:active {\n    background-color: var(--ezClockerStone);\n    font-weight: bold;\n    cursor: pointer;\n}\n\noption.ezSelectButton-option:disabled {\n    color: var(--ezClockerStone);\n    font-size: 12pt;\n    font-weight: normal;\n    text-align: left;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 3px;\n    border-bottom-right-radius: 3px;\n    cursor: default;\n}\n\n/* -------------------------------------------------------------------\n| Large Tablet Screen Styles (https://yesviz.com/laptops.php)\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 1023px) {\n\n}\n*/\n\n\n/* -------------------------------------------------------------------\n| Small Tablet Screen Styles (https://yesviz.com/tablets.php)\n------------------------------------------------------------------- */\n/*\n@media screen and (max-width: 768px) {\n\n}\n*/\n\n/* -------------------------------------------------------------------\n| Phone Screen Styles  (https://yesviz.com/mobiles.php)\n------------------------------------------------------------------- */\n@media screen and (max-width: 480px) {\n\n    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    | ezDialogButton Styles\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n    button.ezDialogButton {\n        padding: 10px 18px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        border-radius: 3px;\n    }\n\n    button.ezDialogButton:hover {\n        padding: 10px 18px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezDialogButton:active {\n        padding: 10px 18px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezDialogButton:disabled {\n        padding: 10px 18px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n    }\n\n    button.ezDisabledDialogButton {\n        padding: 10px 18px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n    }\n\n    button.ezWhiteDialogButton {\n        padding: 10px 18px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        border-radius: 3px;\n    }\n\n    button.ezWhiteDialogButton:hover {\n        padding: 10px 18px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezWhiteDialogButton:hover:active,\n    button.ezWhiteDialogButton:active {\n        padding: 10px 18px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);\n    }\n\n    button.ezWhiteDialogButton:disabled {\n        padding: 10px 18px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerStone);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n    }\n\n    button.ezDisabledWhiteDialogButton {\n        padding: 10px 18px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerStone);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n        border-radius: 3px;\n    }\n}\n\n\n/* -------------------------------------------------------------------\n| Wearable Screen Style  (https://yesviz.com/watches.php)\n------------------------------------------------------------------- */\n@media screen and (max-width: 319px) {\n\n    /* ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    | ezDialogButton Styles\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ */\n    button.ezDialogButton {\n        padding: 4px 10px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        border-radius: 3px;\n    }\n\n    button.ezDialogButton:hover {\n        padding: 4px 10px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezDialogButton:active {\n        padding: 4px 10px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezDialogButton:disabled {\n        padding: 4px 10px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n    }\n\n    button.ezDisabledDialogButton {\n        padding: 4px 10px;\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n        border-radius: 3px;\n    }\n\n    button.ezWhiteDialogButton {\n        padding: 4px 10px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        border-radius: 3px;\n    }\n\n    button.ezWhiteDialogButton:hover {\n        padding: 4px 10px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n    }\n\n    button.ezWhiteDialogButton:hover:active,\n    button.ezWhiteDialogButton:active {\n        padding: 4px 10px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerBlack);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: bold;\n        box-shadow: inset 0 0 4px 2px rgba(0, 0, 0, 0.5);\n    }\n\n    button.ezWhiteDialogButton:disabled {\n        padding: 4px 10px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerStone);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n    }\n\n    button.ezDisabledWhiteDialogButton {\n        padding: 4px 10px;\n        background-color: var(--ezClockerWhite);\n        color: var(--ezClockerStone);\n        vertical-align: middle;\n        font-size: 12pt;\n        font-weight: normal;\n        border-radius: 3px;\n    }\n}\n\n.ezFullWidthButton {\n    width: 100%;\n}\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    EzClocker Tab Link Buttons\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ezTabLink-ezClockerNavy\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none (Active)\n        :hover (Inactive Hover)\n        :disabled (Inactive)\n        :active (Active Mouse Down/Click)\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ezTabLink-ezClockerNavy {\n    color: var(--ezClockerNavy);\n    font-weight: bold;\n    text-decoration: none;\n    cursor: pointer;\n    padding: 8px 16px;\n    margin-right: 8px;\n    display: inline-block;\n    border-bottom: 2px solid var(--ezClockerNavy);\n}\n\n.ezTabLink-ezClockerNavy:hover {\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.ezTabLink-ezClockerNavy:disabled {\n    color: var(--ezClockerDarkGray);\n    font-weight: normal;\n    text-decoration: none;\n    cursor: default;\n    border-bottom: 2px solid transparent;\n}\n\n.ezTabLink-ezClockerNavy:active {\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n.ezTabLink-ezClockerNavy-inactive {\n    color: var(--ezClockerDarkGray);\n    font-weight: normal;\n    text-decoration: none;\n    cursor: pointer;\n    padding: 8px 16px;\n    margin-right: 8px;\n    display: inline-block;\n    border-bottom: 2px solid transparent;\n}\n\n.ezTabLink-ezClockerNavy-inactive:hover {\n    color: var(--ezClockerNavy);\n    font-weight: normal;\n    text-decoration: none;\n    cursor: pointer;\n}\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    JQuery Button Style Overrides\n    ##########################################################################################################################################################\n*/\n\n/*\n    ===================================================================================================================\n    [Class Group]\n    JQuery Style Overrides\n    ===================================================================================================================\n*/\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-icon\n        .ui-button .ui-icon\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-icon,\n.ui-icon:enabled,\n.ui-button .ui-icon,\n.ui-button .ui-icon:enabled {\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-icon\n        .ui-button .ui-icon\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-icon:enabled:focus,\n.ui-button .ui-icon:enabled:focus {\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-icon\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-icon:enabled:hover,\n.ui-icon:enabled:focus:hover,\n.ui-button .ui-icon:enabled:hover,\n.ui-button .ui-icon:enabled:focus:hover {\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-icon\n        .ui-button .ui-icon\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    States:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-icon:enabled:active,\n.ui-icon:enabled:active:hover,\n.ui-icon:enabled:focus:active,\n.ui-icon:enabled:focus:active:hover,\n.ui-button .ui-icon:enabled:active,\n.ui-button .ui-icon:enabled:active:hover,\n.ui-button .ui-icon:enabled:focus:active,\n.ui-button .ui-icon:enabled:focus:active:hover {\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-icon\n        .ui-button .ui-icon\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-icon:disabled,\n.ui-icon:disabled:hover,\n.ui-button .ui-icon:disabled,\n.ui-button .ui-icon:disabled:hover {\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-button\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        none\n        :enabled\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button,\n.ui-button:enabled {\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    font-family: var(--ezButtons-font-family);\n    font-size: 12pt;\n    font-weight: normal;\n    text-align: center;\n    vertical-align: middle;\n    border-color: var(--ezClockerGray);\n    border-width: 1px;\n    border-style: solid;\n    border-radius: 3px;\n    box-shadow: 0 0 1px 1px transparent;\n    outline-style: none;\n    cursor: pointer;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-button\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:focus\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button:enabled:focus {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezClockerBlack);\n    box-shadow: 0 0 1px 1px transparent;\n    outline-color: var(--ezClockerGray);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-button\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :enabled:hover\n        :enabled:focus:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button:enabled:hover,\n.ui-button:enabled:focus:hover {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezClockerBlack);\n    box-shadow: 0 0 1px 1px rgba(0, 0, 0, 0.3);\n    outline-color: var(--ezClockerGray);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-button\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    States:\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button:enabled:active,\n.ui-button:enabled:active:hover,\n.ui-button:enabled:focus:active,\n.ui-button:enabled:focus:active:hover {\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    box-shadow:\n        0 0 1px 1px transparent,\n        inset 0 0 4px 2px rgba(198, 118, 0, 0.5);\n    outline-color: var(--ezClockerGray);\n    outline-width: 0;\n    outline-style: groove;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-button\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Defined states:\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button:disabled,\n.ui-button:disabled:hover {\n    background-color: var(--ezHoverOrange);\n    color: var(--ezBorderOrange);\n    border-color: var(--ezClockerOrange);\n    cursor: default;\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-state-active .ui-icon,\n        .ui-button .ui-icon,\n        .ui-button:enabled .ui-icon:enabled,\n        .ui-button:enabled:active .ui-icon:enabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    States:\n        none\n        :enabled\n        :enabled:active\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-button .ui-icon,\n.ui-button:enabled .ui-icon:enabled,\n.ui-button:enabled:active .ui-icon:enabled:active,\n.ui-state-active .ui-icon {\n    /* Using black icons only */\n    background-image: url(\"/jquery-ui/images/ui-icons_000000_256x240.png\");\n}\n\n/*\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    [Class Definition]\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    Classes:\n        .ui-dialog-titlebar-close\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n    States:\n        none\n        :enabled\n        :enabled:focus\n        :enabled:hover\n        :enabled:focus:hover\n        :enabled:active\n        :enabled:active:hover\n        :enabled:focus:active\n        :enabled:focus:active:hover\n        :disabled\n        :disabled:hover\n    ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~\n*/\n.ui-dialog-titlebar-close,\n.ui-dialog-titlebar-close:enabled,\n.ui-dialog-titlebar-close:enabled:focus,\n.ui-dialog-titlebar-close:enabled:hover,\n.ui-dialog-titlebar-close:enabled:focus:hover,\n.ui-dialog-titlebar-close:enabled:active,\n.ui-dialog-titlebar-close:enabled:active:hover,\n.ui-dialog-titlebar-close:enabled:focus:active,\n.ui-dialog-titlebar-close:enabled:focus:active:hover,\n.ui-dialog-titlebar-close:disabled,\n.ui-dialog-titlebar-close:disabled:hover {\n    /* Hide all JQuery UI dialog's top right X butons */\n    display: none\n}\n\n/*\n    ##########################################################################################################################################################\n    [Class Section]\n    DEPRECATED STYLES\n    DO NOT USE CLASS IN THIS SECTION\n    ##########################################################################################################################################################\n*/\n\n/* @DEPRECATED: a.navButton */\na.navButton {\n    font-size: medium;\n    font-weight: normal;\n    margin: 2px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: var(--ezActionGreenBorderColor);\n    background-color: #8ef13c;\n    color: var(--ezClockerBlack);\n    cursor: pointer;\n    padding: 4px 8px;\n    border-radius: 3px;\n}\n\n/* @DEPRECATED: a.navButton */\na.navButton:hover:enabled {\n    /* DEPRECATED: DO NOT USE */\n    border-top-color: var(--ezActionGreenHoverColor);\n    border-left-color: var(--ezActionGreenHoverColor);\n    border-bottom-color: #66cc99;\n    border-right-color: #66cc99;\n    background-color: #a9f16c;\n}\n\n/* @DEPRECATED: a.navButton */\na.navButton:hover:active {\n    border-top-color: #66cc99;\n    border-left-color: #66cc99;\n    border-bottom-color: var(--ezActionGreenHoverColor);\n    border-right-color: var(--ezActionGreenHoverColor);\n    color: #a9f16c;\n    background-color: var(--ezActionGreenBorderColor);\n}\n\n/* @DEPRECATED: a.toolButton */\na.toolButton {\n    font-size: small;\n    font-weight: normal;\n    margin: 2px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #996600;\n    background-color: var(--ezClockerOrange);\n    color: var(--ezClockerBlack);\n    cursor: pointer;\n    padding: 2px 4px;\n    border-radius: 3px;\n}\n\n/* @DEPRECATED: a.toolButton */\na.toolButton:hover:enabled {\n    border-top-color: #ffee00;\n    border-left-color: #ffee00;\n    border-bottom-color: #ff9933;\n    border-right-color: #ff9933;\n    background-color: #ffcc66;\n}\n\n/* @DEPRECATED: a.toolButton */\na.toolButton:hover:active {\n    border-top-color: #ff9933;\n    border-left-color: #ff9933;\n    border-bottom-color: #ffee00;\n    border-right-color: #ffee00;\n    background-color: #ffcc66;\n}\n\n/* @DEPRECATED: a.disabledToolButton */\na.disabledToolButton {\n    font-size: small;\n    font-weight: normal;\n    margin: 2px;\n    border-style: solid;\n    border-width: 1px;\n    border-color: #808080;\n    background-color: var(--ezClockerStone);\n    color: #808080;\n    cursor: default;\n    padding: 2px 4px;\n    border-radius: 3px;\n}\n\n/* @DEPRECATED: .buttonText */\n.buttonText {\n    font-size: 12pt;\n    font-family: verdana, sans-serif;\n    font-weight: normal;\n}\n\n/* @DEPRECATED: .headerButtonText */\n.headerButtonText {\n    font-size: 12pt;\n    font-family: verdana, sans-serif;\n    font-weight: bold;\n}\n\n/* @DEPRECATED: button.ezNoButtonMargin */\nbutton.ezNoButtonMargin {\n    margin: 0;\n}\n\n/* @DEPRECATED: button.fullWidth */\nbutton.fullWidth {\n    width: 100%;\n}\n\n/* @DEPRECATED: button.paddButton10 */\nbutton.paddButton10 {\n    margin-left: 10px;\n}\n\n\nbutton.ezToolButtonWhite,\nbutton.ezToolButtonWhite:active,\nbutton.ezToolButtonWhite:enabled button.ezToolButtonWhite:focus,\nbutton.ezToolButtonWhite:enabled:focus,\nbutton.ezToolButtonWhite:hover:enabled {\n    background-color: var(--ezClockerWhite);\n    padding: 2px;\n    margin: 1px;\n    min-width: 28px;\n    min-height: 28px;\n    max-height: 28px;\n    opacity: 1;\n    color: var(--ezNavyContainerTextColor);\n    font-size: 10pt;\n    vertical-align: middle;\n    text-align: center;\n    border-color: var(--ezBorderNavy);\n    border-style: solid;\n    border-width: 1px;\n    border-radius: 3px;\n    outline-style: none;\n    box-shadow: unset;\n    cursor: pointer;\n}\n\nbutton.ezAddTimeButton {\n    font-weight: bold;\n    background-color: #ffc500;\n    border-color: #6d6e70;\n    border-style: solid;\n    border-width: 1px;\n    color: #000000;\n    height: 45px;\n    width: 130px;\n}\n\n/* @DEPRECATED: paper-button.ez-navigation-button */\npaper-button.ez-navigation-button {\n    font-family: var(--ezFontFamily);\n    max-height: var(--ezNavButtonMaxHeight);\n    max-width: var(--ezNavButtonMaxWidth);\n    min-width: var(--ezNavButtonMinWidth);\n    font-size: var(--ezNavButtonFontSize);\n    font-weight: var(--ezNavButtonFontWeight);\n    background-color: var(--ezNavButtonColor);\n    color: var(--ezNavButtonTextColor);\n    text-transform: var(--ezNavButtonTextTransform);\n}\n\n/* @DEPRECATED: paper-button.ez-navigation-button */\npaper-button.ez-navigation-button>paper-ripple {\n    color: var(--ezWhite);\n}\n\n/* @DEPRECATED: paper-button.ez-navigation-button */\npaper-button.ez-navigation-button:hover:enabled {\n    background-color: var(--ezNavButtonColorHover);\n    box-shadow:\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\n        0 3px 1px -2px rgba(0, 0, 0, 0.2);\n}\n\n/* @DEPRECATED: ez-signout-button */\npaper-button.ez-signout-button {\n    text-transform: var(--ezSignOutButtonTextTransform);\n    max-height: var(--ezSignOutButtonMaxHeight);\n    max-width: var(--ezSignOutButtonMaxWidth);\n    min-width: var(--ezSignOutButtonMinWidth);\n    font-size: var(--ezSignOutButtonFontSize);\n    font-weight: var(--ezSignOutButtonFontWeight);\n    background-color: var(--ezSignOutButtonColor);\n    color: var(--ezSignOutButtonTextColor);\n}\n\n/* @DEPRECATED: ez-signout-button */\npaper-button.ez-signout-button>paper-ripple {\n    color: var(--ezWhite);\n}\n\n/* @DEPRECATED: ez-signout-button */\npaper-button.ez-signout-button:hover:enabled {\n    background-color: var(--ezSignOutButtonHoverColor);\n    box-shadow:\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\n        0 3px 1px -2px rgba(0, 0, 0, 0.20);\n}\n\n/* @DEPRECATED: paper-button.ez-select-plan-button */\npaper-button.ez-select-plan-button {\n    max-width: var(--ezSelectPlanButtonMaxWidth);\n    min-width: var(--ezSelectPlanButtonMinWidth);\n    max-height: var(--ezSelectPlanBtnMaxHeight);\n    font-size: var(--ezSelectPlanBtnFontSize);\n    font-weight: var(ezSelectPlanBtnFontWeight);\n    background-color: var(--ezSelectPlanBtnColor);\n    color: var(--ezSelectPlanBtnTextColor);\n    text-transform: var(--ezSelectPlanTextTransform);\n}\n\n/* @DEPRECATED: paper-button.ez-select-plan-button */\npaper-button.ez-select-plan-button>paper-ripple {\n    color: var(--ezBorderGreen);\n}\n\n/* @DEPRECATED: paper-button.ez-select-plan-button */\npaper-button.ez-select-plan-button:hover:enabled {\n    background-color: var(--ezSelectPlanBtnHoverColor);\n    box-shadow:\n        0 2px 2px 0 rgba(0, 0, 0, 0.14),\n        0 1px 5px 0 rgba(0, 0, 0, 0.12),\n        0 3px 1px -2px rgba(0, 0, 0, 0.20);\n}\n\n/*\n    ##########################################################################################################################################################\n    END OF DEPRECATED CLASS SECTION\n    ##########################################################################################################################################################\n*/"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
